// Marzipano - a 360° media viewer for the modern web (v0.7.2)
//
// Copyright 2016 Google Inc. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
! function (t) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
    else if ("function" == typeof define && define.amd) define([], t);
    else {
        var e;
        e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, e.Marzipano = t()
    }
}(function () {
    var t;
    return function () {
        function t(e, i, r) {
            function n(s, a) {
                if (!i[s]) {
                    if (!e[s]) {
                        var l = "function" == typeof require && require;
                        if (!a && l) return l(s, !0);
                        if (o) return o(s, !0);
                        var h = new Error("Cannot find module '" + s + "'");
                        throw h.code = "MODULE_NOT_FOUND", h
                    }
                    var u = i[s] = {
                        exports: {}
                    };
                    e[s][0].call(u.exports, function (t) {
                        return n(e[s][1][t] || t)
                    }, u, u.exports, t, e, i, r)
                }
                return i[s].exports
            }
            for (var o = "function" == typeof require && require, s = 0; s < r.length; s++) n(r[s]);
            return n
        }
        return t
    }()({
        1: [function (e, i, r) {
            ! function (e, r, n) {
                void 0 !== i && i.exports ? i.exports = n() : "function" == typeof t && t.amd ? t("bowser", n) : e.bowser = n()
            }(this, 0, function () {
                function t(t) {
                    function e(e) {
                        var i = t.match(e);
                        return i && i.length > 1 && i[1] || ""
                    }

                    function i(e) {
                        var i = t.match(e);
                        return i && i.length > 1 && i[2] || ""
                    }
                    var n, o = e(/(ipod|iphone|ipad)/i).toLowerCase(),
                        a = /like android/i.test(t),
                        l = !a && /android/i.test(t),
                        h = /nexus\s*[0-6]\s*/i.test(t),
                        u = !h && /nexus\s*[0-9]+/i.test(t),
                        c = /CrOS/.test(t),
                        p = /silk/i.test(t),
                        d = /sailfish/i.test(t),
                        f = /tizen/i.test(t),
                        m = /(web|hpw)(o|0)s/i.test(t),
                        v = /windows phone/i.test(t),
                        _ = (/SamsungBrowser/i.test(t), !v && /windows/i.test(t)),
                        y = !o && !p && /macintosh/i.test(t),
                        g = !l && !d && !f && !m && /linux/i.test(t),
                        x = i(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
                        M = e(/version\/(\d+(\.\d+)?)/i),
                        w = /tablet/i.test(t) && !/tablet pc/i.test(t),
                        b = !w && /[^-]mobi/i.test(t),
                        S = /xbox/i.test(t);
                    /opera/i.test(t) ? n = {
                        name: "Opera",
                        opera: s,
                        version: M || e(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
                    } : /opr\/|opios/i.test(t) ? n = {
                        name: "Opera",
                        opera: s,
                        version: e(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || M
                    } : /SamsungBrowser/i.test(t) ? n = {
                        name: "Samsung Internet for Android",
                        samsungBrowser: s,
                        version: M || e(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
                    } : /Whale/i.test(t) ? n = {
                        name: "NAVER Whale browser",
                        whale: s,
                        version: e(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /MZBrowser/i.test(t) ? n = {
                        name: "MZ Browser",
                        mzbrowser: s,
                        version: e(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /coast/i.test(t) ? n = {
                        name: "Opera Coast",
                        coast: s,
                        version: M || e(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
                    } : /focus/i.test(t) ? n = {
                        name: "Focus",
                        focus: s,
                        version: e(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /yabrowser/i.test(t) ? n = {
                        name: "Yandex Browser",
                        yandexbrowser: s,
                        version: M || e(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
                    } : /ucbrowser/i.test(t) ? n = {
                        name: "UC Browser",
                        ucbrowser: s,
                        version: e(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /mxios/i.test(t) ? n = {
                        name: "Maxthon",
                        maxthon: s,
                        version: e(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /epiphany/i.test(t) ? n = {
                        name: "Epiphany",
                        epiphany: s,
                        version: e(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /puffin/i.test(t) ? n = {
                        name: "Puffin",
                        puffin: s,
                        version: e(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
                    } : /sleipnir/i.test(t) ? n = {
                        name: "Sleipnir",
                        sleipnir: s,
                        version: e(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
                    } : /k-meleon/i.test(t) ? n = {
                        name: "K-Meleon",
                        kMeleon: s,
                        version: e(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
                    } : v ? (n = {
                        name: "Windows Phone",
                        osname: "Windows Phone",
                        windowsphone: s
                    }, x ? (n.msedge = s, n.version = x) : (n.msie = s, n.version = e(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? n = {
                        name: "Internet Explorer",
                        msie: s,
                        version: e(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                    } : c ? n = {
                        name: "Chrome",
                        osname: "Chrome OS",
                        chromeos: s,
                        chromeBook: s,
                        chrome: s,
                        version: e(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                    } : /edg([ea]|ios)/i.test(t) ? n = {
                        name: "Microsoft Edge",
                        msedge: s,
                        version: x
                    } : /vivaldi/i.test(t) ? n = {
                        name: "Vivaldi",
                        vivaldi: s,
                        version: e(/vivaldi\/(\d+(\.\d+)?)/i) || M
                    } : d ? n = {
                        name: "Sailfish",
                        osname: "Sailfish OS",
                        sailfish: s,
                        version: e(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
                    } : /seamonkey\//i.test(t) ? n = {
                        name: "SeaMonkey",
                        seamonkey: s,
                        version: e(/seamonkey\/(\d+(\.\d+)?)/i)
                    } : /firefox|iceweasel|fxios/i.test(t) ? (n = {
                        name: "Firefox",
                        firefox: s,
                        version: e(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
                    }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (n.firefoxos = s, n.osname = "Firefox OS")) : p ? n = {
                        name: "Amazon Silk",
                        silk: s,
                        version: e(/silk\/(\d+(\.\d+)?)/i)
                    } : /phantom/i.test(t) ? n = {
                        name: "PhantomJS",
                        phantom: s,
                        version: e(/phantomjs\/(\d+(\.\d+)?)/i)
                    } : /slimerjs/i.test(t) ? n = {
                        name: "SlimerJS",
                        slimer: s,
                        version: e(/slimerjs\/(\d+(\.\d+)?)/i)
                    } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? n = {
                        name: "BlackBerry",
                        osname: "BlackBerry OS",
                        blackberry: s,
                        version: M || e(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
                    } : m ? (n = {
                        name: "WebOS",
                        osname: "WebOS",
                        webos: s,
                        version: M || e(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
                    }, /touchpad\//i.test(t) && (n.touchpad = s)) : /bada/i.test(t) ? n = {
                        name: "Bada",
                        osname: "Bada",
                        bada: s,
                        version: e(/dolfin\/(\d+(\.\d+)?)/i)
                    } : f ? n = {
                        name: "Tizen",
                        osname: "Tizen",
                        tizen: s,
                        version: e(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || M
                    } : /qupzilla/i.test(t) ? n = {
                        name: "QupZilla",
                        qupzilla: s,
                        version: e(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || M
                    } : /chromium/i.test(t) ? n = {
                        name: "Chromium",
                        chromium: s,
                        version: e(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || M
                    } : /chrome|crios|crmo/i.test(t) ? n = {
                        name: "Chrome",
                        chrome: s,
                        version: e(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                    } : l ? n = {
                        name: "Android",
                        version: M
                    } : /safari|applewebkit/i.test(t) ? (n = {
                        name: "Safari",
                        safari: s
                    }, M && (n.version = M)) : o ? (n = {
                        name: "iphone" == o ? "iPhone" : "ipad" == o ? "iPad" : "iPod"
                    }, M && (n.version = M)) : n = /googlebot/i.test(t) ? {
                        name: "Googlebot",
                        googlebot: s,
                        version: e(/googlebot\/(\d+(\.\d+))/i) || M
                    } : {
                        name: e(/^(.*)\/(.*) /),
                        version: i(/^(.*)\/(.*) /)
                    }, !n.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (n.name = n.name || "Blink", n.blink = s) : (n.name = n.name || "Webkit", n.webkit = s), !n.version && M && (n.version = M)) : !n.opera && /gecko\//i.test(t) && (n.name = n.name || "Gecko", n.gecko = s, n.version = n.version || e(/gecko\/(\d+(\.\d+)?)/i)), n.windowsphone || !l && !n.silk ? !n.windowsphone && o ? (n[o] = s, n.ios = s, n.osname = "iOS") : y ? (n.mac = s, n.osname = "macOS") : S ? (n.xbox = s, n.osname = "Xbox") : _ ? (n.windows = s, n.osname = "Windows") : g && (n.linux = s, n.osname = "Linux") : (n.android = s, n.osname = "Android");
                    var E = "";
                    n.windows ? E = function (t) {
                        switch (t) {
                            case "NT":
                                return "NT";
                            case "XP":
                                return "XP";
                            case "NT 5.0":
                                return "2000";
                            case "NT 5.1":
                                return "XP";
                            case "NT 5.2":
                                return "2003";
                            case "NT 6.0":
                                return "Vista";
                            case "NT 6.1":
                                return "7";
                            case "NT 6.2":
                                return "8";
                            case "NT 6.3":
                                return "8.1";
                            case "NT 10.0":
                                return "10";
                            default:
                                return undefined
                        }
                    }(e(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : n.windowsphone ? E = e(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : n.mac ? (E = e(/Mac OS X (\d+([_\.\s]\d+)*)/i), E = E.replace(/[_\s]/g, ".")) : o ? (E = e(/os (\d+([_\s]\d+)*) like mac os x/i), E = E.replace(/[_\s]/g, ".")) : l ? E = e(/android[ \/-](\d+(\.\d+)*)/i) : n.webos ? E = e(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : n.blackberry ? E = e(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : n.bada ? E = e(/bada\/(\d+(\.\d+)*)/i) : n.tizen && (E = e(/tizen[\/\s](\d+(\.\d+)*)/i)), E && (n.osversion = E);
                    var I = !n.windows && E.split(".")[0];
                    return w || u || "ipad" == o || l && (3 == I || I >= 4 && !b) || n.silk ? n.tablet = s : (b || "iphone" == o || "ipod" == o || l || h || n.blackberry || n.webos || n.bada) && (n.mobile = s), n.msedge || n.msie && n.version >= 10 || n.yandexbrowser && n.version >= 15 || n.vivaldi && n.version >= 1 || n.chrome && n.version >= 20 || n.samsungBrowser && n.version >= 4 || n.whale && 1 === r([n.version, "1.0"]) || n.mzbrowser && 1 === r([n.version, "6.0"]) || n.focus && 1 === r([n.version, "1.0"]) || n.firefox && n.version >= 20 || n.safari && n.version >= 6 || n.opera && n.version >= 10 || n.ios && n.osversion && n.osversion.split(".")[0] >= 6 || n.blackberry && n.version >= 10.1 || n.chromium && n.version >= 20 ? n.a = s : n.msie && n.version < 10 || n.chrome && n.version < 20 || n.firefox && n.version < 20 || n.safari && n.version < 6 || n.opera && n.version < 10 || n.ios && n.osversion && n.osversion.split(".")[0] < 6 || n.chromium && n.version < 20 ? n.c = s : n.x = s, n
                }

                function e(t) {
                    return t.split(".").length
                }

                function i(t, e) {
                    var i, r = [];
                    if (Array.prototype.map) return Array.prototype.map.call(t, e);
                    for (i = 0; i < t.length; i++) r.push(e(t[i]));
                    return r
                }

                function r(t) {
                    for (var r = Math.max(e(t[0]), e(t[1])), n = i(t, function (t) {
                            var n = r - e(t);
                            return t += new Array(n + 1).join(".0"), i(t.split("."), function (t) {
                                return new Array(20 - t.length).join("0") + t
                            }).reverse()
                        }); --r >= 0;) {
                        if (n[0][r] > n[1][r]) return 1;
                        if (n[0][r] !== n[1][r]) return -1;
                        if (0 === r) return 0
                    }
                }

                function n(e, i, n) {
                    var o = a;
                    "string" == typeof i && (n = i, i = void 0), void 0 === i && (i = !1), n && (o = t(n));
                    var s = "" + o.version;
                    for (var l in e)
                        if (e.hasOwnProperty(l) && o[l]) {
                            if ("string" != typeof e[l]) throw new Error("Browser version in the minVersion map should be a string: " + l + ": " + String(e));
                            return r([s, e[l]]) < 0
                        }
                    return i
                }

                function o(t, e, i) {
                    return !n(t, e, i)
                }
                var s = !0,
                    a = t("undefined" != typeof navigator ? navigator.userAgent || "" : "");
                return a.test = function (t) {
                    for (var e = 0; e < t.length; ++e) {
                        var i = t[e];
                        if ("string" == typeof i && i in a) return !0
                    }
                    return !1
                }, a.isUnsupportedBrowser = n, a.compareVersions = r, a.check = o, a._detect = t, a.detect = t, a
            })
        }, {}],
        2: [function (t, e, i) {
            i.glMatrix = t("./gl-matrix/common.js"), i.mat2 = t("./gl-matrix/mat2.js"), i.mat2d = t("./gl-matrix/mat2d.js"), i.mat3 = t("./gl-matrix/mat3.js"), i.mat4 = t("./gl-matrix/mat4.js"), i.quat = t("./gl-matrix/quat.js"), i.vec2 = t("./gl-matrix/vec2.js"), i.vec3 = t("./gl-matrix/vec3.js"), i.vec4 = t("./gl-matrix/vec4.js")
        }, {
            "./gl-matrix/common.js": 3,
            "./gl-matrix/mat2.js": 4,
            "./gl-matrix/mat2d.js": 5,
            "./gl-matrix/mat3.js": 6,
            "./gl-matrix/mat4.js": 7,
            "./gl-matrix/quat.js": 8,
            "./gl-matrix/vec2.js": 9,
            "./gl-matrix/vec3.js": 10,
            "./gl-matrix/vec4.js": 11
        }],
        3: [function (t, e, i) {
            var r = {};
            r.EPSILON = 1e-6, r.ARRAY_TYPE = "undefined" != typeof Float32Array ? Float32Array : Array, r.RANDOM = Math.random, r.ENABLE_SIMD = !1, r.SIMD_AVAILABLE = r.ARRAY_TYPE === this.Float32Array && "undefined" != typeof SIMD, r.USE_SIMD = r.ENABLE_SIMD && r.SIMD_AVAILABLE, r.setMatrixArrayType = function (t) {
                r.ARRAY_TYPE = t
            };
            var n = Math.PI / 180;
            r.toRadian = function (t) {
                return t * n
            }, r.equals = function (t, e) {
                return Math.abs(t - e) <= r.EPSILON * Math.max(1, Math.abs(t), Math.abs(e))
            }, e.exports = r
        }, {}],
        4: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(4);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(4);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t
            }, n.identity = function (t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t
            }, n.fromValues = function (t, e, i, n) {
                var o = new r.ARRAY_TYPE(4);
                return o[0] = t, o[1] = e, o[2] = i, o[3] = n, o
            }, n.set = function (t, e, i, r, n) {
                return t[0] = e, t[1] = i, t[2] = r, t[3] = n, t
            }, n.transpose = function (t, e) {
                if (t === e) {
                    var i = e[1];
                    t[1] = e[2], t[2] = i
                } else t[0] = e[0], t[1] = e[2], t[2] = e[1], t[3] = e[3];
                return t
            }, n.invert = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = i * o - n * r;
                return s ? (s = 1 / s, t[0] = o * s, t[1] = -r * s, t[2] = -n * s, t[3] = i * s, t) : null
            }, n.adjoint = function (t, e) {
                var i = e[0];
                return t[0] = e[3], t[1] = -e[1], t[2] = -e[2], t[3] = i, t
            }, n.determinant = function (t) {
                return t[0] * t[3] - t[2] * t[1]
            }, n.multiply = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = i[0],
                    l = i[1],
                    h = i[2],
                    u = i[3];
                return t[0] = r * a + o * l, t[1] = n * a + s * l, t[2] = r * h + o * u, t[3] = n * h + s * u, t
            }, n.mul = n.multiply, n.rotate = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = Math.sin(i),
                    l = Math.cos(i);
                return t[0] = r * l + o * a, t[1] = n * l + s * a, t[2] = r * -a + o * l, t[3] = n * -a + s * l, t
            }, n.scale = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = i[0],
                    l = i[1];
                return t[0] = r * a, t[1] = n * a, t[2] = o * l, t[3] = s * l, t
            }, n.fromRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = r, t[1] = i, t[2] = -i, t[3] = r, t
            }, n.fromScaling = function (t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = e[1], t
            }, n.str = function (t) {
                return "mat2(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")"
            }, n.frob = function (t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2))
            }, n.LDU = function (t, e, i, r) {
                return t[2] = r[2] / r[0], i[0] = r[0], i[1] = r[1], i[3] = r[3] - t[2] * i[1], [t, e, i]
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t[3] = e[3] + i[3], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t[3] = e[3] - i[3], t
            }, n.sub = n.subtract, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = t[3],
                    a = e[0],
                    l = e[1],
                    h = e[2],
                    u = e[3];
                return Math.abs(i - a) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(n - l) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - h) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(h)) && Math.abs(s - u) <= r.EPSILON * Math.max(1, Math.abs(s), Math.abs(u))
            }, n.multiplyScalar = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t[3] = e[3] * i, t
            }, n.multiplyScalarAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t[3] = e[3] + i[3] * r, t
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        5: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(6);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(6);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t
            }, n.identity = function (t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = 0, t[5] = 0, t
            }, n.fromValues = function (t, e, i, n, o, s) {
                var a = new r.ARRAY_TYPE(6);
                return a[0] = t, a[1] = e, a[2] = i, a[3] = n, a[4] = o, a[5] = s, a
            }, n.set = function (t, e, i, r, n, o, s) {
                return t[0] = e, t[1] = i, t[2] = r, t[3] = n, t[4] = o, t[5] = s, t
            }, n.invert = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = i * o - r * n;
                return l ? (l = 1 / l, t[0] = o * l, t[1] = -r * l, t[2] = -n * l, t[3] = i * l, t[4] = (n * a - o * s) * l, t[5] = (r * s - i * a) * l, t) : null
            }, n.determinant = function (t) {
                return t[0] * t[3] - t[1] * t[2]
            }, n.multiply = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = i[0],
                    u = i[1],
                    c = i[2],
                    p = i[3],
                    d = i[4],
                    f = i[5];
                return t[0] = r * h + o * u, t[1] = n * h + s * u, t[2] = r * c + o * p, t[3] = n * c + s * p, t[4] = r * d + o * f + a, t[5] = n * d + s * f + l, t
            }, n.mul = n.multiply, n.rotate = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = Math.sin(i),
                    u = Math.cos(i);
                return t[0] = r * u + o * h, t[1] = n * u + s * h, t[2] = r * -h + o * u, t[3] = n * -h + s * u, t[4] = a, t[5] = l, t
            }, n.scale = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = i[0],
                    u = i[1];
                return t[0] = r * h, t[1] = n * h, t[2] = o * u, t[3] = s * u, t[4] = a, t[5] = l, t
            }, n.translate = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = i[0],
                    u = i[1];
                return t[0] = r, t[1] = n, t[2] = o, t[3] = s, t[4] = r * h + o * u + a, t[5] = n * h + s * u + l, t
            }, n.fromRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = r, t[1] = i, t[2] = -i, t[3] = r, t[4] = 0, t[5] = 0, t
            }, n.fromScaling = function (t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = e[1], t[4] = 0, t[5] = 0, t
            }, n.fromTranslation = function (t, e) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 1, t[4] = e[0], t[5] = e[1], t
            }, n.str = function (t) {
                return "mat2d(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ")"
            }, n.frob = function (t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2) + Math.pow(t[4], 2) + Math.pow(t[5], 2) + 1)
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t[3] = e[3] + i[3], t[4] = e[4] + i[4], t[5] = e[5] + i[5], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t[3] = e[3] - i[3], t[4] = e[4] - i[4], t[5] = e[5] - i[5], t
            }, n.sub = n.subtract, n.multiplyScalar = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t[3] = e[3] * i, t[4] = e[4] * i, t[5] = e[5] * i, t
            }, n.multiplyScalarAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t[3] = e[3] + i[3] * r, t[4] = e[4] + i[4] * r, t[5] = e[5] + i[5] * r, t
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = t[3],
                    a = t[4],
                    l = t[5],
                    h = e[0],
                    u = e[1],
                    c = e[2],
                    p = e[3],
                    d = e[4],
                    f = e[5];
                return Math.abs(i - h) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(h)) && Math.abs(n - u) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(u)) && Math.abs(o - c) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(c)) && Math.abs(s - p) <= r.EPSILON * Math.max(1, Math.abs(s), Math.abs(p)) && Math.abs(a - d) <= r.EPSILON * Math.max(1, Math.abs(a), Math.abs(d)) && Math.abs(l - f) <= r.EPSILON * Math.max(1, Math.abs(l), Math.abs(f))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        6: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(9);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t
            }, n.fromMat4 = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[4], t[4] = e[5], t[5] = e[6], t[6] = e[8], t[7] = e[9], t[8] = e[10], t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(9);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t
            }, n.fromValues = function (t, e, i, n, o, s, a, l, h) {
                var u = new r.ARRAY_TYPE(9);
                return u[0] = t, u[1] = e, u[2] = i, u[3] = n, u[4] = o, u[5] = s, u[6] = a, u[7] = l, u[8] = h, u
            }, n.set = function (t, e, i, r, n, o, s, a, l, h) {
                return t[0] = e, t[1] = i, t[2] = r, t[3] = n, t[4] = o, t[5] = s, t[6] = a, t[7] = l, t[8] = h, t
            }, n.identity = function (t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t
            }, n.transpose = function (t, e) {
                if (t === e) {
                    var i = e[1],
                        r = e[2],
                        n = e[5];
                    t[1] = e[3], t[2] = e[6], t[3] = i, t[5] = e[7], t[6] = r, t[7] = n
                } else t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8];
                return t
            }, n.invert = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = e[6],
                    h = e[7],
                    u = e[8],
                    c = u * s - a * h,
                    p = -u * o + a * l,
                    d = h * o - s * l,
                    f = i * c + r * p + n * d;
                return f ? (f = 1 / f, t[0] = c * f, t[1] = (-u * r + n * h) * f, t[2] = (a * r - n * s) * f, t[3] = p * f, t[4] = (u * i - n * l) * f, t[5] = (-a * i + n * o) * f, t[6] = d * f, t[7] = (-h * i + r * l) * f, t[8] = (s * i - r * o) * f, t) : null
            }, n.adjoint = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = e[6],
                    h = e[7],
                    u = e[8];
                return t[0] = s * u - a * h, t[1] = n * h - r * u, t[2] = r * a - n * s, t[3] = a * l - o * u, t[4] = i * u - n * l, t[5] = n * o - i * a, t[6] = o * h - s * l, t[7] = r * l - i * h, t[8] = i * s - r * o, t
            }, n.determinant = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2],
                    n = t[3],
                    o = t[4],
                    s = t[5],
                    a = t[6],
                    l = t[7],
                    h = t[8];
                return e * (h * o - s * l) + i * (-h * n + s * a) + r * (l * n - o * a)
            }, n.multiply = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = e[6],
                    u = e[7],
                    c = e[8],
                    p = i[0],
                    d = i[1],
                    f = i[2],
                    m = i[3],
                    v = i[4],
                    _ = i[5],
                    y = i[6],
                    g = i[7],
                    x = i[8];
                return t[0] = p * r + d * s + f * h, t[1] = p * n + d * a + f * u, t[2] = p * o + d * l + f * c, t[3] = m * r + v * s + _ * h, t[4] = m * n + v * a + _ * u, t[5] = m * o + v * l + _ * c, t[6] = y * r + g * s + x * h, t[7] = y * n + g * a + x * u, t[8] = y * o + g * l + x * c, t
            }, n.mul = n.multiply, n.translate = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = e[6],
                    u = e[7],
                    c = e[8],
                    p = i[0],
                    d = i[1];
                return t[0] = r, t[1] = n, t[2] = o, t[3] = s, t[4] = a, t[5] = l, t[6] = p * r + d * s + h, t[7] = p * n + d * a + u, t[8] = p * o + d * l + c, t
            }, n.rotate = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = e[6],
                    u = e[7],
                    c = e[8],
                    p = Math.sin(i),
                    d = Math.cos(i);
                return t[0] = d * r + p * s, t[1] = d * n + p * a, t[2] = d * o + p * l, t[3] = d * s - p * r, t[4] = d * a - p * n, t[5] = d * l - p * o, t[6] = h, t[7] = u, t[8] = c, t
            }, n.scale = function (t, e, i) {
                var r = i[0],
                    n = i[1];
                return t[0] = r * e[0], t[1] = r * e[1], t[2] = r * e[2], t[3] = n * e[3], t[4] = n * e[4], t[5] = n * e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t
            }, n.fromTranslation = function (t, e) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = e[0], t[7] = e[1], t[8] = 1, t
            }, n.fromRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = r, t[1] = i, t[2] = 0, t[3] = -i, t[4] = r, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t
            }, n.fromScaling = function (t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = e[1], t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t
            }, n.fromMat2d = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = 0, t[3] = e[2], t[4] = e[3], t[5] = 0, t[6] = e[4], t[7] = e[5], t[8] = 1, t
            }, n.fromQuat = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = i + i,
                    a = r + r,
                    l = n + n,
                    h = i * s,
                    u = r * s,
                    c = r * a,
                    p = n * s,
                    d = n * a,
                    f = n * l,
                    m = o * s,
                    v = o * a,
                    _ = o * l;
                return t[0] = 1 - c - f, t[3] = u - _, t[6] = p + v, t[1] = u + _, t[4] = 1 - h - f, t[7] = d - m, t[2] = p - v, t[5] = d + m, t[8] = 1 - h - c, t
            }, n.normalFromMat4 = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = e[6],
                    h = e[7],
                    u = e[8],
                    c = e[9],
                    p = e[10],
                    d = e[11],
                    f = e[12],
                    m = e[13],
                    v = e[14],
                    _ = e[15],
                    y = i * a - r * s,
                    g = i * l - n * s,
                    x = i * h - o * s,
                    M = r * l - n * a,
                    w = r * h - o * a,
                    b = n * h - o * l,
                    S = u * m - c * f,
                    E = u * v - p * f,
                    I = u * _ - d * f,
                    D = c * v - p * m,
                    T = c * _ - d * m,
                    F = p * _ - d * v,
                    L = y * F - g * T + x * D + M * I - w * E + b * S;
                return L ? (L = 1 / L, t[0] = (a * F - l * T + h * D) * L, t[1] = (l * I - s * F - h * E) * L, t[2] = (s * T - a * I + h * S) * L, t[3] = (n * T - r * F - o * D) * L, t[4] = (i * F - n * I + o * E) * L, t[5] = (r * I - i * T - o * S) * L, t[6] = (m * b - v * w + _ * M) * L, t[7] = (v * x - f * b - _ * g) * L, t[8] = (f * w - m * x + _ * y) * L, t) : null
            }, n.str = function (t) {
                return "mat3(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ")"
            }, n.frob = function (t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2) + Math.pow(t[4], 2) + Math.pow(t[5], 2) + Math.pow(t[6], 2) + Math.pow(t[7], 2) + Math.pow(t[8], 2))
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t[3] = e[3] + i[3], t[4] = e[4] + i[4], t[5] = e[5] + i[5], t[6] = e[6] + i[6], t[7] = e[7] + i[7], t[8] = e[8] + i[8], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t[3] = e[3] - i[3], t[4] = e[4] - i[4], t[5] = e[5] - i[5], t[6] = e[6] - i[6], t[7] = e[7] - i[7], t[8] = e[8] - i[8], t
            }, n.sub = n.subtract, n.multiplyScalar = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t[3] = e[3] * i, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * i, t
            }, n.multiplyScalarAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t[3] = e[3] + i[3] * r, t[4] = e[4] + i[4] * r, t[5] = e[5] + i[5] * r, t[6] = e[6] + i[6] * r, t[7] = e[7] + i[7] * r, t[8] = e[8] + i[8] * r, t
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = t[3],
                    a = t[4],
                    l = t[5],
                    h = t[6],
                    u = t[7],
                    c = t[8],
                    p = e[0],
                    d = e[1],
                    f = e[2],
                    m = e[3],
                    v = e[4],
                    _ = e[5],
                    y = e[6],
                    g = e[7],
                    x = e[8];
                return Math.abs(i - p) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(p)) && Math.abs(n - d) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(d)) && Math.abs(o - f) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(s - m) <= r.EPSILON * Math.max(1, Math.abs(s), Math.abs(m)) && Math.abs(a - v) <= r.EPSILON * Math.max(1, Math.abs(a), Math.abs(v)) && Math.abs(l - _) <= r.EPSILON * Math.max(1, Math.abs(l), Math.abs(_)) && Math.abs(h - y) <= r.EPSILON * Math.max(1, Math.abs(h), Math.abs(y)) && Math.abs(u - g) <= r.EPSILON * Math.max(1, Math.abs(u), Math.abs(g)) && Math.abs(c - x) <= r.EPSILON * Math.max(1, Math.abs(c), Math.abs(x))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        7: [function (t, e, i) {
            var r = t("./common.js"),
                n = {
                    scalar: {},
                    SIMD: {}
                };
            n.create = function () {
                var t = new r.ARRAY_TYPE(16);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(16);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t
            }, n.fromValues = function (t, e, i, n, o, s, a, l, h, u, c, p, d, f, m, v) {
                var _ = new r.ARRAY_TYPE(16);
                return _[0] = t, _[1] = e, _[2] = i, _[3] = n, _[4] = o, _[5] = s, _[6] = a, _[7] = l, _[8] = h, _[9] = u, _[10] = c, _[11] = p, _[12] = d, _[13] = f, _[14] = m, _[15] = v, _
            }, n.set = function (t, e, i, r, n, o, s, a, l, h, u, c, p, d, f, m, v) {
                return t[0] = e, t[1] = i, t[2] = r, t[3] = n, t[4] = o, t[5] = s, t[6] = a, t[7] = l, t[8] = h, t[9] = u, t[10] = c, t[11] = p, t[12] = d, t[13] = f, t[14] = m, t[15] = v, t
            }, n.identity = function (t) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.scalar.transpose = function (t, e) {
                if (t === e) {
                    var i = e[1],
                        r = e[2],
                        n = e[3],
                        o = e[6],
                        s = e[7],
                        a = e[11];
                    t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = i, t[6] = e[9], t[7] = e[13], t[8] = r, t[9] = o, t[11] = e[14], t[12] = n, t[13] = s, t[14] = a
                } else t[0] = e[0], t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = e[1], t[5] = e[5], t[6] = e[9], t[7] = e[13], t[8] = e[2], t[9] = e[6], t[10] = e[10], t[11] = e[14], t[12] = e[3], t[13] = e[7], t[14] = e[11], t[15] = e[15];
                return t
            }, n.SIMD.transpose = function (t, e) {
                var i, r, n, o, s, a, l, h, u, c;
                return i = SIMD.Float32x4.load(e, 0), r = SIMD.Float32x4.load(e, 4), n = SIMD.Float32x4.load(e, 8), o = SIMD.Float32x4.load(e, 12), s = SIMD.Float32x4.shuffle(i, r, 0, 1, 4, 5), a = SIMD.Float32x4.shuffle(n, o, 0, 1, 4, 5), l = SIMD.Float32x4.shuffle(s, a, 0, 2, 4, 6), h = SIMD.Float32x4.shuffle(s, a, 1, 3, 5, 7), SIMD.Float32x4.store(t, 0, l), SIMD.Float32x4.store(t, 4, h), s = SIMD.Float32x4.shuffle(i, r, 2, 3, 6, 7), a = SIMD.Float32x4.shuffle(n, o, 2, 3, 6, 7), u = SIMD.Float32x4.shuffle(s, a, 0, 2, 4, 6), c = SIMD.Float32x4.shuffle(s, a, 1, 3, 5, 7), SIMD.Float32x4.store(t, 8, u), SIMD.Float32x4.store(t, 12, c), t
            }, n.transpose = r.USE_SIMD ? n.SIMD.transpose : n.scalar.transpose, n.scalar.invert = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = e[6],
                    h = e[7],
                    u = e[8],
                    c = e[9],
                    p = e[10],
                    d = e[11],
                    f = e[12],
                    m = e[13],
                    v = e[14],
                    _ = e[15],
                    y = i * a - r * s,
                    g = i * l - n * s,
                    x = i * h - o * s,
                    M = r * l - n * a,
                    w = r * h - o * a,
                    b = n * h - o * l,
                    S = u * m - c * f,
                    E = u * v - p * f,
                    I = u * _ - d * f,
                    D = c * v - p * m,
                    T = c * _ - d * m,
                    F = p * _ - d * v,
                    L = y * F - g * T + x * D + M * I - w * E + b * S;
                return L ? (L = 1 / L, t[0] = (a * F - l * T + h * D) * L, t[1] = (n * T - r * F - o * D) * L, t[2] = (m * b - v * w + _ * M) * L, t[3] = (p * w - c * b - d * M) * L, t[4] = (l * I - s * F - h * E) * L, t[5] = (i * F - n * I + o * E) * L, t[6] = (v * x - f * b - _ * g) * L, t[7] = (u * b - p * x + d * g) * L, t[8] = (s * T - a * I + h * S) * L, t[9] = (r * I - i * T - o * S) * L, t[10] = (f * w - m * x + _ * y) * L, t[11] = (c * x - u * w - d * y) * L, t[12] = (a * E - s * D - l * S) * L, t[13] = (i * D - r * E + n * S) * L, t[14] = (m * g - f * M - v * y) * L, t[15] = (u * M - c * g + p * y) * L, t) : null
            }, n.SIMD.invert = function (t, e) {
                var i, r, n, o, s, a, l, h, u, c, p = SIMD.Float32x4.load(e, 0),
                    d = SIMD.Float32x4.load(e, 4),
                    f = SIMD.Float32x4.load(e, 8),
                    m = SIMD.Float32x4.load(e, 12);
                return s = SIMD.Float32x4.shuffle(p, d, 0, 1, 4, 5), r = SIMD.Float32x4.shuffle(f, m, 0, 1, 4, 5), i = SIMD.Float32x4.shuffle(s, r, 0, 2, 4, 6), r = SIMD.Float32x4.shuffle(r, s, 1, 3, 5, 7), s = SIMD.Float32x4.shuffle(p, d, 2, 3, 6, 7), o = SIMD.Float32x4.shuffle(f, m, 2, 3, 6, 7), n = SIMD.Float32x4.shuffle(s, o, 0, 2, 4, 6), o = SIMD.Float32x4.shuffle(o, s, 1, 3, 5, 7), s = SIMD.Float32x4.mul(n, o), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), a = SIMD.Float32x4.mul(r, s), l = SIMD.Float32x4.mul(i, s), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), a = SIMD.Float32x4.sub(SIMD.Float32x4.mul(r, s), a), l = SIMD.Float32x4.sub(SIMD.Float32x4.mul(i, s), l), l = SIMD.Float32x4.swizzle(l, 2, 3, 0, 1), s = SIMD.Float32x4.mul(r, n), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), a = SIMD.Float32x4.add(SIMD.Float32x4.mul(o, s), a), u = SIMD.Float32x4.mul(i, s), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), a = SIMD.Float32x4.sub(a, SIMD.Float32x4.mul(o, s)), u = SIMD.Float32x4.sub(SIMD.Float32x4.mul(i, s), u), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), s = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(r, 2, 3, 0, 1), o), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), n = SIMD.Float32x4.swizzle(n, 2, 3, 0, 1), a = SIMD.Float32x4.add(SIMD.Float32x4.mul(n, s), a), h = SIMD.Float32x4.mul(i, s), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), a = SIMD.Float32x4.sub(a, SIMD.Float32x4.mul(n, s)), h = SIMD.Float32x4.sub(SIMD.Float32x4.mul(i, s), h), h = SIMD.Float32x4.swizzle(h, 2, 3, 0, 1), s = SIMD.Float32x4.mul(i, r), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), h = SIMD.Float32x4.add(SIMD.Float32x4.mul(o, s), h), u = SIMD.Float32x4.sub(SIMD.Float32x4.mul(n, s), u), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), h = SIMD.Float32x4.sub(SIMD.Float32x4.mul(o, s), h), u = SIMD.Float32x4.sub(u, SIMD.Float32x4.mul(n, s)), s = SIMD.Float32x4.mul(i, o), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), l = SIMD.Float32x4.sub(l, SIMD.Float32x4.mul(n, s)), h = SIMD.Float32x4.add(SIMD.Float32x4.mul(r, s), h), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), l = SIMD.Float32x4.add(SIMD.Float32x4.mul(n, s), l), h = SIMD.Float32x4.sub(h, SIMD.Float32x4.mul(r, s)), s = SIMD.Float32x4.mul(i, n), s = SIMD.Float32x4.swizzle(s, 1, 0, 3, 2), l = SIMD.Float32x4.add(SIMD.Float32x4.mul(o, s), l), u = SIMD.Float32x4.sub(u, SIMD.Float32x4.mul(r, s)), s = SIMD.Float32x4.swizzle(s, 2, 3, 0, 1), l = SIMD.Float32x4.sub(l, SIMD.Float32x4.mul(o, s)), u = SIMD.Float32x4.add(SIMD.Float32x4.mul(r, s), u), c = SIMD.Float32x4.mul(i, a), c = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(c, 2, 3, 0, 1), c), c = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(c, 1, 0, 3, 2), c), s = SIMD.Float32x4.reciprocalApproximation(c), c = SIMD.Float32x4.sub(SIMD.Float32x4.add(s, s), SIMD.Float32x4.mul(c, SIMD.Float32x4.mul(s, s))), (c = SIMD.Float32x4.swizzle(c, 0, 0, 0, 0)) ? (SIMD.Float32x4.store(t, 0, SIMD.Float32x4.mul(c, a)), SIMD.Float32x4.store(t, 4, SIMD.Float32x4.mul(c, l)), SIMD.Float32x4.store(t, 8, SIMD.Float32x4.mul(c, h)), SIMD.Float32x4.store(t, 12, SIMD.Float32x4.mul(c, u)), t) : null
            }, n.invert = r.USE_SIMD ? n.SIMD.invert : n.scalar.invert, n.scalar.adjoint = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = e[4],
                    a = e[5],
                    l = e[6],
                    h = e[7],
                    u = e[8],
                    c = e[9],
                    p = e[10],
                    d = e[11],
                    f = e[12],
                    m = e[13],
                    v = e[14],
                    _ = e[15];
                return t[0] = a * (p * _ - d * v) - c * (l * _ - h * v) + m * (l * d - h * p), t[1] = -(r * (p * _ - d * v) - c * (n * _ - o * v) + m * (n * d - o * p)), t[2] = r * (l * _ - h * v) - a * (n * _ - o * v) + m * (n * h - o * l), t[3] = -(r * (l * d - h * p) - a * (n * d - o * p) + c * (n * h - o * l)), t[4] = -(s * (p * _ - d * v) - u * (l * _ - h * v) + f * (l * d - h * p)), t[5] = i * (p * _ - d * v) - u * (n * _ - o * v) + f * (n * d - o * p), t[6] = -(i * (l * _ - h * v) - s * (n * _ - o * v) + f * (n * h - o * l)), t[7] = i * (l * d - h * p) - s * (n * d - o * p) + u * (n * h - o * l), t[8] = s * (c * _ - d * m) - u * (a * _ - h * m) + f * (a * d - h * c), t[9] = -(i * (c * _ - d * m) - u * (r * _ - o * m) + f * (r * d - o * c)), t[10] = i * (a * _ - h * m) - s * (r * _ - o * m) + f * (r * h - o * a), t[11] = -(i * (a * d - h * c) - s * (r * d - o * c) + u * (r * h - o * a)), t[12] = -(s * (c * v - p * m) - u * (a * v - l * m) + f * (a * p - l * c)), t[13] = i * (c * v - p * m) - u * (r * v - n * m) + f * (r * p - n * c), t[14] = -(i * (a * v - l * m) - s * (r * v - n * m) + f * (r * l - n * a)), t[15] = i * (a * p - l * c) - s * (r * p - n * c) + u * (r * l - n * a), t
            }, n.SIMD.adjoint = function (t, e) {
                var i, r, n, o, s, a, l, h, u, c, p, d, f;
                return i = SIMD.Float32x4.load(e, 0), r = SIMD.Float32x4.load(e, 4), n = SIMD.Float32x4.load(e, 8), o = SIMD.Float32x4.load(e, 12), u = SIMD.Float32x4.shuffle(i, r, 0, 1, 4, 5), a = SIMD.Float32x4.shuffle(n, o, 0, 1, 4, 5), s = SIMD.Float32x4.shuffle(u, a, 0, 2, 4, 6), a = SIMD.Float32x4.shuffle(a, u, 1, 3, 5, 7), u = SIMD.Float32x4.shuffle(i, r, 2, 3, 6, 7), h = SIMD.Float32x4.shuffle(n, o, 2, 3, 6, 7), l = SIMD.Float32x4.shuffle(u, h, 0, 2, 4, 6), h = SIMD.Float32x4.shuffle(h, u, 1, 3, 5, 7), u = SIMD.Float32x4.mul(l, h), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), c = SIMD.Float32x4.mul(a, u), p = SIMD.Float32x4.mul(s, u), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), c = SIMD.Float32x4.sub(SIMD.Float32x4.mul(a, u), c), p = SIMD.Float32x4.sub(SIMD.Float32x4.mul(s, u), p), p = SIMD.Float32x4.swizzle(p, 2, 3, 0, 1), u = SIMD.Float32x4.mul(a, l), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), c = SIMD.Float32x4.add(SIMD.Float32x4.mul(h, u), c), f = SIMD.Float32x4.mul(s, u), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), c = SIMD.Float32x4.sub(c, SIMD.Float32x4.mul(h, u)), f = SIMD.Float32x4.sub(SIMD.Float32x4.mul(s, u), f), f = SIMD.Float32x4.swizzle(f, 2, 3, 0, 1), u = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(a, 2, 3, 0, 1), h), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), l = SIMD.Float32x4.swizzle(l, 2, 3, 0, 1), c = SIMD.Float32x4.add(SIMD.Float32x4.mul(l, u), c), d = SIMD.Float32x4.mul(s, u), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), c = SIMD.Float32x4.sub(c, SIMD.Float32x4.mul(l, u)), d = SIMD.Float32x4.sub(SIMD.Float32x4.mul(s, u), d), d = SIMD.Float32x4.swizzle(d, 2, 3, 0, 1), u = SIMD.Float32x4.mul(s, a), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), d = SIMD.Float32x4.add(SIMD.Float32x4.mul(h, u), d), f = SIMD.Float32x4.sub(SIMD.Float32x4.mul(l, u), f), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), d = SIMD.Float32x4.sub(SIMD.Float32x4.mul(h, u), d), f = SIMD.Float32x4.sub(f, SIMD.Float32x4.mul(l, u)), u = SIMD.Float32x4.mul(s, h), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), p = SIMD.Float32x4.sub(p, SIMD.Float32x4.mul(l, u)), d = SIMD.Float32x4.add(SIMD.Float32x4.mul(a, u), d), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), p = SIMD.Float32x4.add(SIMD.Float32x4.mul(l, u), p), d = SIMD.Float32x4.sub(d, SIMD.Float32x4.mul(a, u)), u = SIMD.Float32x4.mul(s, l), u = SIMD.Float32x4.swizzle(u, 1, 0, 3, 2), p = SIMD.Float32x4.add(SIMD.Float32x4.mul(h, u), p), f = SIMD.Float32x4.sub(f, SIMD.Float32x4.mul(a, u)), u = SIMD.Float32x4.swizzle(u, 2, 3, 0, 1), p = SIMD.Float32x4.sub(p, SIMD.Float32x4.mul(h, u)), f = SIMD.Float32x4.add(SIMD.Float32x4.mul(a, u), f), SIMD.Float32x4.store(t, 0, c), SIMD.Float32x4.store(t, 4, p), SIMD.Float32x4.store(t, 8, d), SIMD.Float32x4.store(t, 12, f), t
            }, n.adjoint = r.USE_SIMD ? n.SIMD.adjoint : n.scalar.adjoint, n.determinant = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2],
                    n = t[3],
                    o = t[4],
                    s = t[5],
                    a = t[6],
                    l = t[7],
                    h = t[8],
                    u = t[9],
                    c = t[10],
                    p = t[11],
                    d = t[12],
                    f = t[13],
                    m = t[14],
                    v = t[15];
                return (e * s - i * o) * (c * v - p * m) - (e * a - r * o) * (u * v - p * f) + (e * l - n * o) * (u * m - c * f) + (i * a - r * s) * (h * v - p * d) - (i * l - n * s) * (h * m - c * d) + (r * l - n * a) * (h * f - u * d)
            }, n.SIMD.multiply = function (t, e, i) {
                var r = SIMD.Float32x4.load(e, 0),
                    n = SIMD.Float32x4.load(e, 4),
                    o = SIMD.Float32x4.load(e, 8),
                    s = SIMD.Float32x4.load(e, 12),
                    a = SIMD.Float32x4.load(i, 0),
                    l = SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(a, 0, 0, 0, 0), r), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(a, 1, 1, 1, 1), n), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(a, 2, 2, 2, 2), o), SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(a, 3, 3, 3, 3), s))));
                SIMD.Float32x4.store(t, 0, l);
                var h = SIMD.Float32x4.load(i, 4),
                    u = SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(h, 0, 0, 0, 0), r), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(h, 1, 1, 1, 1), n), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(h, 2, 2, 2, 2), o), SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(h, 3, 3, 3, 3), s))));
                SIMD.Float32x4.store(t, 4, u);
                var c = SIMD.Float32x4.load(i, 8),
                    p = SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(c, 0, 0, 0, 0), r), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(c, 1, 1, 1, 1), n), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(c, 2, 2, 2, 2), o), SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(c, 3, 3, 3, 3), s))));
                SIMD.Float32x4.store(t, 8, p);
                var d = SIMD.Float32x4.load(i, 12),
                    f = SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(d, 0, 0, 0, 0), r), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(d, 1, 1, 1, 1), n), SIMD.Float32x4.add(SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(d, 2, 2, 2, 2), o), SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(d, 3, 3, 3, 3), s))));
                return SIMD.Float32x4.store(t, 12, f), t
            }, n.scalar.multiply = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = e[4],
                    l = e[5],
                    h = e[6],
                    u = e[7],
                    c = e[8],
                    p = e[9],
                    d = e[10],
                    f = e[11],
                    m = e[12],
                    v = e[13],
                    _ = e[14],
                    y = e[15],
                    g = i[0],
                    x = i[1],
                    M = i[2],
                    w = i[3];
                return t[0] = g * r + x * a + M * c + w * m, t[1] = g * n + x * l + M * p + w * v, t[2] = g * o + x * h + M * d + w * _, t[3] = g * s + x * u + M * f + w * y, g = i[4], x = i[5], M = i[6], w = i[7], t[4] = g * r + x * a + M * c + w * m, t[5] = g * n + x * l + M * p + w * v, t[6] = g * o + x * h + M * d + w * _, t[7] = g * s + x * u + M * f + w * y, g = i[8], x = i[9], M = i[10], w = i[11], t[8] = g * r + x * a + M * c + w * m, t[9] = g * n + x * l + M * p + w * v, t[10] = g * o + x * h + M * d + w * _, t[11] = g * s + x * u + M * f + w * y, g = i[12], x = i[13], M = i[14], w = i[15], t[12] = g * r + x * a + M * c + w * m, t[13] = g * n + x * l + M * p + w * v, t[14] = g * o + x * h + M * d + w * _, t[15] = g * s + x * u + M * f + w * y, t
            }, n.multiply = r.USE_SIMD ? n.SIMD.multiply : n.scalar.multiply, n.mul = n.multiply, n.scalar.translate = function (t, e, i) {
                var r, n, o, s, a, l, h, u, c, p, d, f, m = i[0],
                    v = i[1],
                    _ = i[2];
                return e === t ? (t[12] = e[0] * m + e[4] * v + e[8] * _ + e[12], t[13] = e[1] * m + e[5] * v + e[9] * _ + e[13], t[14] = e[2] * m + e[6] * v + e[10] * _ + e[14], t[15] = e[3] * m + e[7] * v + e[11] * _ + e[15]) : (r = e[0], n = e[1], o = e[2], s = e[3], a = e[4], l = e[5], h = e[6], u = e[7], c = e[8], p = e[9], d = e[10], f = e[11], t[0] = r, t[1] = n, t[2] = o, t[3] = s, t[4] = a, t[5] = l, t[6] = h, t[7] = u, t[8] = c, t[9] = p, t[10] = d, t[11] = f, t[12] = r * m + a * v + c * _ + e[12], t[13] = n * m + l * v + p * _ + e[13], t[14] = o * m + h * v + d * _ + e[14], t[15] = s * m + u * v + f * _ + e[15]), t
            }, n.SIMD.translate = function (t, e, i) {
                var r = SIMD.Float32x4.load(e, 0),
                    n = SIMD.Float32x4.load(e, 4),
                    o = SIMD.Float32x4.load(e, 8),
                    s = SIMD.Float32x4.load(e, 12),
                    a = SIMD.Float32x4(i[0], i[1], i[2], 0);
                e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11]), r = SIMD.Float32x4.mul(r, SIMD.Float32x4.swizzle(a, 0, 0, 0, 0)), n = SIMD.Float32x4.mul(n, SIMD.Float32x4.swizzle(a, 1, 1, 1, 1)), o = SIMD.Float32x4.mul(o, SIMD.Float32x4.swizzle(a, 2, 2, 2, 2));
                var l = SIMD.Float32x4.add(r, SIMD.Float32x4.add(n, SIMD.Float32x4.add(o, s)));
                return SIMD.Float32x4.store(t, 12, l), t
            }, n.translate = r.USE_SIMD ? n.SIMD.translate : n.scalar.translate, n.scalar.scale = function (t, e, i) {
                var r = i[0],
                    n = i[1],
                    o = i[2];
                return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * n, t[5] = e[5] * n, t[6] = e[6] * n, t[7] = e[7] * n, t[8] = e[8] * o, t[9] = e[9] * o, t[10] = e[10] * o, t[11] = e[11] * o, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t
            }, n.SIMD.scale = function (t, e, i) {
                var r, n, o, s = SIMD.Float32x4(i[0], i[1], i[2], 0);
                return r = SIMD.Float32x4.load(e, 0), SIMD.Float32x4.store(t, 0, SIMD.Float32x4.mul(r, SIMD.Float32x4.swizzle(s, 0, 0, 0, 0))), n = SIMD.Float32x4.load(e, 4), SIMD.Float32x4.store(t, 4, SIMD.Float32x4.mul(n, SIMD.Float32x4.swizzle(s, 1, 1, 1, 1))), o = SIMD.Float32x4.load(e, 8), SIMD.Float32x4.store(t, 8, SIMD.Float32x4.mul(o, SIMD.Float32x4.swizzle(s, 2, 2, 2, 2))), t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t
            }, n.scale = r.USE_SIMD ? n.SIMD.scale : n.scalar.scale, n.rotate = function (t, e, i, n) {
                var o, s, a, l, h, u, c, p, d, f, m, v, _, y, g, x, M, w, b, S, E, I, D, T, F = n[0],
                    L = n[1],
                    C = n[2],
                    z = Math.sqrt(F * F + L * L + C * C);
                return Math.abs(z) < r.EPSILON ? null : (z = 1 / z, F *= z, L *= z, C *= z, o = Math.sin(i), s = Math.cos(i), a = 1 - s, l = e[0], h = e[1], u = e[2], c = e[3], p = e[4], d = e[5], f = e[6], m = e[7], v = e[8], _ = e[9], y = e[10], g = e[11], x = F * F * a + s, M = L * F * a + C * o, w = C * F * a - L * o, b = F * L * a - C * o, S = L * L * a + s, E = C * L * a + F * o, I = F * C * a + L * o, D = L * C * a - F * o, T = C * C * a + s, t[0] = l * x + p * M + v * w, t[1] = h * x + d * M + _ * w, t[2] = u * x + f * M + y * w, t[3] = c * x + m * M + g * w, t[4] = l * b + p * S + v * E, t[5] = h * b + d * S + _ * E, t[6] = u * b + f * S + y * E, t[7] = c * b + m * S + g * E, t[8] = l * I + p * D + v * T, t[9] = h * I + d * D + _ * T, t[10] = u * I + f * D + y * T, t[11] = c * I + m * D + g * T, e !== t && (t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t)
            }, n.scalar.rotateX = function (t, e, i) {
                var r = Math.sin(i),
                    n = Math.cos(i),
                    o = e[4],
                    s = e[5],
                    a = e[6],
                    l = e[7],
                    h = e[8],
                    u = e[9],
                    c = e[10],
                    p = e[11];
                return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = o * n + h * r, t[5] = s * n + u * r, t[6] = a * n + c * r, t[7] = l * n + p * r, t[8] = h * n - o * r, t[9] = u * n - s * r, t[10] = c * n - a * r, t[11] = p * n - l * r, t
            }, n.SIMD.rotateX = function (t, e, i) {
                var r = SIMD.Float32x4.splat(Math.sin(i)),
                    n = SIMD.Float32x4.splat(Math.cos(i));
                e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
                var o = SIMD.Float32x4.load(e, 4),
                    s = SIMD.Float32x4.load(e, 8);
                return SIMD.Float32x4.store(t, 4, SIMD.Float32x4.add(SIMD.Float32x4.mul(o, n), SIMD.Float32x4.mul(s, r))), SIMD.Float32x4.store(t, 8, SIMD.Float32x4.sub(SIMD.Float32x4.mul(s, n), SIMD.Float32x4.mul(o, r))), t
            }, n.rotateX = r.USE_SIMD ? n.SIMD.rotateX : n.scalar.rotateX, n.scalar.rotateY = function (t, e, i) {
                var r = Math.sin(i),
                    n = Math.cos(i),
                    o = e[0],
                    s = e[1],
                    a = e[2],
                    l = e[3],
                    h = e[8],
                    u = e[9],
                    c = e[10],
                    p = e[11];
                return e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = o * n - h * r, t[1] = s * n - u * r, t[2] = a * n - c * r, t[3] = l * n - p * r, t[8] = o * r + h * n, t[9] = s * r + u * n, t[10] = a * r + c * n, t[11] = l * r + p * n, t
            }, n.SIMD.rotateY = function (t, e, i) {
                var r = SIMD.Float32x4.splat(Math.sin(i)),
                    n = SIMD.Float32x4.splat(Math.cos(i));
                e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
                var o = SIMD.Float32x4.load(e, 0),
                    s = SIMD.Float32x4.load(e, 8);
                return SIMD.Float32x4.store(t, 0, SIMD.Float32x4.sub(SIMD.Float32x4.mul(o, n), SIMD.Float32x4.mul(s, r))), SIMD.Float32x4.store(t, 8, SIMD.Float32x4.add(SIMD.Float32x4.mul(o, r), SIMD.Float32x4.mul(s, n))), t
            }, n.rotateY = r.USE_SIMD ? n.SIMD.rotateY : n.scalar.rotateY, n.scalar.rotateZ = function (t, e, i) {
                var r = Math.sin(i),
                    n = Math.cos(i),
                    o = e[0],
                    s = e[1],
                    a = e[2],
                    l = e[3],
                    h = e[4],
                    u = e[5],
                    c = e[6],
                    p = e[7];
                return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = o * n + h * r, t[1] = s * n + u * r, t[2] = a * n + c * r, t[3] = l * n + p * r, t[4] = h * n - o * r, t[5] = u * n - s * r, t[6] = c * n - a * r, t[7] = p * n - l * r, t
            }, n.SIMD.rotateZ = function (t, e, i) {
                var r = SIMD.Float32x4.splat(Math.sin(i)),
                    n = SIMD.Float32x4.splat(Math.cos(i));
                e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]);
                var o = SIMD.Float32x4.load(e, 0),
                    s = SIMD.Float32x4.load(e, 4);
                return SIMD.Float32x4.store(t, 0, SIMD.Float32x4.add(SIMD.Float32x4.mul(o, n), SIMD.Float32x4.mul(s, r))), SIMD.Float32x4.store(t, 4, SIMD.Float32x4.sub(SIMD.Float32x4.mul(s, n), SIMD.Float32x4.mul(o, r))), t
            }, n.rotateZ = r.USE_SIMD ? n.SIMD.rotateZ : n.scalar.rotateZ, n.fromTranslation = function (t, e) {
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = e[0], t[13] = e[1], t[14] = e[2], t[15] = 1, t
            }, n.fromScaling = function (t, e) {
                return t[0] = e[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.fromRotation = function (t, e, i) {
                var n, o, s, a = i[0],
                    l = i[1],
                    h = i[2],
                    u = Math.sqrt(a * a + l * l + h * h);
                return Math.abs(u) < r.EPSILON ? null : (u = 1 / u, a *= u, l *= u, h *= u, n = Math.sin(e), o = Math.cos(e), s = 1 - o, t[0] = a * a * s + o, t[1] = l * a * s + h * n, t[2] = h * a * s - l * n, t[3] = 0, t[4] = a * l * s - h * n, t[5] = l * l * s + o, t[6] = h * l * s + a * n, t[7] = 0, t[8] = a * h * s + l * n, t[9] = l * h * s - a * n, t[10] = h * h * s + o, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t)
            }, n.fromXRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = r, t[6] = i, t[7] = 0, t[8] = 0, t[9] = -i, t[10] = r, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.fromYRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = r, t[1] = 0, t[2] = -i, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = i, t[9] = 0, t[10] = r, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.fromZRotation = function (t, e) {
                var i = Math.sin(e),
                    r = Math.cos(e);
                return t[0] = r, t[1] = i, t[2] = 0, t[3] = 0, t[4] = -i, t[5] = r, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.fromRotationTranslation = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = r + r,
                    l = n + n,
                    h = o + o,
                    u = r * a,
                    c = r * l,
                    p = r * h,
                    d = n * l,
                    f = n * h,
                    m = o * h,
                    v = s * a,
                    _ = s * l,
                    y = s * h;
                return t[0] = 1 - (d + m), t[1] = c + y, t[2] = p - _, t[3] = 0, t[4] = c - y, t[5] = 1 - (u + m), t[6] = f + v, t[7] = 0, t[8] = p + _, t[9] = f - v, t[10] = 1 - (u + d), t[11] = 0, t[12] = i[0], t[13] = i[1], t[14] = i[2], t[15] = 1, t
            }, n.getTranslation = function (t, e) {
                return t[0] = e[12], t[1] = e[13], t[2] = e[14], t
            }, n.getScaling = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[4],
                    s = e[5],
                    a = e[6],
                    l = e[8],
                    h = e[9],
                    u = e[10];
                return t[0] = Math.sqrt(i * i + r * r + n * n), t[1] = Math.sqrt(o * o + s * s + a * a), t[2] = Math.sqrt(l * l + h * h + u * u), t
            }, n.getRotation = function (t, e) {
                var i = e[0] + e[5] + e[10],
                    r = 0;
                return i > 0 ? (r = 2 * Math.sqrt(i + 1), t[3] = .25 * r, t[0] = (e[6] - e[9]) / r, t[1] = (e[8] - e[2]) / r, t[2] = (e[1] - e[4]) / r) : e[0] > e[5] & e[0] > e[10] ? (r = 2 * Math.sqrt(1 + e[0] - e[5] - e[10]), t[3] = (e[6] - e[9]) / r, t[0] = .25 * r, t[1] = (e[1] + e[4]) / r, t[2] = (e[8] + e[2]) / r) : e[5] > e[10] ? (r = 2 * Math.sqrt(1 + e[5] - e[0] - e[10]), t[3] = (e[8] - e[2]) / r, t[0] = (e[1] + e[4]) / r, t[1] = .25 * r, t[2] = (e[6] + e[9]) / r) : (r = 2 * Math.sqrt(1 + e[10] - e[0] - e[5]), t[3] = (e[1] - e[4]) / r, t[0] = (e[8] + e[2]) / r, t[1] = (e[6] + e[9]) / r, t[2] = .25 * r), t
            }, n.fromRotationTranslationScale = function (t, e, i, r) {
                var n = e[0],
                    o = e[1],
                    s = e[2],
                    a = e[3],
                    l = n + n,
                    h = o + o,
                    u = s + s,
                    c = n * l,
                    p = n * h,
                    d = n * u,
                    f = o * h,
                    m = o * u,
                    v = s * u,
                    _ = a * l,
                    y = a * h,
                    g = a * u,
                    x = r[0],
                    M = r[1],
                    w = r[2];
                return t[0] = (1 - (f + v)) * x, t[1] = (p + g) * x, t[2] = (d - y) * x, t[3] = 0, t[4] = (p - g) * M, t[5] = (1 - (c + v)) * M, t[6] = (m + _) * M, t[7] = 0, t[8] = (d + y) * w, t[9] = (m - _) * w, t[10] = (1 - (c + f)) * w, t[11] = 0, t[12] = i[0], t[13] = i[1], t[14] = i[2], t[15] = 1, t
            }, n.fromRotationTranslationScaleOrigin = function (t, e, i, r, n) {
                var o = e[0],
                    s = e[1],
                    a = e[2],
                    l = e[3],
                    h = o + o,
                    u = s + s,
                    c = a + a,
                    p = o * h,
                    d = o * u,
                    f = o * c,
                    m = s * u,
                    v = s * c,
                    _ = a * c,
                    y = l * h,
                    g = l * u,
                    x = l * c,
                    M = r[0],
                    w = r[1],
                    b = r[2],
                    S = n[0],
                    E = n[1],
                    I = n[2];
                return t[0] = (1 - (m + _)) * M, t[1] = (d + x) * M, t[2] = (f - g) * M, t[3] = 0, t[4] = (d - x) * w, t[5] = (1 - (p + _)) * w, t[6] = (v + y) * w, t[7] = 0, t[8] = (f + g) * b, t[9] = (v - y) * b, t[10] = (1 - (p + m)) * b, t[11] = 0, t[12] = i[0] + S - (t[0] * S + t[4] * E + t[8] * I), t[13] = i[1] + E - (t[1] * S + t[5] * E + t[9] * I), t[14] = i[2] + I - (t[2] * S + t[6] * E + t[10] * I), t[15] = 1, t
            }, n.fromQuat = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = i + i,
                    a = r + r,
                    l = n + n,
                    h = i * s,
                    u = r * s,
                    c = r * a,
                    p = n * s,
                    d = n * a,
                    f = n * l,
                    m = o * s,
                    v = o * a,
                    _ = o * l;
                return t[0] = 1 - c - f, t[1] = u + _, t[2] = p - v, t[3] = 0, t[4] = u - _, t[5] = 1 - h - f, t[6] = d + m, t[7] = 0, t[8] = p + v, t[9] = d - m, t[10] = 1 - h - c, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t
            }, n.frustum = function (t, e, i, r, n, o, s) {
                var a = 1 / (i - e),
                    l = 1 / (n - r),
                    h = 1 / (o - s);
                return t[0] = 2 * o * a, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 2 * o * l, t[6] = 0, t[7] = 0, t[8] = (i + e) * a, t[9] = (n + r) * l, t[10] = (s + o) * h, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = s * o * 2 * h, t[15] = 0, t
            }, n.perspective = function (t, e, i, r, n) {
                var o = 1 / Math.tan(e / 2),
                    s = 1 / (r - n);
                return t[0] = o / i, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = o, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = (n + r) * s, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = 2 * n * r * s, t[15] = 0, t
            }, n.perspectiveFromFieldOfView = function (t, e, i, r) {
                var n = Math.tan(e.upDegrees * Math.PI / 180),
                    o = Math.tan(e.downDegrees * Math.PI / 180),
                    s = Math.tan(e.leftDegrees * Math.PI / 180),
                    a = Math.tan(e.rightDegrees * Math.PI / 180),
                    l = 2 / (s + a),
                    h = 2 / (n + o);
                return t[0] = l, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = h, t[6] = 0, t[7] = 0, t[8] = -(s - a) * l * .5, t[9] = (n - o) * h * .5, t[10] = r / (i - r), t[11] = -1, t[12] = 0, t[13] = 0, t[14] = r * i / (i - r), t[15] = 0, t
            }, n.ortho = function (t, e, i, r, n, o, s) {
                var a = 1 / (e - i),
                    l = 1 / (r - n),
                    h = 1 / (o - s);
                return t[0] = -2 * a, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * h, t[11] = 0, t[12] = (e + i) * a, t[13] = (n + r) * l, t[14] = (s + o) * h, t[15] = 1, t
            }, n.lookAt = function (t, e, i, o) {
                var s, a, l, h, u, c, p, d, f, m, v = e[0],
                    _ = e[1],
                    y = e[2],
                    g = o[0],
                    x = o[1],
                    M = o[2],
                    w = i[0],
                    b = i[1],
                    S = i[2];
                return Math.abs(v - w) < r.EPSILON && Math.abs(_ - b) < r.EPSILON && Math.abs(y - S) < r.EPSILON ? n.identity(t) : (p = v - w, d = _ - b, f = y - S, m = 1 / Math.sqrt(p * p + d * d + f * f), p *= m, d *= m, f *= m, s = x * f - M * d, a = M * p - g * f, l = g * d - x * p, m = Math.sqrt(s * s + a * a + l * l), m ? (m = 1 / m, s *= m, a *= m, l *= m) : (s = 0, a = 0, l = 0), h = d * l - f * a, u = f * s - p * l, c = p * a - d * s, m = Math.sqrt(h * h + u * u + c * c), m ? (m = 1 / m, h *= m, u *= m, c *= m) : (h = 0, u = 0, c = 0), t[0] = s, t[1] = h, t[2] = p, t[3] = 0, t[4] = a, t[5] = u, t[6] = d, t[7] = 0, t[8] = l, t[9] = c, t[10] = f, t[11] = 0, t[12] = -(s * v + a * _ + l * y), t[13] = -(h * v + u * _ + c * y), t[14] = -(p * v + d * _ + f * y), t[15] = 1, t)
            }, n.str = function (t) {
                return "mat4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ", " + t[4] + ", " + t[5] + ", " + t[6] + ", " + t[7] + ", " + t[8] + ", " + t[9] + ", " + t[10] + ", " + t[11] + ", " + t[12] + ", " + t[13] + ", " + t[14] + ", " + t[15] + ")"
            }, n.frob = function (t) {
                return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2) + Math.pow(t[2], 2) + Math.pow(t[3], 2) + Math.pow(t[4], 2) + Math.pow(t[5], 2) + Math.pow(t[6], 2) + Math.pow(t[7], 2) + Math.pow(t[8], 2) + Math.pow(t[9], 2) + Math.pow(t[10], 2) + Math.pow(t[11], 2) + Math.pow(t[12], 2) + Math.pow(t[13], 2) + Math.pow(t[14], 2) + Math.pow(t[15], 2))
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t[3] = e[3] + i[3], t[4] = e[4] + i[4], t[5] = e[5] + i[5], t[6] = e[6] + i[6], t[7] = e[7] + i[7], t[8] = e[8] + i[8], t[9] = e[9] + i[9], t[10] = e[10] + i[10], t[11] = e[11] + i[11], t[12] = e[12] + i[12], t[13] = e[13] + i[13], t[14] = e[14] + i[14], t[15] = e[15] + i[15], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t[3] = e[3] - i[3], t[4] = e[4] - i[4], t[5] = e[5] - i[5], t[6] = e[6] - i[6], t[7] = e[7] - i[7], t[8] = e[8] - i[8], t[9] = e[9] - i[9], t[10] = e[10] - i[10], t[11] = e[11] - i[11], t[12] = e[12] - i[12], t[13] = e[13] - i[13], t[14] = e[14] - i[14], t[15] = e[15] - i[15], t
            }, n.sub = n.subtract, n.multiplyScalar = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t[3] = e[3] * i, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * i, t[9] = e[9] * i, t[10] = e[10] * i, t[11] = e[11] * i, t[12] = e[12] * i, t[13] = e[13] * i, t[14] = e[14] * i, t[15] = e[15] * i, t
            }, n.multiplyScalarAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t[3] = e[3] + i[3] * r, t[4] = e[4] + i[4] * r, t[5] = e[5] + i[5] * r, t[6] = e[6] + i[6] * r, t[7] = e[7] + i[7] * r, t[8] = e[8] + i[8] * r, t[9] = e[9] + i[9] * r, t[10] = e[10] + i[10] * r, t[11] = e[11] + i[11] * r, t[12] = e[12] + i[12] * r, t[13] = e[13] + i[13] * r, t[14] = e[14] + i[14] * r, t[15] = e[15] + i[15] * r, t
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3] && t[4] === e[4] && t[5] === e[5] && t[6] === e[6] && t[7] === e[7] && t[8] === e[8] && t[9] === e[9] && t[10] === e[10] && t[11] === e[11] && t[12] === e[12] && t[13] === e[13] && t[14] === e[14] && t[15] === e[15]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = t[3],
                    a = t[4],
                    l = t[5],
                    h = t[6],
                    u = t[7],
                    c = t[8],
                    p = t[9],
                    d = t[10],
                    f = t[11],
                    m = t[12],
                    v = t[13],
                    _ = t[14],
                    y = t[15],
                    g = e[0],
                    x = e[1],
                    M = e[2],
                    w = e[3],
                    b = e[4],
                    S = e[5],
                    E = e[6],
                    I = e[7],
                    D = e[8],
                    T = e[9],
                    F = e[10],
                    L = e[11],
                    C = e[12],
                    z = e[13],
                    R = e[14],
                    P = e[15];
                return Math.abs(i - g) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(g)) && Math.abs(n - x) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(x)) && Math.abs(o - M) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(M)) && Math.abs(s - w) <= r.EPSILON * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - b) <= r.EPSILON * Math.max(1, Math.abs(a), Math.abs(b)) && Math.abs(l - S) <= r.EPSILON * Math.max(1, Math.abs(l), Math.abs(S)) && Math.abs(h - E) <= r.EPSILON * Math.max(1, Math.abs(h), Math.abs(E)) && Math.abs(u - I) <= r.EPSILON * Math.max(1, Math.abs(u), Math.abs(I)) && Math.abs(c - D) <= r.EPSILON * Math.max(1, Math.abs(c), Math.abs(D)) && Math.abs(p - T) <= r.EPSILON * Math.max(1, Math.abs(p), Math.abs(T)) && Math.abs(d - F) <= r.EPSILON * Math.max(1, Math.abs(d), Math.abs(F)) && Math.abs(f - L) <= r.EPSILON * Math.max(1, Math.abs(f), Math.abs(L)) && Math.abs(m - C) <= r.EPSILON * Math.max(1, Math.abs(m), Math.abs(C)) && Math.abs(v - z) <= r.EPSILON * Math.max(1, Math.abs(v), Math.abs(z)) && Math.abs(_ - R) <= r.EPSILON * Math.max(1, Math.abs(_), Math.abs(R)) && Math.abs(y - P) <= r.EPSILON * Math.max(1, Math.abs(y), Math.abs(P))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        8: [function (t, e, i) {
            var r = t("./common.js"),
                n = t("./mat3.js"),
                o = t("./vec3.js"),
                s = t("./vec4.js"),
                a = {};
            a.create = function () {
                var t = new r.ARRAY_TYPE(4);
                return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t
            }, a.rotationTo = function () {
                var t = o.create(),
                    e = o.fromValues(1, 0, 0),
                    i = o.fromValues(0, 1, 0);
                return function (r, n, s) {
                    var l = o.dot(n, s);
                    return l < -.999999 ? (o.cross(t, e, n), o.length(t) < 1e-6 && o.cross(t, i, n), o.normalize(t, t), a.setAxisAngle(r, t, Math.PI), r) : l > .999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (o.cross(t, n, s), r[0] = t[0], r[1] = t[1], r[2] = t[2], r[3] = 1 + l, a.normalize(r, r))
                }
            }(), a.setAxes = function () {
                var t = n.create();
                return function (e, i, r, n) {
                    return t[0] = r[0], t[3] = r[1], t[6] = r[2], t[1] = n[0], t[4] = n[1], t[7] = n[2], t[2] = -i[0], t[5] = -i[1], t[8] = -i[2], a.normalize(e, a.fromMat3(e, t))
                }
            }(), a.clone = s.clone, a.fromValues = s.fromValues, a.copy = s.copy, a.set = s.set, a.identity = function (t) {
                return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t
            }, a.setAxisAngle = function (t, e, i) {
                i *= .5;
                var r = Math.sin(i);
                return t[0] = r * e[0], t[1] = r * e[1], t[2] = r * e[2], t[3] = Math.cos(i), t
            }, a.getAxisAngle = function (t, e) {
                var i = 2 * Math.acos(e[3]),
                    r = Math.sin(i / 2);
                return 0 != r ? (t[0] = e[0] / r, t[1] = e[1] / r, t[2] = e[2] / r) : (t[0] = 1, t[1] = 0, t[2] = 0), i
            }, a.add = s.add, a.multiply = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = i[0],
                    l = i[1],
                    h = i[2],
                    u = i[3];
                return t[0] = r * u + s * a + n * h - o * l, t[1] = n * u + s * l + o * a - r * h, t[2] = o * u + s * h + r * l - n * a, t[3] = s * u - r * a - n * l - o * h, t
            }, a.mul = a.multiply, a.scale = s.scale, a.rotateX = function (t, e, i) {
                i *= .5;
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = Math.sin(i),
                    l = Math.cos(i);
                return t[0] = r * l + s * a, t[1] = n * l + o * a, t[2] = o * l - n * a, t[3] = s * l - r * a, t
            }, a.rotateY = function (t, e, i) {
                i *= .5;
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = Math.sin(i),
                    l = Math.cos(i);
                return t[0] = r * l - o * a, t[1] = n * l + s * a, t[2] = o * l + r * a, t[3] = s * l - n * a, t
            }, a.rotateZ = function (t, e, i) {
                i *= .5;
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3],
                    a = Math.sin(i),
                    l = Math.cos(i);
                return t[0] = r * l + n * a, t[1] = n * l - r * a, t[2] = o * l + s * a, t[3] = s * l - o * a, t
            }, a.calculateW = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2];
                return t[0] = i, t[1] = r, t[2] = n, t[3] = Math.sqrt(Math.abs(1 - i * i - r * r - n * n)), t
            }, a.dot = s.dot, a.lerp = s.lerp, a.slerp = function (t, e, i, r) {
                var n, o, s, a, l, h = e[0],
                    u = e[1],
                    c = e[2],
                    p = e[3],
                    d = i[0],
                    f = i[1],
                    m = i[2],
                    v = i[3];
                return o = h * d + u * f + c * m + p * v, o < 0 && (o = -o, d = -d, f = -f, m = -m, v = -v), 1 - o > 1e-6 ? (n = Math.acos(o), s = Math.sin(n), a = Math.sin((1 - r) * n) / s, l = Math.sin(r * n) / s) : (a = 1 - r, l = r), t[0] = a * h + l * d, t[1] = a * u + l * f, t[2] = a * c + l * m, t[3] = a * p + l * v, t
            }, a.sqlerp = function () {
                var t = a.create(),
                    e = a.create();
                return function (i, r, n, o, s, l) {
                    return a.slerp(t, r, s, l), a.slerp(e, n, o, l), a.slerp(i, t, e, 2 * l * (1 - l)), i
                }
            }(), a.invert = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = i * i + r * r + n * n + o * o,
                    a = s ? 1 / s : 0;
                return t[0] = -i * a, t[1] = -r * a, t[2] = -n * a, t[3] = o * a, t
            }, a.conjugate = function (t, e) {
                return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = e[3], t
            }, a.length = s.length, a.len = a.length, a.squaredLength = s.squaredLength, a.sqrLen = a.squaredLength, a.normalize = s.normalize, a.fromMat3 = function (t, e) {
                var i, r = e[0] + e[4] + e[8];
                if (r > 0) i = Math.sqrt(r + 1), t[3] = .5 * i, i = .5 / i, t[0] = (e[5] - e[7]) * i, t[1] = (e[6] - e[2]) * i, t[2] = (e[1] - e[3]) * i;
                else {
                    var n = 0;
                    e[4] > e[0] && (n = 1), e[8] > e[3 * n + n] && (n = 2);
                    var o = (n + 1) % 3,
                        s = (n + 2) % 3;
                    i = Math.sqrt(e[3 * n + n] - e[3 * o + o] - e[3 * s + s] + 1), t[n] = .5 * i, i = .5 / i, t[3] = (e[3 * o + s] - e[3 * s + o]) * i, t[o] = (e[3 * o + n] + e[3 * n + o]) * i, t[s] = (e[3 * s + n] + e[3 * n + s]) * i
                }
                return t
            }, a.str = function (t) {
                return "quat(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")"
            }, a.exactEquals = s.exactEquals, a.equals = s.equals, e.exports = a
        }, {
            "./common.js": 3,
            "./mat3.js": 6,
            "./vec3.js": 10,
            "./vec4.js": 11
        }],
        9: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(2);
                return t[0] = 0, t[1] = 0, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(2);
                return e[0] = t[0], e[1] = t[1], e
            }, n.fromValues = function (t, e) {
                var i = new r.ARRAY_TYPE(2);
                return i[0] = t, i[1] = e, i
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t
            }, n.set = function (t, e, i) {
                return t[0] = e, t[1] = i, t
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t
            }, n.sub = n.subtract, n.multiply = function (t, e, i) {
                return t[0] = e[0] * i[0], t[1] = e[1] * i[1], t
            }, n.mul = n.multiply, n.divide = function (t, e, i) {
                return t[0] = e[0] / i[0], t[1] = e[1] / i[1], t
            }, n.div = n.divide, n.ceil = function (t, e) {
                return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t
            }, n.floor = function (t, e) {
                return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t
            }, n.min = function (t, e, i) {
                return t[0] = Math.min(e[0], i[0]), t[1] = Math.min(e[1], i[1]), t
            }, n.max = function (t, e, i) {
                return t[0] = Math.max(e[0], i[0]), t[1] = Math.max(e[1], i[1]), t
            }, n.round = function (t, e) {
                return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t
            }, n.scale = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t
            }, n.scaleAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t
            }, n.distance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1];
                return Math.sqrt(i * i + r * r)
            }, n.dist = n.distance, n.squaredDistance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1];
                return i * i + r * r
            }, n.sqrDist = n.squaredDistance, n.length = function (t) {
                var e = t[0],
                    i = t[1];
                return Math.sqrt(e * e + i * i)
            }, n.len = n.length, n.squaredLength = function (t) {
                var e = t[0],
                    i = t[1];
                return e * e + i * i
            }, n.sqrLen = n.squaredLength, n.negate = function (t, e) {
                return t[0] = -e[0], t[1] = -e[1], t
            }, n.inverse = function (t, e) {
                return t[0] = 1 / e[0], t[1] = 1 / e[1], t
            }, n.normalize = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = i * i + r * r;
                return n > 0 && (n = 1 / Math.sqrt(n), t[0] = e[0] * n, t[1] = e[1] * n), t
            }, n.dot = function (t, e) {
                return t[0] * e[0] + t[1] * e[1]
            }, n.cross = function (t, e, i) {
                var r = e[0] * i[1] - e[1] * i[0];
                return t[0] = t[1] = 0, t[2] = r, t
            }, n.lerp = function (t, e, i, r) {
                var n = e[0],
                    o = e[1];
                return t[0] = n + r * (i[0] - n), t[1] = o + r * (i[1] - o), t
            }, n.random = function (t, e) {
                e = e || 1;
                var i = 2 * r.RANDOM() * Math.PI;
                return t[0] = Math.cos(i) * e, t[1] = Math.sin(i) * e, t
            }, n.transformMat2 = function (t, e, i) {
                var r = e[0],
                    n = e[1];
                return t[0] = i[0] * r + i[2] * n, t[1] = i[1] * r + i[3] * n, t
            }, n.transformMat2d = function (t, e, i) {
                var r = e[0],
                    n = e[1];
                return t[0] = i[0] * r + i[2] * n + i[4], t[1] = i[1] * r + i[3] * n + i[5], t
            }, n.transformMat3 = function (t, e, i) {
                var r = e[0],
                    n = e[1];
                return t[0] = i[0] * r + i[3] * n + i[6], t[1] = i[1] * r + i[4] * n + i[7], t
            }, n.transformMat4 = function (t, e, i) {
                var r = e[0],
                    n = e[1];
                return t[0] = i[0] * r + i[4] * n + i[12], t[1] = i[1] * r + i[5] * n + i[13], t
            }, n.forEach = function () {
                var t = n.create();
                return function (e, i, r, n, o, s) {
                    var a, l;
                    for (i || (i = 2), r || (r = 0), l = n ? Math.min(n * i + r, e.length) : e.length, a = r; a < l; a += i) t[0] = e[a], t[1] = e[a + 1], o(t, t, s), e[a] = t[0], e[a + 1] = t[1];
                    return e
                }
            }(), n.str = function (t) {
                return "vec2(" + t[0] + ", " + t[1] + ")"
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = e[0],
                    s = e[1];
                return Math.abs(i - o) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(n - s) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(s))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        10: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(3);
                return t[0] = 0, t[1] = 0, t[2] = 0, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(3);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e
            }, n.fromValues = function (t, e, i) {
                var n = new r.ARRAY_TYPE(3);
                return n[0] = t, n[1] = e, n[2] = i, n
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t
            }, n.set = function (t, e, i, r) {
                return t[0] = e, t[1] = i, t[2] = r, t
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t
            }, n.sub = n.subtract, n.multiply = function (t, e, i) {
                return t[0] = e[0] * i[0], t[1] = e[1] * i[1], t[2] = e[2] * i[2], t
            }, n.mul = n.multiply, n.divide = function (t, e, i) {
                return t[0] = e[0] / i[0], t[1] = e[1] / i[1], t[2] = e[2] / i[2], t
            }, n.div = n.divide, n.ceil = function (t, e) {
                return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t
            }, n.floor = function (t, e) {
                return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t
            }, n.min = function (t, e, i) {
                return t[0] = Math.min(e[0], i[0]), t[1] = Math.min(e[1], i[1]), t[2] = Math.min(e[2], i[2]), t
            }, n.max = function (t, e, i) {
                return t[0] = Math.max(e[0], i[0]), t[1] = Math.max(e[1], i[1]), t[2] = Math.max(e[2], i[2]), t
            }, n.round = function (t, e) {
                return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t
            }, n.scale = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t
            }, n.scaleAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t
            }, n.distance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1],
                    n = e[2] - t[2];
                return Math.sqrt(i * i + r * r + n * n)
            }, n.dist = n.distance, n.squaredDistance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1],
                    n = e[2] - t[2];
                return i * i + r * r + n * n
            }, n.sqrDist = n.squaredDistance, n.length = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2];
                return Math.sqrt(e * e + i * i + r * r)
            }, n.len = n.length, n.squaredLength = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2];
                return e * e + i * i + r * r
            }, n.sqrLen = n.squaredLength, n.negate = function (t, e) {
                return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t
            }, n.inverse = function (t, e) {
                return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t
            }, n.normalize = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = i * i + r * r + n * n;
                return o > 0 && (o = 1 / Math.sqrt(o), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o), t
            }, n.dot = function (t, e) {
                return t[0] * e[0] + t[1] * e[1] + t[2] * e[2]
            }, n.cross = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = i[0],
                    a = i[1],
                    l = i[2];
                return t[0] = n * l - o * a, t[1] = o * s - r * l, t[2] = r * a - n * s, t
            }, n.lerp = function (t, e, i, r) {
                var n = e[0],
                    o = e[1],
                    s = e[2];
                return t[0] = n + r * (i[0] - n), t[1] = o + r * (i[1] - o), t[2] = s + r * (i[2] - s), t
            }, n.hermite = function (t, e, i, r, n, o) {
                var s = o * o,
                    a = s * (2 * o - 3) + 1,
                    l = s * (o - 2) + o,
                    h = s * (o - 1),
                    u = s * (3 - 2 * o);
                return t[0] = e[0] * a + i[0] * l + r[0] * h + n[0] * u, t[1] = e[1] * a + i[1] * l + r[1] * h + n[1] * u, t[2] = e[2] * a + i[2] * l + r[2] * h + n[2] * u, t
            }, n.bezier = function (t, e, i, r, n, o) {
                var s = 1 - o,
                    a = s * s,
                    l = o * o,
                    h = a * s,
                    u = 3 * o * a,
                    c = 3 * l * s,
                    p = l * o;
                return t[0] = e[0] * h + i[0] * u + r[0] * c + n[0] * p, t[1] = e[1] * h + i[1] * u + r[1] * c + n[1] * p, t[2] = e[2] * h + i[2] * u + r[2] * c + n[2] * p, t
            }, n.random = function (t, e) {
                e = e || 1;
                var i = 2 * r.RANDOM() * Math.PI,
                    n = 2 * r.RANDOM() - 1,
                    o = Math.sqrt(1 - n * n) * e;
                return t[0] = Math.cos(i) * o, t[1] = Math.sin(i) * o, t[2] = n * e, t
            }, n.transformMat4 = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = i[3] * r + i[7] * n + i[11] * o + i[15];
                return s = s || 1, t[0] = (i[0] * r + i[4] * n + i[8] * o + i[12]) / s, t[1] = (i[1] * r + i[5] * n + i[9] * o + i[13]) / s, t[2] = (i[2] * r + i[6] * n + i[10] * o + i[14]) / s, t
            }, n.transformMat3 = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2];
                return t[0] = r * i[0] + n * i[3] + o * i[6], t[1] = r * i[1] + n * i[4] + o * i[7], t[2] = r * i[2] + n * i[5] + o * i[8], t
            }, n.transformQuat = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = i[0],
                    a = i[1],
                    l = i[2],
                    h = i[3],
                    u = h * r + a * o - l * n,
                    c = h * n + l * r - s * o,
                    p = h * o + s * n - a * r,
                    d = -s * r - a * n - l * o;
                return t[0] = u * h + d * -s + c * -l - p * -a, t[1] = c * h + d * -a + p * -s - u * -l, t[2] = p * h + d * -l + u * -a - c * -s, t
            }, n.rotateX = function (t, e, i, r) {
                var n = [],
                    o = [];
                return n[0] = e[0] - i[0], n[1] = e[1] - i[1], n[2] = e[2] - i[2], o[0] = n[0], o[1] = n[1] * Math.cos(r) - n[2] * Math.sin(r), o[2] = n[1] * Math.sin(r) + n[2] * Math.cos(r), t[0] = o[0] + i[0], t[1] = o[1] + i[1], t[2] = o[2] + i[2], t
            }, n.rotateY = function (t, e, i, r) {
                var n = [],
                    o = [];
                return n[0] = e[0] - i[0], n[1] = e[1] - i[1], n[2] = e[2] - i[2], o[0] = n[2] * Math.sin(r) + n[0] * Math.cos(r), o[1] = n[1], o[2] = n[2] * Math.cos(r) - n[0] * Math.sin(r), t[0] = o[0] + i[0], t[1] = o[1] + i[1], t[2] = o[2] + i[2], t
            }, n.rotateZ = function (t, e, i, r) {
                var n = [],
                    o = [];
                return n[0] = e[0] - i[0], n[1] = e[1] - i[1], n[2] = e[2] - i[2], o[0] = n[0] * Math.cos(r) - n[1] * Math.sin(r), o[1] = n[0] * Math.sin(r) + n[1] * Math.cos(r), o[2] = n[2], t[0] = o[0] + i[0], t[1] = o[1] + i[1], t[2] = o[2] + i[2], t
            }, n.forEach = function () {
                var t = n.create();
                return function (e, i, r, n, o, s) {
                    var a, l;
                    for (i || (i = 3), r || (r = 0), l = n ? Math.min(n * i + r, e.length) : e.length, a = r; a < l; a += i) t[0] = e[a], t[1] = e[a + 1], t[2] = e[a + 2], o(t, t, s), e[a] = t[0], e[a + 1] = t[1], e[a + 2] = t[2];
                    return e
                }
            }(), n.angle = function (t, e) {
                var i = n.fromValues(t[0], t[1], t[2]),
                    r = n.fromValues(e[0], e[1], e[2]);
                n.normalize(i, i), n.normalize(r, r);
                var o = n.dot(i, r);
                return o > 1 ? 0 : o < -1 ? Math.PI : Math.acos(o)
            }, n.str = function (t) {
                return "vec3(" + t[0] + ", " + t[1] + ", " + t[2] + ")"
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = e[0],
                    a = e[1],
                    l = e[2];
                return Math.abs(i - s) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(n - a) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(o - l) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(l))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        11: [function (t, e, i) {
            var r = t("./common.js"),
                n = {};
            n.create = function () {
                var t = new r.ARRAY_TYPE(4);
                return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t
            }, n.clone = function (t) {
                var e = new r.ARRAY_TYPE(4);
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e
            }, n.fromValues = function (t, e, i, n) {
                var o = new r.ARRAY_TYPE(4);
                return o[0] = t, o[1] = e, o[2] = i, o[3] = n, o
            }, n.copy = function (t, e) {
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t
            }, n.set = function (t, e, i, r, n) {
                return t[0] = e, t[1] = i, t[2] = r, t[3] = n, t
            }, n.add = function (t, e, i) {
                return t[0] = e[0] + i[0], t[1] = e[1] + i[1], t[2] = e[2] + i[2], t[3] = e[3] + i[3], t
            }, n.subtract = function (t, e, i) {
                return t[0] = e[0] - i[0], t[1] = e[1] - i[1], t[2] = e[2] - i[2], t[3] = e[3] - i[3], t
            }, n.sub = n.subtract, n.multiply = function (t, e, i) {
                return t[0] = e[0] * i[0], t[1] = e[1] * i[1], t[2] = e[2] * i[2], t[3] = e[3] * i[3], t
            }, n.mul = n.multiply, n.divide = function (t, e, i) {
                return t[0] = e[0] / i[0], t[1] = e[1] / i[1], t[2] = e[2] / i[2], t[3] = e[3] / i[3], t
            }, n.div = n.divide, n.ceil = function (t, e) {
                return t[0] = Math.ceil(e[0]), t[1] = Math.ceil(e[1]), t[2] = Math.ceil(e[2]), t[3] = Math.ceil(e[3]), t
            }, n.floor = function (t, e) {
                return t[0] = Math.floor(e[0]), t[1] = Math.floor(e[1]), t[2] = Math.floor(e[2]), t[3] = Math.floor(e[3]), t
            }, n.min = function (t, e, i) {
                return t[0] = Math.min(e[0], i[0]), t[1] = Math.min(e[1], i[1]), t[2] = Math.min(e[2], i[2]), t[3] = Math.min(e[3], i[3]), t
            }, n.max = function (t, e, i) {
                return t[0] = Math.max(e[0], i[0]), t[1] = Math.max(e[1], i[1]), t[2] = Math.max(e[2], i[2]), t[3] = Math.max(e[3], i[3]), t
            }, n.round = function (t, e) {
                return t[0] = Math.round(e[0]), t[1] = Math.round(e[1]), t[2] = Math.round(e[2]), t[3] = Math.round(e[3]), t
            }, n.scale = function (t, e, i) {
                return t[0] = e[0] * i, t[1] = e[1] * i, t[2] = e[2] * i, t[3] = e[3] * i, t
            }, n.scaleAndAdd = function (t, e, i, r) {
                return t[0] = e[0] + i[0] * r, t[1] = e[1] + i[1] * r, t[2] = e[2] + i[2] * r, t[3] = e[3] + i[3] * r, t
            }, n.distance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1],
                    n = e[2] - t[2],
                    o = e[3] - t[3];
                return Math.sqrt(i * i + r * r + n * n + o * o)
            }, n.dist = n.distance, n.squaredDistance = function (t, e) {
                var i = e[0] - t[0],
                    r = e[1] - t[1],
                    n = e[2] - t[2],
                    o = e[3] - t[3];
                return i * i + r * r + n * n + o * o
            }, n.sqrDist = n.squaredDistance, n.length = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2],
                    n = t[3];
                return Math.sqrt(e * e + i * i + r * r + n * n)
            }, n.len = n.length, n.squaredLength = function (t) {
                var e = t[0],
                    i = t[1],
                    r = t[2],
                    n = t[3];
                return e * e + i * i + r * r + n * n
            }, n.sqrLen = n.squaredLength, n.negate = function (t, e) {
                return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = -e[3], t
            }, n.inverse = function (t, e) {
                return t[0] = 1 / e[0], t[1] = 1 / e[1], t[2] = 1 / e[2], t[3] = 1 / e[3], t
            }, n.normalize = function (t, e) {
                var i = e[0],
                    r = e[1],
                    n = e[2],
                    o = e[3],
                    s = i * i + r * r + n * n + o * o;
                return s > 0 && (s = 1 / Math.sqrt(s), t[0] = i * s, t[1] = r * s, t[2] = n * s, t[3] = o * s), t
            }, n.dot = function (t, e) {
                return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3]
            }, n.lerp = function (t, e, i, r) {
                var n = e[0],
                    o = e[1],
                    s = e[2],
                    a = e[3];
                return t[0] = n + r * (i[0] - n), t[1] = o + r * (i[1] - o), t[2] = s + r * (i[2] - s), t[3] = a + r * (i[3] - a), t
            }, n.random = function (t, e) {
                return e = e || 1, t[0] = r.RANDOM(), t[1] = r.RANDOM(), t[2] = r.RANDOM(), t[3] = r.RANDOM(), n.normalize(t, t), n.scale(t, t, e), t
            }, n.transformMat4 = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3];
                return t[0] = i[0] * r + i[4] * n + i[8] * o + i[12] * s, t[1] = i[1] * r + i[5] * n + i[9] * o + i[13] * s, t[2] = i[2] * r + i[6] * n + i[10] * o + i[14] * s, t[3] = i[3] * r + i[7] * n + i[11] * o + i[15] * s, t
            }, n.transformQuat = function (t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = i[0],
                    a = i[1],
                    l = i[2],
                    h = i[3],
                    u = h * r + a * o - l * n,
                    c = h * n + l * r - s * o,
                    p = h * o + s * n - a * r,
                    d = -s * r - a * n - l * o;
                return t[0] = u * h + d * -s + c * -l - p * -a, t[1] = c * h + d * -a + p * -s - u * -l, t[2] = p * h + d * -l + u * -a - c * -s, t[3] = e[3], t
            }, n.forEach = function () {
                var t = n.create();
                return function (e, i, r, n, o, s) {
                    var a, l;
                    for (i || (i = 4), r || (r = 0), l = n ? Math.min(n * i + r, e.length) : e.length, a = r; a < l; a += i) t[0] = e[a], t[1] = e[a + 1], t[2] = e[a + 2], t[3] = e[a + 3], o(t, t, s), e[a] = t[0], e[a + 1] = t[1], e[a + 2] = t[2], e[a + 3] = t[3];
                    return e
                }
            }(), n.str = function (t) {
                return "vec4(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")"
            }, n.exactEquals = function (t, e) {
                return t[0] === e[0] && t[1] === e[1] && t[2] === e[2] && t[3] === e[3]
            }, n.equals = function (t, e) {
                var i = t[0],
                    n = t[1],
                    o = t[2],
                    s = t[3],
                    a = e[0],
                    l = e[1],
                    h = e[2],
                    u = e[3];
                return Math.abs(i - a) <= r.EPSILON * Math.max(1, Math.abs(i), Math.abs(a)) && Math.abs(n - l) <= r.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - h) <= r.EPSILON * Math.max(1, Math.abs(o), Math.abs(h)) && Math.abs(s - u) <= r.EPSILON * Math.max(1, Math.abs(s), Math.abs(u))
            }, e.exports = n
        }, {
            "./common.js": 3
        }],
        12: [function (e, i, r) {
            ! function (e, r, n, o) {
                "use strict";

                function s(t, e, i) {
                    return setTimeout(d(t, i), e)
                }

                function a(t, e, i) {
                    return !!Array.isArray(t) && (l(t, i[e], i), !0)
                }

                function l(t, e, i) {
                    var r;
                    if (t)
                        if (t.forEach) t.forEach(e, i);
                        else if (t.length !== o)
                        for (r = 0; r < t.length;) e.call(i, t[r], r, t), r++;
                    else
                        for (r in t) t.hasOwnProperty(r) && e.call(i, t[r], r, t)
                }

                function h(t, e, i) {
                    for (var r = Object.keys(e), n = 0; n < r.length;)(!i || i && t[r[n]] === o) && (t[r[n]] = e[r[n]]), n++;
                    return t
                }

                function u(t, e) {
                    return h(t, e, !0)
                }

                function c(t) {
                    if (Object.create) return Object.create(t);
                    var e = function () {};
                    e.prototype = t;
                    var i = new e;
                    return e.prototype = null, i
                }

                function p(t, e, i) {
                    var r, n = e.prototype;
                    r = t.prototype = c(n), r.constructor = t, r._super = n, i && h(r, i)
                }

                function d(t, e) {
                    return function () {
                        return t.apply(e, arguments)
                    }
                }

                function f(t, e) {
                    return typeof t == dt ? t.apply(e ? e[0] || o : o, e) : t
                }

                function m(t, e) {
                    return t === o ? e : t
                }

                function v(t, e, i) {
                    l(x(e), function (e) {
                        t.addEventListener(e, i, !1)
                    })
                }

                function _(t, e, i) {
                    l(x(e), function (e) {
                        t.removeEventListener(e, i, !1)
                    })
                }

                function y(t, e) {
                    for (; t;) {
                        if (t == e) return !0;
                        t = t.parentNode
                    }
                    return !1
                }

                function g(t, e) {
                    return t.indexOf(e) > -1
                }

                function x(t) {
                    return t.trim().split(/\s+/g)
                }

                function M(t, e, i) {
                    if (t.indexOf && !i) return t.indexOf(e);
                    for (var r = 0; r < t.length;) {
                        if (i && t[r][i] == e || !i && t[r] === e) return r;
                        r++
                    }
                    return -1
                }

                function w(t) {
                    return Array.prototype.slice.call(t, 0)
                }

                function b(t, e, i) {
                    for (var r = [], n = [], o = 0; o < t.length;) {
                        var s = e ? t[o][e] : t[o];
                        M(n, s) < 0 && r.push(t[o]), n[o] = s, o++
                    }
                    return i && (r = e ? r.sort(function (t, i) {
                        return t[e] > i[e]
                    }) : r.sort()), r
                }

                function S(t, e) {
                    for (var i, r, n = e[0].toUpperCase() + e.slice(1), s = 0; s < ct.length;) {
                        if (i = ct[s], (r = i ? i + n : e) in t) return r;
                        s++
                    }
                    return o
                }

                function E() {
                    return _t++
                }

                function I(t) {
                    var i = t.ownerDocument || t;
                    return i.defaultView || i.parentWindow || e
                }

                function D(t, e) {
                    var i = this;
                    this.manager = t, this.callback = e, this.element = t.element,
                        this.target = t.options.inputTarget, this.domHandler = function (e) {
                            f(t.options.enable, [t]) && i.handler(e)
                        }, this.init()
                }

                function T(t) {
                    var e = t.options.inputClass;
                    return new(e || (xt ? B : Mt ? V : gt ? G : Y))(t, F)
                }

                function F(t, e, i) {
                    var r = i.pointers.length,
                        n = i.changedPointers.length,
                        o = e & bt && r - n == 0,
                        s = e & (Et | It) && r - n == 0;
                    i.isFirst = !!o, i.isFinal = !!s, o && (t.session = {}), i.eventType = e, L(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i
                }

                function L(t, e) {
                    var i = t.session,
                        r = e.pointers,
                        n = r.length;
                    i.firstInput || (i.firstInput = R(e)), n > 1 && !i.firstMultiple ? i.firstMultiple = R(e) : 1 === n && (i.firstMultiple = !1);
                    var o = i.firstInput,
                        s = i.firstMultiple,
                        a = s ? s.center : o.center,
                        l = e.center = P(r);
                    e.timeStamp = vt(), e.deltaTime = e.timeStamp - o.timeStamp, e.angle = O(a, l), e.distance = H(a, l), C(i, e), e.offsetDirection = k(e.deltaX, e.deltaY), e.scale = s ? q(s.pointers, r) : 1, e.rotation = s ? N(s.pointers, r) : 0, z(i, e);
                    var h = t.element;
                    y(e.srcEvent.target, h) && (h = e.srcEvent.target), e.target = h
                }

                function C(t, e) {
                    var i = e.center,
                        r = t.offsetDelta || {},
                        n = t.prevDelta || {},
                        o = t.prevInput || {};
                    e.eventType !== bt && o.eventType !== Et || (n = t.prevDelta = {
                        x: o.deltaX || 0,
                        y: o.deltaY || 0
                    }, r = t.offsetDelta = {
                        x: i.x,
                        y: i.y
                    }), e.deltaX = n.x + (i.x - r.x), e.deltaY = n.y + (i.y - r.y)
                }

                function z(t, e) {
                    var i, r, n, s, a = t.lastInterval || e,
                        l = e.timeStamp - a.timeStamp;
                    if (e.eventType != It && (l > wt || a.velocity === o)) {
                        var h = a.deltaX - e.deltaX,
                            u = a.deltaY - e.deltaY,
                            c = A(l, h, u);
                        r = c.x, n = c.y, i = mt(c.x) > mt(c.y) ? c.x : c.y, s = k(h, u), t.lastInterval = e
                    } else i = a.velocity, r = a.velocityX, n = a.velocityY, s = a.direction;
                    e.velocity = i, e.velocityX = r, e.velocityY = n, e.direction = s
                }

                function R(t) {
                    for (var e = [], i = 0; i < t.pointers.length;) e[i] = {
                        clientX: ft(t.pointers[i].clientX),
                        clientY: ft(t.pointers[i].clientY)
                    }, i++;
                    return {
                        timeStamp: vt(),
                        pointers: e,
                        center: P(e),
                        deltaX: t.deltaX,
                        deltaY: t.deltaY
                    }
                }

                function P(t) {
                    var e = t.length;
                    if (1 === e) return {
                        x: ft(t[0].clientX),
                        y: ft(t[0].clientY)
                    };
                    for (var i = 0, r = 0, n = 0; n < e;) i += t[n].clientX, r += t[n].clientY, n++;
                    return {
                        x: ft(i / e),
                        y: ft(r / e)
                    }
                }

                function A(t, e, i) {
                    return {
                        x: e / t || 0,
                        y: i / t || 0
                    }
                }

                function k(t, e) {
                    return t === e ? Dt : mt(t) >= mt(e) ? t > 0 ? Tt : Ft : e > 0 ? Lt : Ct
                }

                function H(t, e, i) {
                    i || (i = At);
                    var r = e[i[0]] - t[i[0]],
                        n = e[i[1]] - t[i[1]];
                    return Math.sqrt(r * r + n * n)
                }

                function O(t, e, i) {
                    i || (i = At);
                    var r = e[i[0]] - t[i[0]],
                        n = e[i[1]] - t[i[1]];
                    return 180 * Math.atan2(n, r) / Math.PI
                }

                function N(t, e) {
                    return O(e[1], e[0], kt) - O(t[1], t[0], kt)
                }

                function q(t, e) {
                    return H(e[0], e[1], kt) / H(t[0], t[1], kt)
                }

                function Y() {
                    this.evEl = Ot, qt ? this.evDoc = Nt : this.evWin = Nt, this.allow = !0, this.pressed = !1, D.apply(this, arguments)
                }

                function B() {
                    this.evEl = Xt, this.evWin = jt, D.apply(this, arguments), this.store = this.manager.session.pointerEvents = []
                }

                function X() {
                    this.evTarget = Wt, this.evWin = Gt, this.started = !1, D.apply(this, arguments)
                }

                function j(t, e) {
                    var i = w(t.touches),
                        r = w(t.changedTouches);
                    return e & (Et | It) && (i = b(i.concat(r), "identifier", !0)), [i, r]
                }

                function V() {
                    this.evTarget = Zt, this.targetIds = {}, D.apply(this, arguments)
                }

                function W(t, e) {
                    var i = w(t.touches),
                        r = this.targetIds;
                    if (e & (bt | St) && 1 === i.length) return r[i[0].identifier] = !0, [i, i];
                    var n, o, s = w(t.changedTouches),
                        a = [],
                        l = this.target;
                    if (o = i.filter(function (t) {
                            return y(t.target, l)
                        }), e === bt)
                        for (n = 0; n < o.length;) r[o[n].identifier] = !0, n++;
                    for (n = 0; n < s.length;) r[s[n].identifier] && a.push(s[n]), e & (Et | It) && delete r[s[n].identifier], n++;
                    return a.length ? [b(o.concat(a), "identifier", !0), a] : void 0
                }

                function G() {
                    D.apply(this, arguments);
                    var t = d(this.handler, this);
                    this.touch = new V(this.manager, t), this.mouse = new Y(this.manager, t)
                }

                function U(t, e) {
                    this.manager = t, this.set(e)
                }

                function Z(t) {
                    if (g(t, te)) return te;
                    var e = g(t, ee),
                        i = g(t, ie);
                    return e && i ? ee + " " + ie : e || i ? e ? ee : ie : g(t, Jt) ? Jt : $t
                }

                function K(t) {
                    this.id = E(), this.manager = null, this.options = u(t || {}, this.defaults), this.options.enable = m(this.options.enable, !0), this.state = re, this.simultaneous = {}, this.requireFail = []
                }

                function Q(t) {
                    return t & le ? "cancel" : t & se ? "end" : t & oe ? "move" : t & ne ? "start" : ""
                }

                function $(t) {
                    return t == Ct ? "down" : t == Lt ? "up" : t == Tt ? "left" : t == Ft ? "right" : ""
                }

                function J(t, e) {
                    var i = e.manager;
                    return i ? i.get(t) : t
                }

                function tt() {
                    K.apply(this, arguments)
                }

                function et() {
                    tt.apply(this, arguments), this.pX = null, this.pY = null
                }

                function it() {
                    tt.apply(this, arguments)
                }

                function rt() {
                    K.apply(this, arguments), this._timer = null, this._input = null
                }

                function nt() {
                    tt.apply(this, arguments)
                }

                function ot() {
                    tt.apply(this, arguments)
                }

                function st() {
                    K.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0
                }

                function at(t, e) {
                    return e = e || {}, e.recognizers = m(e.recognizers, at.defaults.preset), new lt(t, e)
                }

                function lt(t, e) {
                    e = e || {}, this.options = u(e, at.defaults), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.element = t, this.input = T(this), this.touchAction = new U(this, this.options.touchAction), ht(this, !0), l(e.recognizers, function (t) {
                        var e = this.add(new t[0](t[1]));
                        t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3])
                    }, this)
                }

                function ht(t, e) {
                    var i = t.element;
                    i.style && l(t.options.cssProps, function (t, r) {
                        i.style[S(i.style, r)] = e ? t : ""
                    })
                }

                function ut(t, e) {
                    var i = r.createEvent("Event");
                    i.initEvent(t, !0, !0), i.gesture = e, e.target.dispatchEvent(i)
                }
                var ct = ["", "webkit", "moz", "MS", "ms", "o"],
                    pt = r.createElement("div"),
                    dt = "function",
                    ft = Math.round,
                    mt = Math.abs,
                    vt = Date.now,
                    _t = 1,
                    yt = /mobile|tablet|ip(ad|hone|od)|android/i,
                    gt = "ontouchstart" in e,
                    xt = S(e, "PointerEvent") !== o,
                    Mt = gt && yt.test(navigator.userAgent),
                    wt = 25,
                    bt = 1,
                    St = 2,
                    Et = 4,
                    It = 8,
                    Dt = 1,
                    Tt = 2,
                    Ft = 4,
                    Lt = 8,
                    Ct = 16,
                    zt = Tt | Ft,
                    Rt = Lt | Ct,
                    Pt = zt | Rt,
                    At = ["x", "y"],
                    kt = ["clientX", "clientY"];
                D.prototype = {
                    handler: function () {},
                    init: function () {
                        this.evEl && v(this.element, this.evEl, this.domHandler), this.evTarget && v(this.target, this.evTarget, this.domHandler), this.evWin && v(I(this.element), this.evWin, this.domHandler), this.evDoc && v(r, this.evDoc, this.domHandler), this.evBody && v(r.body, this.evBody, this.domHandler)
                    },
                    destroy: function () {
                        this.evEl && _(this.element, this.evEl, this.domHandler), this.evTarget && _(this.target, this.evTarget, this.domHandler), this.evWin && _(I(this.element), this.evWin, this.domHandler), this.evDoc && _(r, this.evDoc, this.domHandler), this.evBody && _(r.body, this.evBody, this.domHandler)
                    }
                };
                var Ht = {
                        mousedown: bt,
                        mousemove: St,
                        mouseup: Et
                    },
                    Ot = "mousedown",
                    Nt = "mousemove mouseup",
                    qt = e.navigator.userAgent.indexOf("MSIE 8") > 0;
                p(Y, D, {
                    handler: function (t) {
                        var e = Ht[t.type],
                            i = 0;
                        qt && (i = 1), e & bt && t.button === i && (this.pressed = !0), e & St && t.button !== i && (e = Et), this.pressed && this.allow && (e & Et && (this.pressed = !1), this.callback(this.manager, e, {
                            pointers: [t],
                            changedPointers: [t],
                            pointerType: "mouse",
                            srcEvent: t
                        }))
                    }
                });
                var Yt = {
                        pointerdown: bt,
                        pointermove: St,
                        pointerup: Et,
                        pointercancel: It,
                        pointerout: It
                    },
                    Bt = {
                        2: "touch",
                        3: "pen",
                        4: "mouse",
                        5: "kinect"
                    },
                    Xt = "pointerdown",
                    jt = "pointermove pointerup pointercancel";
                e.MSPointerEvent && (Xt = "MSPointerDown", jt = "MSPointerMove MSPointerUp MSPointerCancel"), p(B, D, {
                    handler: function (t) {
                        var e = this.store,
                            i = !1,
                            r = t.type.toLowerCase().replace("ms", ""),
                            n = Yt[r],
                            o = Bt[t.pointerType] || t.pointerType,
                            s = "touch" == o,
                            a = M(e, t.pointerId, "pointerId");
                        n & bt && (0 === t.button || s) ? a < 0 && (e.push(t), a = e.length - 1) : n & (Et | It) && (i = !0), a < 0 || (e[a] = t, this.callback(this.manager, n, {
                            pointers: e,
                            changedPointers: [t],
                            pointerType: o,
                            srcEvent: t
                        }), i && e.splice(a, 1))
                    }
                });
                var Vt = {
                        touchstart: bt,
                        touchmove: St,
                        touchend: Et,
                        touchcancel: It
                    },
                    Wt = "touchstart",
                    Gt = "touchstart touchmove touchend touchcancel";
                p(X, D, {
                    handler: function (t) {
                        var e = Vt[t.type];
                        if (e === bt && (this.started = !0), this.started) {
                            var i = j.call(this, t, e);
                            e & (Et | It) && i[0].length - i[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
                                pointers: i[0],
                                changedPointers: i[1],
                                pointerType: "touch",
                                srcEvent: t
                            })
                        }
                    }
                });
                var Ut = {
                        touchstart: bt,
                        touchmove: St,
                        touchend: Et,
                        touchcancel: It
                    },
                    Zt = "touchstart touchmove touchend touchcancel";
                p(V, D, {
                    handler: function (t) {
                        var e = Ut[t.type],
                            i = W.call(this, t, e);
                        i && this.callback(this.manager, e, {
                            pointers: i[0],
                            changedPointers: i[1],
                            pointerType: "touch",
                            srcEvent: t
                        })
                    }
                }), p(G, D, {
                    handler: function (t, e, i) {
                        var r = "touch" == i.pointerType,
                            n = "mouse" == i.pointerType;
                        if (r) this.mouse.allow = !1;
                        else if (n && !this.mouse.allow) return;
                        e & (Et | It) && (this.mouse.allow = !0), this.callback(t, e, i)
                    },
                    destroy: function () {
                        this.touch.destroy(), this.mouse.destroy()
                    }
                });
                var Kt = S(pt.style, "touchAction"),
                    Qt = Kt !== o,
                    $t = "auto",
                    Jt = "manipulation",
                    te = "none",
                    ee = "pan-x",
                    ie = "pan-y";
                U.prototype = {
                    set: function (t) {
                        "compute" == t && (t = this.compute()), Qt && this.manager.element.style && (this.manager.element.style[Kt] = t), this.actions = t.toLowerCase().trim()
                    },
                    update: function () {
                        this.set(this.manager.options.touchAction)
                    },
                    compute: function () {
                        var t = [];
                        return l(this.manager.recognizers, function (e) {
                            f(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()))
                        }), Z(t.join(" "))
                    },
                    preventDefaults: function (t) {
                        if (!Qt) {
                            var e = t.srcEvent,
                                i = t.offsetDirection;
                            if (this.manager.session.prevented) return void e.preventDefault();
                            var r = this.actions,
                                n = g(r, te),
                                o = g(r, ie),
                                s = g(r, ee);
                            return n || o && i & zt || s && i & Rt ? this.preventSrc(e) : void 0
                        }
                    },
                    preventSrc: function (t) {
                        this.manager.session.prevented = !0, t.preventDefault()
                    }
                };
                var re = 1,
                    ne = 2,
                    oe = 4,
                    se = 8,
                    ae = se,
                    le = 16;
                K.prototype = {
                    defaults: {},
                    set: function (t) {
                        return h(this.options, t), this.manager && this.manager.touchAction.update(), this
                    },
                    recognizeWith: function (t) {
                        if (a(t, "recognizeWith", this)) return this;
                        var e = this.simultaneous;
                        return t = J(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this
                    },
                    dropRecognizeWith: function (t) {
                        return a(t, "dropRecognizeWith", this) ? this : (t = J(t, this), delete this.simultaneous[t.id], this)
                    },
                    requireFailure: function (t) {
                        if (a(t, "requireFailure", this)) return this;
                        var e = this.requireFail;
                        return t = J(t, this), -1 === M(e, t) && (e.push(t), t.requireFailure(this)), this
                    },
                    dropRequireFailure: function (t) {
                        if (a(t, "dropRequireFailure", this)) return this;
                        t = J(t, this);
                        var e = M(this.requireFail, t);
                        return e > -1 && this.requireFail.splice(e, 1), this
                    },
                    hasRequireFailures: function () {
                        return this.requireFail.length > 0
                    },
                    canRecognizeWith: function (t) {
                        return !!this.simultaneous[t.id]
                    },
                    emit: function (t) {
                        function e(e) {
                            i.manager.emit(i.options.event + (e ? Q(r) : ""), t)
                        }
                        var i = this,
                            r = this.state;
                        r < se && e(!0), e(), r >= se && e(!0)
                    },
                    tryEmit: function (t) {
                        if (this.canEmit()) return this.emit(t);
                        this.state = 32
                    },
                    canEmit: function () {
                        for (var t = 0; t < this.requireFail.length;) {
                            if (!(this.requireFail[t].state & (32 | re))) return !1;
                            t++
                        }
                        return !0
                    },
                    recognize: function (t) {
                        var e = h({}, t);
                        if (!f(this.options.enable, [this, e])) return this.reset(), void(this.state = 32);
                        this.state & (ae | le | 32) && (this.state = re), this.state = this.process(e), this.state & (ne | oe | se | le) && this.tryEmit(e)
                    },
                    process: function (t) {},
                    getTouchAction: function () {},
                    reset: function () {}
                }, p(tt, K, {
                    defaults: {
                        pointers: 1
                    },
                    attrTest: function (t) {
                        var e = this.options.pointers;
                        return 0 === e || t.pointers.length === e
                    },
                    process: function (t) {
                        var e = this.state,
                            i = t.eventType,
                            r = e & (ne | oe),
                            n = this.attrTest(t);
                        return r && (i & It || !n) ? e | le : r || n ? i & Et ? e | se : e & ne ? e | oe : ne : 32
                    }
                }), p(et, tt, {
                    defaults: {
                        event: "pan",
                        threshold: 10,
                        pointers: 1,
                        direction: Pt
                    },
                    getTouchAction: function () {
                        var t = this.options.direction,
                            e = [];
                        return t & zt && e.push(ie), t & Rt && e.push(ee), e
                    },
                    directionTest: function (t) {
                        var e = this.options,
                            i = !0,
                            r = t.distance,
                            n = t.direction,
                            o = t.deltaX,
                            s = t.deltaY;
                        return n & e.direction || (e.direction & zt ? (n = 0 === o ? Dt : o < 0 ? Tt : Ft, i = o != this.pX, r = Math.abs(t.deltaX)) : (n = 0 === s ? Dt : s < 0 ? Lt : Ct, i = s != this.pY, r = Math.abs(t.deltaY))), t.direction = n, i && r > e.threshold && n & e.direction
                    },
                    attrTest: function (t) {
                        return tt.prototype.attrTest.call(this, t) && (this.state & ne || !(this.state & ne) && this.directionTest(t))
                    },
                    emit: function (t) {
                        this.pX = t.deltaX, this.pY = t.deltaY;
                        var e = $(t.direction);
                        e && this.manager.emit(this.options.event + e, t), this._super.emit.call(this, t)
                    }
                }), p(it, tt, {
                    defaults: {
                        event: "pinch",
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function () {
                        return [te]
                    },
                    attrTest: function (t) {
                        return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & ne)
                    },
                    emit: function (t) {
                        if (this._super.emit.call(this, t), 1 !== t.scale) {
                            var e = t.scale < 1 ? "in" : "out";
                            this.manager.emit(this.options.event + e, t)
                        }
                    }
                }), p(rt, K, {
                    defaults: {
                        event: "press",
                        pointers: 1,
                        time: 500,
                        threshold: 5
                    },
                    getTouchAction: function () {
                        return [$t]
                    },
                    process: function (t) {
                        var e = this.options,
                            i = t.pointers.length === e.pointers,
                            r = t.distance < e.threshold,
                            n = t.deltaTime > e.time;
                        if (this._input = t, !r || !i || t.eventType & (Et | It) && !n) this.reset();
                        else if (t.eventType & bt) this.reset(), this._timer = s(function () {
                            this.state = ae, this.tryEmit()
                        }, e.time, this);
                        else if (t.eventType & Et) return ae;
                        return 32
                    },
                    reset: function () {
                        clearTimeout(this._timer)
                    },
                    emit: function (t) {
                        this.state === ae && (t && t.eventType & Et ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = vt(), this.manager.emit(this.options.event, this._input)))
                    }
                }), p(nt, tt, {
                    defaults: {
                        event: "rotate",
                        threshold: 0,
                        pointers: 2
                    },
                    getTouchAction: function () {
                        return [te]
                    },
                    attrTest: function (t) {
                        return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & ne)
                    }
                }), p(ot, tt, {
                    defaults: {
                        event: "swipe",
                        threshold: 10,
                        velocity: .65,
                        direction: zt | Rt,
                        pointers: 1
                    },
                    getTouchAction: function () {
                        return et.prototype.getTouchAction.call(this)
                    },
                    attrTest: function (t) {
                        var e, i = this.options.direction;
                        return i & (zt | Rt) ? e = t.velocity : i & zt ? e = t.velocityX : i & Rt && (e = t.velocityY), this._super.attrTest.call(this, t) && i & t.direction && t.distance > this.options.threshold && mt(e) > this.options.velocity && t.eventType & Et
                    },
                    emit: function (t) {
                        var e = $(t.direction);
                        e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t)
                    }
                }), p(st, K, {
                    defaults: {
                        event: "tap",
                        pointers: 1,
                        taps: 1,
                        interval: 300,
                        time: 250,
                        threshold: 2,
                        posThreshold: 10
                    },
                    getTouchAction: function () {
                        return [Jt]
                    },
                    process: function (t) {
                        var e = this.options,
                            i = t.pointers.length === e.pointers,
                            r = t.distance < e.threshold,
                            n = t.deltaTime < e.time;
                        if (this.reset(), t.eventType & bt && 0 === this.count) return this.failTimeout();
                        if (r && n && i) {
                            if (t.eventType != Et) return this.failTimeout();
                            var o = !this.pTime || t.timeStamp - this.pTime < e.interval,
                                a = !this.pCenter || H(this.pCenter, t.center) < e.posThreshold;
                            this.pTime = t.timeStamp, this.pCenter = t.center, a && o ? this.count += 1 : this.count = 1, this._input = t;
                            if (0 === this.count % e.taps) return this.hasRequireFailures() ? (this._timer = s(function () {
                                this.state = ae, this.tryEmit()
                            }, e.interval, this), ne) : ae
                        }
                        return 32
                    },
                    failTimeout: function () {
                        return this._timer = s(function () {
                            this.state = 32
                        }, this.options.interval, this), 32
                    },
                    reset: function () {
                        clearTimeout(this._timer)
                    },
                    emit: function () {
                        this.state == ae && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input))
                    }
                }), at.VERSION = "2.0.4", at.defaults = {
                    domEvents: !1,
                    touchAction: "compute",
                    enable: !0,
                    inputTarget: null,
                    inputClass: null,
                    preset: [[nt, {
                        enable: !1
                    }], [it, {
                        enable: !1
                    }, ["rotate"]], [ot, {
                        direction: zt
                    }], [et, {
                        direction: zt
                    }, ["swipe"]], [st], [st, {
                        event: "doubletap",
                        taps: 2
                    }, ["tap"]], [rt]],
                    cssProps: {
                        userSelect: "none",
                        touchSelect: "none",
                        touchCallout: "none",
                        contentZooming: "none",
                        userDrag: "none",
                        tapHighlightColor: "rgba(0,0,0,0)"
                    }
                };
                lt.prototype = {
                    set: function (t) {
                        return h(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this
                    },
                    stop: function (t) {
                        this.session.stopped = t ? 2 : 1
                    },
                    recognize: function (t) {
                        var e = this.session;
                        if (!e.stopped) {
                            this.touchAction.preventDefaults(t);
                            var i, r = this.recognizers,
                                n = e.curRecognizer;
                            (!n || n && n.state & ae) && (n = e.curRecognizer = null);
                            for (var o = 0; o < r.length;) i = r[o], 2 === e.stopped || n && i != n && !i.canRecognizeWith(n) ? i.reset() : i.recognize(t), !n && i.state & (ne | oe | se) && (n = e.curRecognizer = i), o++
                        }
                    },
                    get: function (t) {
                        if (t instanceof K) return t;
                        for (var e = this.recognizers, i = 0; i < e.length; i++)
                            if (e[i].options.event == t) return e[i];
                        return null
                    },
                    add: function (t) {
                        if (a(t, "add", this)) return this;
                        var e = this.get(t.options.event);
                        return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t
                    },
                    remove: function (t) {
                        if (a(t, "remove", this)) return this;
                        var e = this.recognizers;
                        return t = this.get(t), e.splice(M(e, t), 1), this.touchAction.update(), this
                    },
                    on: function (t, e) {
                        var i = this.handlers;
                        return l(x(t), function (t) {
                            i[t] = i[t] || [], i[t].push(e)
                        }), this
                    },
                    off: function (t, e) {
                        var i = this.handlers;
                        return l(x(t), function (t) {
                            e ? i[t].splice(M(i[t], e), 1) : delete i[t]
                        }), this
                    },
                    emit: function (t, e) {
                        this.options.domEvents && ut(t, e);
                        var i = this.handlers[t] && this.handlers[t].slice();
                        if (i && i.length) {
                            e.type = t, e.preventDefault = function () {
                                e.srcEvent.preventDefault()
                            };
                            for (var r = 0; r < i.length;) i[r](e), r++
                        }
                    },
                    destroy: function () {
                        this.element && ht(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null
                    }
                }, h(at, {
                    INPUT_START: bt,
                    INPUT_MOVE: St,
                    INPUT_END: Et,
                    INPUT_CANCEL: It,
                    STATE_POSSIBLE: re,
                    STATE_BEGAN: ne,
                    STATE_CHANGED: oe,
                    STATE_ENDED: se,
                    STATE_RECOGNIZED: ae,
                    STATE_CANCELLED: le,
                    STATE_FAILED: 32,
                    DIRECTION_NONE: Dt,
                    DIRECTION_LEFT: Tt,
                    DIRECTION_RIGHT: Ft,
                    DIRECTION_UP: Lt,
                    DIRECTION_DOWN: Ct,
                    DIRECTION_HORIZONTAL: zt,
                    DIRECTION_VERTICAL: Rt,
                    DIRECTION_ALL: Pt,
                    Manager: lt,
                    Input: D,
                    TouchAction: U,
                    TouchInput: V,
                    MouseInput: Y,
                    PointerEventInput: B,
                    TouchMouseInput: G,
                    SingleTouchInput: X,
                    Recognizer: K,
                    AttrRecognizer: tt,
                    Tap: st,
                    Pan: et,
                    Swipe: ot,
                    Pinch: it,
                    Rotate: nt,
                    Press: rt,
                    on: v,
                    off: _,
                    each: l,
                    merge: u,
                    extend: h,
                    inherit: p,
                    bindFn: d,
                    prefixed: S
                }), typeof t == dt && t.amd ? t(function () {
                    return at
                }) : void 0 !== i && i.exports ? i.exports = at : e.Hammer = at
            }(window, document)
        }, {}],
        13: [function (t, e, i) {
            "use strict";

            function r() {}

            function n(t) {
                for (var e in r.prototype) r.prototype.hasOwnProperty(e) && (t.prototype[e] = r.prototype[e])
            }
            r.prototype.addEventListener = function (t, e) {
                var i = this.__events = this.__events || {};
                (i[t] = i[t] || []).push(e)
            }, r.prototype.removeEventListener = function (t, e) {
                var i = this.__events = this.__events || {},
                    r = i[t];
                if (r) {
                    var n = r.indexOf(e);
                    n >= 0 && r.splice(n, 1)
                }
            }, r.prototype.emit = function () {
                var t = this.__events = this.__events || {},
                    e = arguments[0],
                    i = t[e];
                if (i)
                    for (var r = 0; r < i.length; r++) {
                        var n = i[r];
                        n.apply(this, arguments)
                    }
            }, e.exports = n
        }, {}],
        14: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this._equals = t, this._hash = e, this._queue = [], this._visited = new n(t, e), this._neighborsFun = null, this._exploreFun = null
            }
            var n = t("./collections/Set");
            r.prototype.start = function (t, e, i) {
                if (this._neighborsFun || this._exploreFun) throw new Error("GraphFinder: search already in progress");
                this.reset(), this._neighborsFun = e, this._exploreFun = i, this._queue.push(t)
            }, r.prototype.reset = function () {
                this._neighborsFun = null, this._exploreFun = null, this._queue.length = 0, this._visited.clear()
            }, r.prototype.next = function () {
                var t = this._queue,
                    e = this._visited,
                    i = this._neighborsFun,
                    r = this._exploreFun;
                if (!i || !r) throw new Error("GraphFinder: no search in progress");
                for (; t.length > 0;) {
                    var n = this._queue.shift();
                    if (!e.has(n) && r(n)) {
                        e.add(n);
                        for (var o = i(n), s = 0; s < o.length; s++) t.push(o[s]);
                        return n
                    }
                }
                return this.reset(), null
            }, e.exports = r
        }, {
            "./collections/Set": 33
        }],
        15: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, n) {
                if (n = n || {}, n.perspective = n.perspective || {}, n.perspective.extraRotations = null != n.perspective.extraRotations ? n.perspective.extraRotations : "", n.perspective.radius && !o()) throw new Error("Hotspot cannot not be embedded in sphere for lack of browser support");
                this._domElement = t, this._parentDomElement = e, this._view = i, this._params = {}, this._perspective = {}, this.setPosition(r), this._parentDomElement.appendChild(this._domElement), this.setPerspective(n.perspective), this._visible = !0, this._position = {
                    x: 0,
                    y: 0
                }
            }
            var n = t("minimal-event-emitter"),
                o = t("./support/Css"),
                s = t("./positionAbsolutely"),
                a = t("./util/dom").setTransform;
            n(r), r.prototype.destroy = function () {
                this._parentDomElement.removeChild(this._domElement), this._domElement = null, this._parentDomElement = null, this._params = null, this._view = null, this._position = null, this._visible = !1
            }, r.prototype.domElement = function () {
                return this._domElement
            }, r.prototype.position = function () {
                return this._params
            }, r.prototype.setPosition = function (t) {
                for (var e in t) this._params[e] = t[e];
                this._update()
            }, r.prototype.perspective = function () {
                return this._perspective
            }, r.prototype.setPerspective = function (t) {
                for (var e in t) this._perspective[e] = t[e];
                this._update()
            }, r.prototype.show = function () {
                this._visible || (this._visible = !0, this._update())
            }, r.prototype.hide = function () {
                this._visible && (this._visible = !1, this._update())
            }, r.prototype._update = function () {
                var t, e, i = this._domElement,
                    r = this._params,
                    n = this._position,
                    o = !1;
                if (this._visible) {
                    var s = this._view;
                    this._perspective.radius ? (o = !0, this._setEmbeddedPosition(s, r)) : (s.coordinatesToScreen(r, n), t = n.x, e = n.y, null != t && null != e && (o = !0, this._setPosition(t, e)))
                }
                o ? (i.style.display = "block", i.style.position = "absolute") : (i.style.display = "none", i.style.position = "")
            }, r.prototype._setEmbeddedPosition = function (t, e) {
                var i = t.coordinatesToPerspectiveTransform(e, this._perspective.radius, this._perspective.extraRotations);
                a(this._domElement, i)
            }, r.prototype._setPosition = function (t, e) {
                s(this._domElement, t, e)
            }, e.exports = r
        }, {
            "./positionAbsolutely": 58,
            "./support/Css": 84,
            "./util/dom": 101,
            "minimal-event-emitter": 13
        }],
        16: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, n) {
                n = n || {}, this._parentDomElement = t, this._stage = e, this._view = i, this._renderLoop = r, this._rect = n.rect, this._hotspotContainerWrapper = document.createElement("div"), h(this._hotspotContainerWrapper), f(this._hotspotContainerWrapper, "none"), this._parentDomElement.appendChild(this._hotspotContainerWrapper), this._hotspotContainer = document.createElement("div"), h(this._hotspotContainer), f(this._hotspotContainer, "all"), this._hotspotContainerWrapper.appendChild(this._hotspotContainer), this._hotspots = [], this._visible = !0, this._supported = !0, this._isVisible = !0, this._positionAndSize = {}, this._hasRect = null, this._newPositionAndSize = {}, this._updateHandler = this._update.bind(this), this._renderLoop.addEventListener("afterRender", this._updateHandler)
            }
            var n = t("minimal-event-emitter"),
                o = t("./Hotspot"),
                s = t("./calcRect"),
                a = t("./positionAbsolutely"),
                l = t("./support/cssPointerEvents"),
                h = t("./util/dom").setAbsolute,
                u = t("./util/dom").setOverflowHidden,
                c = t("./util/dom").setOverflowVisible,
                p = t("./util/dom").setNullSize,
                d = t("./util/dom").setPixelSize,
                f = t("./util/dom").setWithVendorPrefix("pointer-events");
            n(r), r.prototype.destroy = function () {
                for (; this._hotspots.length;) this.destroyHotspot(this._hotspots[0]);
                this._parentDomElement.removeChild(this._hotspotContainerWrapper), this._renderLoop.removeEventListener("afterRender", this._updateHandler), this._parentDomElement = null, this._stage = null, this._view = null, this._renderLoop = null, this._rect = null
            }, r.prototype.domElement = function () {
                return this._hotspotContainer
            }, r.prototype.setRect = function (t) {
                this._rect = t
            }, r.prototype.rect = function () {
                return this._rect
            }, r.prototype.createHotspot = function (t, e, i) {
                e = e || {};
                var r = new o(t, this._hotspotContainer, this._view, e, i);
                return this._hotspots.push(r), r._update(), this.emit("hotspotsChange"), r
            }, r.prototype.hasHotspot = function (t) {
                return this._hotspots.indexOf(t) >= 0
            }, r.prototype.listHotspots = function () {
                return [].concat(this._hotspots)
            }, r.prototype.destroyHotspot = function (t) {
                var e = this._hotspots.indexOf(t);
                if (e < 0) throw new Error("No such hotspot");
                this._hotspots.splice(e, 1), t.destroy(), this.emit("hotspotsChange")
            }, r.prototype.hide = function () {
                this._visible = !1, this._updateVisibility()
            }, r.prototype.show = function () {
                this._visible = !0, this._updateVisibility()
            }, r.prototype._updateVisibility = function () {
                var t = this._visible && this._supported;
                t && !this._isVisible ? (this._hotspotContainerWrapper.style.display = "block", this._isVisible = !0) : !t && this._isVisible && (this._hotspotContainerWrapper.style.display = "none", this._isVisible = !1)
            }, r.prototype._update = function () {
                this._updatePositionAndSize();
                for (var t = 0; t < this._hotspots.length; t++) this._hotspots[t]._update()
            }, r.prototype._updatePositionAndSize = function () {
                this._rect ? !l() && this._hotspots.length > 0 ? (console.warn("HotspotContainer: this browser does not support using effects.rect with hotspots. Hotspots will be hidden."), this._supported = !1) : (s(this._stage.width(), this._stage.height(), this._rect, this._newPositionAndSize), this._setPositionAndSizeWithRect(this._newPositionAndSize), this._supported = !0) : (this._setPositionAndSizeWithoutRect(), this._supported = !0), this._updateVisibility()
            }, r.prototype._setPositionAndSizeWithRect = function (t) {
                var e = this._hotspotContainerWrapper;
                !0 !== this._hasRect && u(e), !0 === this._hasRect && t.left === this._positionAndSize.left && t.top === this._positionAndSize.top || a(e, t.left, t.top), !0 === this._hasRect && +t.width === this._positionAndSize.width && t.height === this._positionAndSize.height || d(e, t.width, t.height), this._positionAndSize.left = t.left, this._positionAndSize.top = t.top, this._positionAndSize.width = t.width, this._positionAndSize.height = t.height, this._hasRect = !0
            }, r.prototype._setPositionAndSizeWithoutRect = function () {
                !1 !== this._hasRect && (a(this._hotspotContainerWrapper, 0, 0), p(this._hotspotContainerWrapper), c(this._hotspotContainerWrapper), this._hasRect = !1)
            }, e.exports = r
        }, {
            "./Hotspot": 15,
            "./calcRect": 29,
            "./positionAbsolutely": 58,
            "./support/cssPointerEvents": 87,
            "./util/dom": 101,
            "minimal-event-emitter": 13
        }],
        17: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, n, o) {
                o = o || {};
                var s = this;
                this._stage = t, this._source = e, this._geometry = i, this._view = r, this._textureStore = n, this._effects = o.effects || {}, this._fixedLevelIndex = null, this._viewChangeHandler = function () {
                    s.emit("viewChange", s.view())
                }, this._view.addEventListener("change", this._viewChangeHandler), this._textureStoreChangeHandler = function () {
                    s.emit("textureStoreChange", s.textureStore())
                }, this._textureStore.addEventListener("textureLoad", this._textureStoreChangeHandler), this._textureStore.addEventListener("textureError", this._textureStoreChangeHandler), this._textureStore.addEventListener("textureInvalid", this._textureStoreChangeHandler)
            }
            var n = t("minimal-event-emitter"),
                o = t("./util/extend");
            n(r), r.prototype.destroy = function () {
                this._view.removeEventListener("change", this._viewChangeHandler), this._textureStore.removeEventListener("textureLoad", this._textureStoreChangeHandler), this._textureStore.removeEventListener("textureError", this._textureStoreChangeHandler), this._textureStore.removeEventListener("textureInvalid", this._textureStoreChangeHandler), this._stage = null, this._source = null, this._geometry = null, this._view = null, this._textureStore = null, this._fixedLevelIndex = null, this._effects = null, this._viewChangeHandler = null, this._textureStoreChangeHandler = null
            }, r.prototype.stage = function () {
                return this._stage
            }, r.prototype.source = function () {
                return this._source
            }, r.prototype.geometry = function () {
                return this._geometry
            }, r.prototype.view = function () {
                return this._view
            }, r.prototype.textureStore = function () {
                return this._textureStore
            }, r.prototype.effects = function () {
                return this._effects
            }, r.prototype.setEffects = function (t) {
                this._effects = t, this.emit("effectsChange", this._effects)
            }, r.prototype.mergeEffects = function (t) {
                o(this._effects, t), this.emit("effectsChange", this._effects)
            }, r.prototype.fixedLevel = function () {
                return this._fixedLevelIndex
            }, r.prototype.setFixedLevel = function (t) {
                if (t !== this._fixedLevelIndex) {
                    if (null != t && (t >= this._geometry.levelList.length || t < 0)) throw new Error("Level index out of range: " + t);
                    this._fixedLevelIndex = t, this.emit("fixedLevelChange", this._fixedLevelIndex)
                }
            }, r.prototype._selectLevel = function () {
                return null != this._fixedLevelIndex ? this._geometry.levelList[this._fixedLevelIndex] : this._view.selectLevel(this._geometry.selectableLevelList)
            }, r.prototype.visibleTiles = function (t) {
                var e = this._selectLevel();
                return this._geometry.visibleTiles(this._view, e, t)
            }, r.prototype.pinLevel = function (t) {
                for (var e = this._geometry.levelList[t], i = this._geometry.levelTiles(e), r = 0; r < i.length; r++) this._textureStore.pin(i[r])
            }, r.prototype.unpinLevel = function (t) {
                for (var e = this._geometry.levelList[t], i = this._geometry.levelTiles(e), r = 0; r < i.length; r++) this._textureStore.unpin(i[r])
            }, r.prototype.pinFirstLevel = function () {
                return this.pinLevel(0)
            }, r.prototype.unpinFirstLevel = function () {
                return this.unpinLevel(0)
            }, e.exports = r
        }, {
            "./util/extend": 102,
            "minimal-event-emitter": 13
        }],
        18: [function (t, e, i) {
            "use strict";

            function r(t) {
                this.constructor.super_.apply(this, arguments), this.message = t
            }
            t("./util/inherits")(r, Error), e.exports = r
        }, {
            "./util/inherits": 104
        }],
        19: [function (t, e, i) {
            "use strict";

            function r(t) {
                var e = this;
                this._stage = t, this._running = !1, this._rendering = !1, this._requestHandle = null, this._boundLoop = this._loop.bind(this), this._renderInvalidHandler = function () {
                    e._rendering || e.renderOnNextFrame()
                }, this._stage.addEventListener("renderInvalid", this._renderInvalidHandler)
            }
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {
                this.stop(), this._stage.removeEventListener("renderInvalid", this._renderInvalidHandler), this._stage = null, this._running = null, this._rendering = null, this._requestHandle = null, this._boundLoop = null
            }, r.prototype.stage = function () {
                return this._stage
            }, r.prototype.start = function () {
                this._running = !0, this.renderOnNextFrame()
            }, r.prototype.stop = function () {
                this._requestHandle && (window.cancelAnimationFrame(this._requestHandle), this._requestHandle = null), this._running = !1
            }, r.prototype.renderOnNextFrame = function () {
                this._running && !this._requestHandle && (this._requestHandle = window.requestAnimationFrame(this._boundLoop))
            }, r.prototype._loop = function () {
                if (!this._running) throw new Error("Render loop running while in stopped state");
                this._requestHandle = null, this._rendering = !0, this.emit("beforeRender"), this._rendering = !1, this._stage.render(), this.emit("afterRender")
            }, e.exports = r
        }, {
            "minimal-event-emitter": 13
        }],
        20: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this._viewer = t, this._view = e, this._layers = [], this._hotspotContainer = new s(t._controlContainer, t.stage(), this._view, t.renderLoop()), this._movement = null, this._movementStartTime = null, this._movementStep = null, this._movementParams = null, this._movementCallback = null, this._updateMovementHandler = this._updateMovement.bind(this), this._updateHotspotContainerHandler = this._updateHotspotContainer.bind(this), this._viewer.addEventListener("sceneChange", this._updateHotspotContainerHandler), this._viewChangeHandler = this.emit.bind(this, "viewChange"), this._view.addEventListener("change", this._viewChangeHandler), this._updateHotspotContainer()
            }
            var n = t("./Layer"),
                o = t("./TextureStore"),
                s = t("./HotspotContainer"),
                a = t("minimal-event-emitter"),
                l = t("./util/clock"),
                h = t("./util/noop"),
                u = t("./util/type"),
                c = t("./util/defaults");
            a(r), r.prototype.destroy = function () {
                    this._view.removeEventListener("change", this._viewChangeHandler), this._viewer.removeEventListener("sceneChange", this._updateHotspotContainerHandler), this._movement && this.stopMovement(), this._hotspotContainer.destroy(), this.destroyAllLayers(), this._movement = null, this._viewer = null, this._layers = null, this._view = null, this._hotspotContainer = null
                }, r.prototype.hotspotContainer = function () {
                    return this._hotspotContainer
                }, r.prototype.layer = function () {
                    return this._layers[0]
                }, r.prototype.listLayers = function () {
                    return [].concat(this._layers)
                }, r.prototype.view = function () {
                    return this._view
                }, r.prototype.viewer = function () {
                    return this._viewer
                }, r.prototype.visible = function () {
                    return this._viewer.scene() === this
                }, r.prototype.createLayer = function (t) {
                    t = t || {};
                    var e = t.textureStoreOpts || {},
                        i = t.layerOpts || {},
                        r = t.source,
                        s = t.geometry,
                        a = this._view,
                        l = this._viewer.stage(),
                        h = new o(s, r, l, e),
                        u = new n(l, r, s, a, h, i);
                    return this._layers.push(u), t.pinFirstLevel && u.pinFirstLevel(), this.emit("layerChange"), u
                }, r.prototype.destroyLayer = function (t) {
                    var e = this._layers.indexOf(t);
                    if (e < 0) throw new Error("No such layer in scene");
                    this._layers.splice(e, 1), this.emit("layerChange"), t.textureStore().destroy(), t.destroy()
                }, r.prototype.destroyAllLayers = function () {
                    for (; this._layers.length > 0;) this.destroyLayer(this._layers[0])
                }, r.prototype.switchTo = function (t, e) {
                    return this._viewer.switchScene(this, t, e)
                }, r.prototype.lookTo = function (t, e, i) {
                    if (e = e || {}, i = i || h, "object" !== u(t)) throw new Error("Target view parameters must be an object");
                    var r = null != e.transitionDuration ? e.transitionDuration : 1e3,
                        n = null == e.shortest || e.shortest,
                        o = this._view,
                        s = o.parameters(),
                        a = {};
                    c(a, t), c(a, s), n && o.normalizeToClosest && o.normalizeToClosest(a, a);
                    var l = function (t) {
                            return (t *= 2) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1)
                        },
                        p = function () {
                            var t = !1;
                            return function (e, i) {
                                if (i >= r && t) return null;
                                var n = Math.min(i / r, 1);
                                for (var o in e) {
                                    var h = s[o],
                                        u = a[o];
                                    e[o] = h + l(n) * (u - h)
                                }
                                return t = i >= r, e
                            }
                        },
                        d = this._viewer.controls().enabled();
                    this._viewer.controls().disable(), this.startMovement(p, function () {
                        d && this._viewer.controls().enable(), i()
                    })
                }, r.prototype.startMovement = function (t, e) {
                    var i = this._viewer.renderLoop();
                    this._movement && this.stopMovement();
                    var r = t();
                    if ("function" != typeof r) throw new Error("Bad movement");
                    this._movement = t, this._movementStep = r, this._movementStartTime = l(), this._movementParams = {}, this._movementCallback = e, i.addEventListener("beforeRender", this._updateMovementHandler), i.renderOnNextFrame()
                },
                r.prototype.stopMovement = function () {
                    var t = this._viewer.renderLoop();
                    this._movementCallback && this._movementCallback(), t.removeEventListener("beforeRender", this._updateMovementHandler), this._movement = null, this._movementStep = null, this._movementStartTime = null, this._movementParams = null, this._movementCallback = null
                }, r.prototype.movement = function () {
                    return this._movement
                }, r.prototype._updateMovement = function () {
                    if (!this._movement) throw new Error("Should not call update");
                    var t = this._viewer.renderLoop(),
                        e = this._view,
                        i = l() - this._movementStartTime,
                        r = this._movementStep,
                        n = this._movementParams;
                    n = e.parameters(n), n = r(n, i), null == n ? this.stopMovement() : (e.setParameters(n), t.renderOnNextFrame())
                }, r.prototype._updateHotspotContainer = function () {
                    this.visible() ? this._hotspotContainer.show() : this._hotspotContainer.hide()
                }, e.exports = r
        }, {
            "./HotspotContainer": 16,
            "./Layer": 17,
            "./TextureStore": 21,
            "./util/clock": 92,
            "./util/defaults": 97,
            "./util/noop": 107,
            "./util/type": 115,
            "minimal-event-emitter": 13
        }],
        21: [function (t, e, i) {
            "use strict";

            function r() {}

            function n(t, e) {
                var i = this;
                i._id = _++, i._store = t, i._tile = e, i._asset = null, i._texture = null, i._changeHandler = function () {
                    t.emit("textureInvalid", e)
                };
                var n = t.source(),
                    o = t.stage(),
                    s = n.loadAsset.bind(n),
                    a = o.createTexture.bind(o),
                    l = p(c(s), a);
                f && console.log("loading", i._id, i._tile), i._cancel = l(o, e, function (t, e, n, o) {
                    if (i._cancel = null, t) return n && n.destroy(), o && o.destroy(), void(t instanceof r ? (i._store.emit("textureCancel", i._tile), f && console.log("cancel", i._id, i._tile)) : (i._store.emit("textureError", i._tile, t), f && console.log("error", i._id, i._tile)));
                    i._texture = o, n.dynamic ? (i._asset = n, n.addEventListener("change", i._changeHandler)) : n.destroy(), i._store.emit("textureLoad", i._tile), f && console.log("load", i._id, i._tile)
                })
            }

            function o(t, e, i, r) {
                r = u(r || {}, v), this._source = e, this._stage = i;
                var n = t.TileClass;
                this._clientPhase = m, this._clientCounter = 0, this._itemMap = new s(n.equals, n.hash), this._visible = new a(n.equals, n.hash), this._previouslyVisible = new l(n.equals, n.hash, r.previouslyVisibleCacheSize), this._pinMap = new s(n.equals, n.hash), this._newVisible = new a(n.equals, n.hash), this._noLongerVisible = [], this._visibleAgain = [], this._evicted = []
            }
            var s = t("./collections/Map"),
                a = t("./collections/Set"),
                l = t("./collections/LruSet"),
                h = t("minimal-event-emitter"),
                u = t("./util/defaults"),
                c = t("./util/retry"),
                p = t("./util/chain"),
                d = t("./util/inherits"),
                f = "undefined" != typeof MARZIPANODEBUG && MARZIPANODEBUG.textureStore,
                m = "idle",
                v = {
                    previouslyVisibleCacheSize: 32
                },
                _ = 0;
            d(r, Error), n.prototype.asset = function () {
                return this._asset
            }, n.prototype.texture = function () {
                return this._texture
            }, n.prototype.destroy = function () {
                var t = this,
                    e = t._id,
                    i = t._store,
                    n = t._tile,
                    o = t._asset,
                    s = t._texture,
                    a = t._cancel;
                if (a) return void a(new r("Texture load cancelled"));
                o && (o.removeEventListener("change", t._changeHandler), o.destroy()), s && s.destroy(), i.emit("textureUnload", n), f && console.log("unload", e, n), t._changeHandler = null, t._asset = null, t._texture = null, t._tile = null, t._store = null, t._id = null
            }, h(n), h(o), o.prototype.destroy = function () {
                this.clear(), this._source = null, this._stage = null, this._itemMap = null, this._visible = null, this._previouslyVisible = null, this._pinMap = null, this._newVisible = null, this._noLongerVisible = null, this._visibleAgain = null, this._evicted = null
            }, o.prototype.stage = function () {
                return this._stage
            }, o.prototype.source = function () {
                return this._source
            }, o.prototype.clear = function () {
                var t = this;
                t._evicted.length = 0, t._itemMap.each(function (e) {
                    t._evicted.push(e)
                }), t._evicted.forEach(function (e) {
                    t._unloadTile(e)
                }), t._itemMap.clear(), t._visible.clear(), t._previouslyVisible.clear(), t._pinMap.clear(), t._newVisible.clear(), t._noLongerVisible.length = 0, t._visibleAgain.length = 0, t._evicted.length = 0
            }, o.prototype.clearNotPinned = function () {
                var t = this;
                t._evicted.length = 0, t._itemMap.each(function (e) {
                    t._pinMap.has(e) || t._evicted.push(e)
                }), t._evicted.forEach(function (e) {
                    t._unloadTile(e)
                }), t._visible.clear(), t._previouslyVisible.clear(), t._evicted.length = 0
            }, o.prototype.startFrame = function () {
                if (this._clientPhase !== m && "start" !== this._clientPhase) throw new Error("TextureStore: startFrame called out of sequence");
                this._clientPhase = "start", this._clientCounter++, this._newVisible.clear()
            }, o.prototype.markTile = function (t) {
                if ("start" !== this._clientPhase) throw new Error("TextureStore: markTile called out of sequence");
                var e = this._itemMap.get(t),
                    i = e && e.texture(),
                    r = e && e.asset();
                i && r && i.refresh(t, r), this._newVisible.add(t)
            }, o.prototype.endFrame = function () {
                if ("start" !== this._clientPhase && "end" !== this._clientPhase) throw new Error("TextureStore: endFrame called out of sequence");
                this._clientPhase = "end", --this._clientCounter || (this._update(), this._clientPhase = m)
            }, o.prototype._update = function () {
                var t = this;
                t._noLongerVisible.length = 0, t._visible.each(function (e) {
                    t._newVisible.has(e) || t._noLongerVisible.push(e)
                }), t._visibleAgain.length = 0, t._newVisible.each(function (e) {
                    t._previouslyVisible.has(e) && t._visibleAgain.push(e)
                }), t._visibleAgain.forEach(function (e) {
                    t._previouslyVisible.remove(e)
                }), t._evicted.length = 0, t._noLongerVisible.forEach(function (e) {
                    var i = t._itemMap.get(e);
                    if (i && i.texture()) {
                        var r = t._previouslyVisible.add(e);
                        null != r && t._evicted.push(r)
                    } else i && t._unloadTile(e)
                }), t._evicted.forEach(function (e) {
                    t._pinMap.has(e) || t._unloadTile(e)
                }), t._newVisible.each(function (e) {
                    t._itemMap.get(e) || t._loadTile(e)
                });
                var e = t._visible;
                t._visible = t._newVisible, t._newVisible = e, t._noLongerVisible.length = 0, t._visibleAgain.length = 0, t._evicted.length = 0
            }, o.prototype._loadTile = function (t) {
                if (this._itemMap.has(t)) throw new Error("TextureStore: loading texture already in cache");
                var e = new n(this, t);
                this._itemMap.set(t, e)
            }, o.prototype._unloadTile = function (t) {
                var e = this._itemMap.del(t);
                if (!e) throw new Error("TextureStore: unloading texture not in cache");
                e.destroy()
            }, o.prototype.asset = function (t) {
                var e = this._itemMap.get(t);
                return e ? e.asset() : null
            }, o.prototype.texture = function (t) {
                var e = this._itemMap.get(t);
                return e ? e.texture() : null
            }, o.prototype.pin = function (t) {
                var e = (this._pinMap.get(t) || 0) + 1;
                return this._pinMap.set(t, e), this._itemMap.has(t) || this._loadTile(t), e
            }, o.prototype.unpin = function (t) {
                var e = this._pinMap.get(t);
                if (!e) throw new Error("TextureStore: unpin when not pinned");
                return e--, e > 0 ? this._pinMap.set(t, e) : (this._pinMap.del(t), this._visible.has(t) || this._previouslyVisible.has(t) || this._unloadTile(t)), e
            }, o.prototype.query = function (t) {
                var e = this._itemMap.get(t),
                    i = this._pinMap.get(t) || 0;
                return {
                    visible: this._visible.has(t),
                    previouslyVisible: this._previouslyVisible.has(t),
                    hasAsset: null != e && null != e.asset(),
                    hasTexture: null != e && null != e.texture(),
                    pinned: 0 !== i,
                    pinCount: i
                }
            }, e.exports = o
        }, {
            "./collections/LruSet": 31,
            "./collections/Map": 32,
            "./collections/Set": 33,
            "./util/chain": 90,
            "./util/defaults": 97,
            "./util/inherits": 104,
            "./util/retry": 112,
            "minimal-event-emitter": 13
        }],
        22: [function (t, e, i) {
            "use strict";

            function r(t) {
                t = o(t || {}, a), this._duration = t.duration, this._startTime = null, this._handle = null, this._check = this._check.bind(this)
            }
            var n = t("minimal-event-emitter"),
                o = t("./util/defaults"),
                s = t("./util/clock"),
                a = {
                    duration: Infinity
                };
            n(r), r.prototype.start = function () {
                this._startTime = s(), null == this._handle && this._duration < Infinity && this._setup(this._duration)
            }, r.prototype.started = function () {
                return null != this._startTime
            }, r.prototype.stop = function () {
                this._startTime = null, null != this._handle && (clearTimeout(this._handle), this._handle = null)
            }, r.prototype._setup = function (t) {
                this._handle = setTimeout(this._check, t)
            }, r.prototype._teardown = function () {
                clearTimeout(this._handle), this._handle = null
            }, r.prototype._check = function () {
                var t = s(),
                    e = t - this._startTime,
                    i = this._duration - e;
                this._teardown(), i <= 0 ? (this.emit("timeout"), this._startTime = null) : i < Infinity && this._setup(i)
            }, r.prototype.duration = function () {
                return this._duration
            }, r.prototype.setDuration = function (t) {
                this._duration = t, null != this._startTime && this._check()
            }, e.exports = r
        }, {
            "./util/clock": 92,
            "./util/defaults": 97,
            "minimal-event-emitter": 13
        }],
        23: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                e = e || {}, this._domElement = t, m(t);
                var i;
                if (e.stageType) {
                    if (!(i = S[e.stageType])) throw new Error("Unknown stage type: " + e.stageType)
                } else {
                    for (var r = 0; r < E.length; r++)
                        if (E[r].supported()) {
                            i = E[r];
                            break
                        }
                    if (!i) throw new Error("None of the stage types are supported")
                }
                this._stage = new i(e.stage), f(this._stage), this._domElement.appendChild(this._stage.domElement()), this._controlContainer = document.createElement("div"), v(this._controlContainer), _(this._controlContainer), b.ios && this._controlContainer.addEventListener("touchmove", function (t) {
                    t.preventDefault()
                });
                var n = document.createElement("div");
                v(n), _(n), y(n), this._controlContainer.appendChild(n), t.appendChild(this._controlContainer), this._size = {}, this.updateSize(), this._updateSizeListener = this.updateSize.bind(this), window.addEventListener("resize", this._updateSizeListener), this._renderLoop = new s(this._stage), this._controls = new a, this._controlMethods = d(this._controls, this._controlContainer, e.controls), this._controls.attach(this._renderLoop), this._hammerManagerTouch = w.get(this._controlContainer, "touch"), this._hammerManagerMouse = w.get(this._controlContainer, "mouse"), this._dragCursor = new M(this._controls, "mouseViewDrag", t, e.cursors && e.cursors.drag || {}), this._renderLoop.start(), this._scenes = [], this._currentScene = null, this._replacedScene = null, this._cancelCurrentTween = null, this._layerChangeHandler = this._updateSceneLayers.bind(this), this._viewChangeHandler = this.emit.bind(this, "viewChange"), this._idleTimer = new h, this._idleTimer.start(), this._resetIdleTimerHandler = this._resetIdleTimer.bind(this), this.addEventListener("viewChange", this._resetIdleTimerHandler), this._enterIdleHandler = this._enterIdle.bind(this), this._idleTimer.addEventListener("timeout", this._enterIdleHandler), this._leaveIdleHandler = this._leaveIdle.bind(this), this._controls.addEventListener("active", this._leaveIdleHandler), this.addEventListener("sceneChange", this._leaveIdleHandler), this._idleMovement = null
            }

            function n(t, e, i) {
                e.listLayers().forEach(function (e) {
                    e.mergeEffects({
                        opacity: t
                    })
                }), e._hotspotContainer.domElement().style.opacity = t
            }
            var o = t("minimal-event-emitter"),
                s = t("./RenderLoop"),
                a = t("./controls/Controls"),
                l = (t("./Layer"), t("./TextureStore"), t("./Scene")),
                h = t("./Timer"),
                u = t("./stages/WebGl"),
                c = t("./stages/Css"),
                p = t("./stages/Flash"),
                d = t("./controls/registerDefaultControls"),
                f = t("./renderers/registerDefaultRenderers"),
                m = t("./util/dom").setOverflowHidden,
                v = t("./util/dom").setAbsolute,
                _ = t("./util/dom").setFullSize,
                y = t("./util/dom").setBlocking,
                g = t("./util/tween"),
                x = t("./util/noop"),
                M = (t("./util/type"), t("./controls/ControlCursor")),
                w = t("./controls/HammerGestures"),
                b = t("bowser"),
                S = {
                    webgl: u,
                    css: c,
                    flash: p
                },
                E = [u, c, p];
            o(r), r.prototype.destroy = function () {
                window.removeEventListener("resize", this._updateSizeListener), this._updateSizeListener = null, this._size = null, this._currentScene && this._removeSceneEventListeners(this._currentScene), this._currentScene = null, this._replacedScene && this._removeSceneEventListeners(this._replacedScene), this._replacedScene = null, this._layerChangeHandler = null, this._viewChangeHandler = null, this._dragCursor.destroy(), this._dragCursor = null;
                for (var t in this._controlMethods) this._controlMethods[t].destroy();
                for (this._controlMethods = null; this._scenes.length;) this.destroyScene(this._scenes[0]);
                this._scenes = null, this._domElement.removeChild(this._stage.domElement()), this._stage.destroy(), this._stage = null, this._renderLoop.destroy(), this._renderLoop = null, this._controls.destroy(), this._controls = null, this._cancelCurrentTween && (this._cancelCurrentTween(), this._cancelCurrentTween = null), this._domElement = null, this._controlContainer = null
            }, r.prototype.updateSize = function () {
                var t = this._size;
                t.width = this._domElement.clientWidth, t.height = this._domElement.clientHeight, this._stage.setSize(t)
            }, r.prototype.stage = function () {
                return this._stage
            }, r.prototype.renderLoop = function () {
                return this._renderLoop
            }, r.prototype.controls = function () {
                return this._controls
            }, r.prototype.domElement = function () {
                return this._domElement
            }, r.prototype.createScene = function (t) {
                t = t || {};
                var e = this.createEmptyScene({
                    view: t.view
                });
                e.createLayer({
                    source: t.source,
                    geometry: t.geometry,
                    pinFirstLevel: t.pinFirstLevel,
                    textureStoreOpts: t.textureStoreOpts,
                    layerOpts: t.layerOpts
                });
                return e
            }, r.prototype.createEmptyScene = function (t) {
                t = t || {};
                var e = new l(this, t.view);
                return this._scenes.push(e), e
            }, r.prototype._updateSceneLayers = function () {
                var t = this._stage,
                    e = this._currentScene,
                    i = this._replacedScene,
                    r = t.listLayers(),
                    n = [];
                if (i && (n = n.concat(i.listLayers())), e && (n = n.concat(e.listLayers())), 1 !== Math.abs(r.length - n.length)) throw new Error("Stage and scene out of sync");
                if (n.length < r.length)
                    for (var o = 0; o < r.length; o++) {
                        var s = r[o];
                        if (n.indexOf(s) < 0) {
                            this._removeLayerFromStage(s);
                            break
                        }
                    }
                if (n.length > r.length)
                    for (var o = 0; o < n.length; o++) {
                        var s = n[o];
                        r.indexOf(s) < 0 && this._addLayerToStage(s, o)
                    }
            }, r.prototype._addLayerToStage = function (t, e) {
                t.pinFirstLevel(), this._stage.addLayer(t, e)
            }, r.prototype._removeLayerFromStage = function (t) {
                this._stage.removeLayer(t), t.unpinFirstLevel(), t.textureStore().clearNotPinned()
            }, r.prototype._addSceneEventListeners = function (t) {
                t.addEventListener("layerChange", this._layerChangeHandler), t.addEventListener("viewChange", this._viewChangeHandler)
            }, r.prototype._removeSceneEventListeners = function (t) {
                t.removeEventListener("layerChange", this._layerChangeHandler), t.removeEventListener("viewChange", this._viewChangeHandler)
            }, r.prototype.destroyScene = function (t) {
                var e = this._scenes.indexOf(t);
                if (e < 0) throw new Error("No such scene in viewer");
                if (this._currentScene === t) {
                    this._removeSceneEventListeners(t);
                    for (var i = t.listLayers(), r = 0; r < i.length; r++) this._removeLayerFromStage(i[r]);
                    this._cancelCurrentTween && (this._cancelCurrentTween(), this._cancelCurrentTween = null), this._currentScene = null, this.emit("sceneChange")
                }
                if (this._replacedScene === t) {
                    this._removeSceneEventListeners(t);
                    for (var i = t.listLayers(), r = 0; r < i.length; r++) this._removeLayerFromStage(i[r]);
                    this._replacedScene = null
                }
                this._scenes.splice(e, 1), t.destroy()
            }, r.prototype.destroyAllScenes = function () {
                for (; this._scenes.length > 0;) this.destroyScene(this._scenes[0])
            }, r.prototype.hasScene = function (t) {
                return this._scenes.indexOf(t) >= 0
            }, r.prototype.listScenes = function () {
                return [].concat(this._scenes)
            }, r.prototype.scene = function () {
                return this._currentScene
            }, r.prototype.view = function () {
                var t = this._currentScene;
                return t ? t.view() : null
            }, r.prototype.lookTo = function (t, e, i) {
                var r = this._currentScene;
                r && r.lookTo(t, e, i)
            }, r.prototype.startMovement = function (t, e) {
                var i = this._currentScene;
                i && i.startMovement(t, e)
            }, r.prototype.stopMovement = function () {
                var t = this._currentScene;
                t && t.stopMovement()
            }, r.prototype.setIdleMovement = function (t, e) {
                this._idleTimer.setDuration(t), this._idleMovement = e
            }, r.prototype.breakIdleMovement = function () {
                this._leaveIdle(), this._resetIdleTimer()
            }, r.prototype._resetIdleTimer = function () {
                this._idleTimer.start()
            }, r.prototype._enterIdle = function () {
                var t = this._currentScene,
                    e = this._idleMovement;
                t && e && t.startMovement(e)
            }, r.prototype._leaveIdle = function () {
                var t = this._currentScene;
                t && t.movement() === this._idleMovement && t.stopMovement()
            };
            r.prototype.switchScene = function (t, e, i) {
                function r(e) {
                    d(e, t, l)
                }

                function o() {
                    if (s._replacedScene) {
                        s._removeSceneEventListeners(s._replacedScene), h = s._replacedScene.listLayers();
                        for (var t = 0; t < h.length; t++) s._removeLayerFromStage(h[t]);
                        s._replacedScene = null
                    }
                    s._cancelCurrentTween = null, i()
                }
                var s = this;
                e = e || {}, i = i || x;
                var a = this._stage,
                    l = this._currentScene;
                if (l === t) return void i();
                if (this._scenes.indexOf(t) < 0) throw new Error("No such scene in viewer");
                this._cancelCurrentTween && (this._cancelCurrentTween(), this._cancelCurrentTween = null);
                var h = l ? l.listLayers() : [],
                    u = t.listLayers(),
                    c = a.listLayers();
                if (l && (c.length !== h.length || c.length > 1 && c[0] != h[0])) throw new Error("Stage not in sync with viewer");
                for (var p = null != e.transitionDuration ? e.transitionDuration : 1e3, d = null != e.transitionUpdate ? e.transitionUpdate : n, u = t.listLayers(), f = 0; f < u.length; f++) this._addLayerToStage(u[f]);
                this._cancelCurrentTween = g(p, r, o), this._currentScene = t, this._replacedScene = l, this.emit("sceneChange"), this.emit("viewChange"), this._addSceneEventListeners(t)
            }, e.exports = r
        }, {
            "./Layer": 17,
            "./RenderLoop": 19,
            "./Scene": 20,
            "./TextureStore": 21,
            "./Timer": 22,
            "./controls/ControlCursor": 38,
            "./controls/Controls": 39,
            "./controls/HammerGestures": 43,
            "./controls/registerDefaultControls": 50,
            "./renderers/registerDefaultRenderers": 70,
            "./stages/Css": 77,
            "./stages/Flash": 78,
            "./stages/WebGl": 81,
            "./util/dom": 101,
            "./util/noop": 107,
            "./util/tween": 114,
            "./util/type": 115,
            bowser: 1,
            "minimal-event-emitter": 13
        }],
        24: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                e = e || {}, this._opts = e, this._element = t, this._timestamp = 1, this._lastUsedTime = null
            }
            t("minimal-event-emitter")(r), r.prototype.element = function () {
                return this._element
            }, r.prototype.width = function () {
                return this._element.width
            }, r.prototype.height = function () {
                return this._element.height
            }, r.prototype.dynamic = !0, r.prototype.timestamp = function () {
                return this._timestamp
            }, r.prototype.changed = function () {
                this._timestamp++, this.emit("change")
            }, r.prototype.destroy = function () {
                this._opts.unload && this._opts.unload()
            }, e.exports = r
        }, {
            "minimal-event-emitter": 13
        }],
        25: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this._flashElement = t, this._imageId = e
            }
            r.prototype.element = function () {
                return this._imageId
            }, r.prototype.timestamp = function () {
                return 0
            }, r.prototype.dynamic = !1, r.prototype.destroy = function () {
                var t = this._flashElement,
                    e = this._imageId;
                t.unloadImage(e), this._flashElement = null, this._imageId = null
            }, e.exports = r
        }, {}],
        26: [function (t, e, i) {
            "use strict";

            function r(t) {
                this._element = t
            }
            var n = t("../util/noop");
            r.prototype.element = function () {
                return this._element
            }, r.prototype.width = function () {
                return this._element.width
            }, r.prototype.height = function () {
                return this._element.height
            }, r.prototype.timestamp = function () {
                return 0
            }, r.prototype.dynamic = !1, r.prototype.destroy = n, e.exports = r
        }, {
            "../util/noop": 107
        }],
        27: [function (t, e, i) {
            "use strict";

            function r(t) {
                this._element = t
            }
            var n = t("../util/noop");
            r.prototype.element = function () {
                return this._element
            }, r.prototype.width = function () {
                return this._element.naturalWidth
            }, r.prototype.height = function () {
                return this._element.naturalHeight
            }, r.prototype.timestamp = function () {
                return 0
            }, r.prototype.dynamic = !1, r.prototype.destroy = n, e.exports = r
        }, {
            "../util/noop": 107
        }],
        28: [function (t, e, i) {
            "use strict";

            function r(t) {
                t = n(t || {}, o);
                var e = t.yawSpeed,
                    i = t.pitchSpeed,
                    r = t.fovSpeed,
                    s = t.yawAccel,
                    a = t.pitchAccel,
                    l = t.fovAccel,
                    h = t.targetPitch,
                    u = t.targetFov;
                return function () {
                    var t, n, o, c, p = 0,
                        d = 0,
                        f = 0,
                        m = 0,
                        v = 0,
                        _ = 0,
                        y = 0;
                    return function (g, x) {
                        if (t = (x - p) / 1e3, v = Math.min(d + t * s, e), n = v * t, g.yaw = g.yaw + n, null != h && g.pitch !== h) {
                            var M = .5 * f * f / a;
                            _ = Math.abs(h - g.pitch) > M ? Math.min(f + t * a, i) : Math.max(f - t * a, 0), o = _ * t, h < g.pitch && (g.pitch = Math.max(h, g.pitch - o)), h > g.pitch && (g.pitch = Math.min(h, g.pitch + o))
                        }
                        if (null != u && g.fov !== h) {
                            var w = .5 * m * m / l;
                            y = Math.abs(u - g.fov) > w ? Math.min(m + t * l, r) : Math.max(m - t * l, 0), c = y * t, u < g.fov && (g.fov = Math.max(u, g.fov - c)), u > g.fov && (g.fov = Math.min(u, g.fov + c))
                        }
                        return p = x, d = v, f = _, m = y, g
                    }
                }
            }
            var n = t("./util/defaults"),
                o = {
                    yawSpeed: .1,
                    pitchSpeed: .1,
                    fovSpeed: .1,
                    yawAccel: .01,
                    pitchAccel: .01,
                    fovAccel: .01,
                    targetPitch: 0,
                    targetFov: null
                };
            e.exports = r
        }, {
            "./util/defaults": 97
        }],
        29: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r) {
                r = r || {};
                var n;
                n = null != i && null != i.absoluteWidth ? i.absoluteWidth : null != i && null != i.relativeWidth ? i.relativeWidth * t : t;
                var o;
                o = i && null != i.absoluteHeight ? i.absoluteHeight : null != i && null != i.relativeHeight ? i.relativeHeight * e : e;
                var s;
                s = null != i && null != i.absoluteX ? i.absoluteX : null != i && null != i.relativeX ? i.relativeX * t : 0;
                var a;
                return a = null != i && null != i.absoluteY ? i.absoluteY : null != i && null != i.relativeY ? i.relativeY * e : 0, r.height = o, r.width = n, r.left = s, r.top = a, r.right = s + n, r.bottom = a + o, r.totalWidth = t, r.totalHeight = e, r
            }
            e.exports = r
        }, {}],
        30: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                if ("function" != typeof t) throw new Error("LruMap: bad equals function");
                if (this._equals = t, "function" != typeof e) throw new Error("LruMap: bad hash function");
                if (this._hash = e, "number" != typeof i || isNaN(i) || i < 0) throw new Error("LruMap: bad maximum size");
                this._maxsize = i, this._keys = [], this._values = [], this._pivot = 0
            }
            var n = t("../util/mod");
            r.prototype._modulus = function () {
                return this._maxsize > this._keys.length ? this._keys.length + 1 : this._maxsize
            }, r.prototype.get = function (t) {
                for (var e = 0; e < this._keys.length; e++) {
                    var i = this._keys[e];
                    if (this._equals(t, i)) {
                        return this._values[e]
                    }
                }
                return null
            }, r.prototype.set = function (t, e) {
                var i = null,
                    r = !1;
                if (0 === this._maxsize) return t;
                for (var o = 0; o < this._keys.length; o++) {
                    var s = this._keys[o];
                    if (this._equals(t, s)) {
                        for (var a = o, l = this._modulus(); a !== this._pivot;) {
                            var h = n(a + 1, l);
                            this._keys[a] = this._keys[h], this._values[a] = this._values[h], a = h
                        }
                        r = !0;
                        break
                    }
                }
                return r || (i = this._pivot < this._keys.length ? this._keys[this._pivot] : null), this._keys[this._pivot] = t, this._values[this._pivot] = e, this._pivot = n(this._pivot + 1, this._modulus()), i
            }, r.prototype.del = function (t) {
                for (var e = 0; e < this._keys.length; e++) {
                    var i = this._keys[e];
                    if (this._equals(t, i)) {
                        for (var r = this._values[e], o = e; o < this._keys.length - 1; o++) this._keys[o] = this._keys[o + 1], this._values[o] = this._values[o + 1];
                        return this._keys.length = this._keys.length - 1, this._values.length = this._values.length - 1, e < this._pivot && (this._pivot = n(this._pivot - 1, this._modulus())), r
                    }
                }
                return null
            }, r.prototype.has = function (t) {
                for (var e = 0; e < this._keys.length; e++) {
                    var i = this._keys[e];
                    if (this._equals(t, i)) return !0
                }
                return !1
            }, r.prototype.size = function () {
                return this._keys.length
            }, r.prototype.clear = function () {
                this._keys.length = 0, this._values.length = 0, this._pivot = 0
            }, r.prototype.each = function (t) {
                for (var e = 0, i = 0; i < this._keys.length; i++) {
                    t(this._keys[i], this._values[i]), e += 1
                }
                return e
            }, e.exports = r
        }, {
            "../util/mod": 106
        }],
        31: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                if ("function" != typeof t) throw new Error("LruSet: bad equals function");
                if (this._equals = t, "function" != typeof e) throw new Error("LruSet: bad hash function");
                if (this._hash = e, "number" != typeof i || isNaN(i) || i < 0) throw new Error("LruSet: bad maximum size");
                this._maxsize = i, this._items = [], this._pivot = 0
            }
            var n = t("../util/mod");
            r.prototype._modulus = function () {
                return this._maxsize > this._items.length ? this._items.length + 1 : this._maxsize
            }, r.prototype.add = function (t) {
                var e = null,
                    i = !1;
                if (0 === this._maxsize) return t;
                for (var r = 0; r < this._items.length; r++) {
                    var o = this._items[r];
                    if (this._equals(t, o)) {
                        for (var s = r, a = this._modulus(); s !== this._pivot;) {
                            var l = n(s + 1, a);
                            this._items[s] = this._items[l], s = l
                        }
                        i = !0;
                        break
                    }
                }
                return i || (e = this._pivot < this._items.length ? this._items[this._pivot] : null), this._items[this._pivot] = t, this._pivot = n(this._pivot + 1, this._modulus()), e
            }, r.prototype.remove = function (t) {
                for (var e = 0; e < this._items.length; e++) {
                    var i = this._items[e];
                    if (this._equals(t, i)) {
                        for (var r = e; r < this._items.length - 1; r++) this._items[r] = this._items[r + 1];
                        return this._items.length = this._items.length - 1, e < this._pivot && (this._pivot = n(this._pivot - 1, this._modulus())), i
                    }
                }
                return null
            }, r.prototype.has = function (t) {
                for (var e = 0; e < this._items.length; e++) {
                    var i = this._items[e];
                    if (this._equals(t, i)) return !0
                }
                return !1
            }, r.prototype.size = function () {
                return this._items.length
            }, r.prototype.clear = function () {
                this._items.length = 0, this._pivot = 0
            }, r.prototype.each = function (t) {
                for (var e = 0, i = 0; i < this._items.length; i++) {
                    t(this._items[i]), e += 1
                }
                return e
            }, e.exports = r
        }, {
            "../util/mod": 106
        }],
        32: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                if ("function" != typeof t) throw new Error("Map: bad equals function");
                if (this._equals = t, "function" != typeof e) throw new Error("Map: bad hash function");
                if (this._hash = e, null != i) {
                    if ("number" != typeof i || isNaN(i) || i < 1) throw new Error("Map: bad number of buckets");
                    this._nbuckets = i
                } else this._nbuckets = n;
                this._keyBuckets = [], this._valBuckets = [];
                for (var r = 0; r < this._nbuckets; r++) this._keyBuckets.push([]), this._valBuckets.push([])
            }
            var n = 32;
            r.prototype._hashmod = function (t) {
                return this._hash(t) % this._nbuckets
            }, r.prototype.get = function (t) {
                for (var e = this._hashmod(t), i = this._keyBuckets[e], r = 0; r < i.length; r++) {
                    var n = i[r];
                    if (this._equals(t, n)) {
                        return this._valBuckets[e][r]
                    }
                }
                return null
            }, r.prototype.set = function (t, e) {
                for (var i = this._hashmod(t), r = this._keyBuckets[i], n = this._valBuckets[i], o = 0; o < r.length; o++) {
                    var s = r[o];
                    if (this._equals(t, s)) {
                        var a = n[o];
                        return r[o] = t, n[o] = e, a
                    }
                }
                return r.push(t), n.push(e), null
            }, r.prototype.del = function (t) {
                for (var e = this._hashmod(t), i = this._keyBuckets[e], r = this._valBuckets[e], n = 0; n < i.length; n++) {
                    var o = i[n];
                    if (this._equals(t, o)) {
                        for (var s = r[n], a = n; a < i.length - 1; a++) i[a] = i[a + 1], r[a] = r[a + 1];
                        return i.length = i.length - 1, r.length = r.length - 1, s
                    }
                }
                return null
            }, r.prototype.has = function (t) {
                for (var e = this._hashmod(t), i = this._keyBuckets[e], r = 0; r < i.length; r++) {
                    var n = i[r];
                    if (this._equals(t, n)) return !0
                }
                return !1
            }, r.prototype.size = function () {
                for (var t = 0, e = 0; e < this._nbuckets; e++) {
                    t += this._keyBuckets[e].length
                }
                return t
            }, r.prototype.clear = function () {
                for (var t = 0; t < this._nbuckets; t++) {
                    var e = this._keyBuckets[t],
                        i = this._valBuckets[t];
                    e.length = 0, i.length = 0
                }
            }, r.prototype.each = function (t) {
                for (var e = 0, i = 0; i < this._nbuckets; i++)
                    for (var r = this._keyBuckets[i], n = this._valBuckets[i], o = 0; o < r.length; o++) {
                        var s = r[o],
                            a = n[o];
                        t(s, a), e += 1
                    }
                return e
            }, e.exports = r
        }, {}],
        33: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                if ("function" != typeof t) throw new Error("Set: bad equals function");
                if (this._equals = t, "function" != typeof e) throw new Error("Set: bad hash function");
                if (this._hash = e, null != i) {
                    if ("number" != typeof i || isNaN(i) || i < 1) throw new Error("Set: bad number of buckets");
                    this._nbuckets = i
                } else this._nbuckets = n;
                this._buckets = [];
                for (var r = 0; r < this._nbuckets; r++) this._buckets.push([])
            }
            var n = 32;
            r.prototype._hashmod = function (t) {
                return this._hash(t) % this._nbuckets
            }, r.prototype.add = function (t) {
                for (var e = this._hashmod(t), i = this._buckets[e], r = 0; r < i.length; r++) {
                    var n = i[r];
                    if (this._equals(t, n)) return i[r] = t, n
                }
                return i.push(t), null
            }, r.prototype.remove = function (t) {
                for (var e = this._hashmod(t), i = this._buckets[e], r = 0; r < i.length; r++) {
                    var n = i[r];
                    if (this._equals(t, n)) {
                        for (var o = r; o < i.length - 1; o++) i[o] = i[o + 1];
                        return i.length = i.length - 1, n
                    }
                }
                return null
            }, r.prototype.has = function (t) {
                for (var e = this._hashmod(t), i = this._buckets[e], r = 0; r < i.length; r++) {
                    var n = i[r];
                    if (this._equals(t, n)) return !0
                }
                return !1
            }, r.prototype.size = function () {
                for (var t = 0, e = 0; e < this._nbuckets; e++) {
                    t += this._buckets[e].length
                }
                return t
            }, r.prototype.clear = function () {
                for (var t = 0; t < this._nbuckets; t++) {
                    this._buckets[t].length = 0
                }
            }, r.prototype.each = function (t) {
                for (var e = 0, i = 0; i < this._nbuckets; i++)
                    for (var r = this._buckets[i], n = 0; n < r.length; n++) {
                        var o = r[n];
                        t(o), e += 1
                    }
                return e
            }, e.exports = r
        }, {}],
        34: [function (t, e, i) {
            "use strict";

            function r(t) {
                this._concurrency = t && t.concurrency || 1, this._paused = t && !!t.paused || !1, this._pool = [];
                for (var e = 0; e < this._concurrency; e++) this._pool.push(new n(t));
                this._next = 0
            }
            var n = t("./WorkQueue"),
                o = t("../util/mod");
            r.prototype.length = function () {
                for (var t = 0, e = 0; e < this._pool.length; e++) t += this._pool[e].length();
                return t
            }, r.prototype.push = function (t, e) {
                var i = this._next,
                    r = this._pool[i].push(t, e);
                return this._next = o(this._next + 1, this._concurrency), r
            }, r.prototype.pause = function () {
                if (!this._paused) {
                    this._paused = !0;
                    for (var t = 0; t < this._concurrency; t++) this._pool[t].pause()
                }
            }, r.prototype.resume = function () {
                if (this._paused) {
                    this._paused = !1;
                    for (var t = 0; t < this._concurrency; t++) this._pool[t].resume()
                }
            }, e.exports = r
        }, {
            "../util/mod": 106,
            "./WorkQueue": 35
        }],
        35: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this.fn = t, this.cb = e, this.cfn = null
            }

            function n(t) {
                this._queue = [], this._delay = t && t.delay || 0, this._paused = t && !!t.paused || !1, this._currentTask = null, this._lastFinished = null
            }
            var o = t("../util/clock");
            n.prototype.length = function () {
                return this._queue.length
            }, n.prototype.push = function (t, e) {
                var i = new r(t, e),
                    n = this._cancel.bind(this, i);
                return this._queue.push(i), this._next(), n
            }, n.prototype.pause = function () {
                this._paused || (this._paused = !0)
            }, n.prototype.resume = function () {
                this._paused && (this._paused = !1, this._next())
            }, n.prototype._start = function (t) {
                if (this._currentTask) throw new Error("WorkQueue: called start while running task");
                this._currentTask = t;
                var e = this._finish.bind(this, t);
                if (t.cfn = t.fn(e), "function" != typeof t.cfn) throw new Error("WorkQueue: function is not cancellable")
            }, n.prototype._finish = function (t) {
                var e = Array.prototype.slice.call(arguments, 1);
                if (this._currentTask !== t) throw new Error("WorkQueue: called finish on wrong task");
                t.cb.apply(null, e), this._currentTask = null, this._lastFinished = o(), this._next()
            }, n.prototype._cancel = function (t) {
                var e = Array.prototype.slice.call(arguments, 1);
                if (this._currentTask === t) t.cfn.apply(null, e);
                else {
                    var i = this._queue.indexOf(t);
                    i >= 0 && (this._queue.splice(i, 1), t.cb.apply(null, e))
                }
            }, n.prototype._next = function () {
                if (!this._paused && this._queue.length && !this._currentTask) {
                    if (null != this._lastFinished) {
                        var t = o() - this._lastFinished,
                            e = this._delay - t;
                        if (e > 0) return void setTimeout(this._next.bind(this), e)
                    }
                    var i = this._queue.shift();
                    this._start(i)
                }
            }, e.exports = n
        }, {
            "../util/clock": 92
        }],
        36: [function (t, e, i) {
            "use strict";

            function r(t) {
                var e = t || {};
                return e.colorOffset = e.colorOffset || a.create(), e.colorMatrix = e.colorMatrix || l.create(), e
            }

            function n(t, e, i) {
                o(i, t, e.colorMatrix), a.add(i, i, e.colorOffset)
            }

            function o(t, e, i) {
                var r = e[0],
                    n = e[1],
                    o = e[2],
                    s = e[3];
                return t[0] = i[0] * r + i[1] * n + i[2] * o + i[3] * s, t[1] = i[4] * r + i[5] * n + i[6] * o + i[7] * s, t[2] = i[8] * r + i[9] * n + i[10] * o + i[11] * s, t[3] = i[12] * r + i[13] * n + i[14] * o + i[15] * s, t
            }

            function s(t, e) {
                for (var i = t.width, r = t.height, o = t.data, s = 0; s < i * r; s++) a.set(h, o[4 * s + 0] / 255, o[4 * s + 1] / 255, o[4 * s + 2] / 255, o[4 * s + 3] / 255), n(h, e, h), o[4 * s + 0] = 255 * h[0], o[4 * s + 1] = 255 * h[1], o[4 * s + 2] = 255 * h[2], o[4 * s + 3] = 255 * h[3]
            }
            var a = t("gl-matrix/src/gl-matrix/vec4"),
                l = t("gl-matrix/src/gl-matrix/mat4"),
                h = a.create();
            e.exports = {
                identity: r,
                applyToPixel: n,
                applyToImageData: s
            }
        }, {
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec4": 11
        }],
        37: [function (t, e, i) {
            "use strict";

            function r(t) {
                t = t || {}, this._methods = [], this._parameters = ["x", "y", "axisScaledX", "axisScaledY", "zoom", "yaw", "pitch", "roll"], this._clock = t.clock || s, this._composedOffsets = {}, this._composeReturn = {
                    offsets: this._composedOffsets,
                    changing: null
                }
            }
            var n = t("minimal-event-emitter"),
                o = t("./Dynamics"),
                s = t("../util/clock");
            n(r), r.prototype.add = function (t) {
                if (!this.has(t)) {
                    var e = {};
                    this._parameters.forEach(function (t) {
                        e[t] = {
                            dynamics: new o,
                            time: null
                        }
                    });
                    var i = this._updateDynamics.bind(this, e),
                        r = {
                            instance: t,
                            dynamics: e,
                            parameterDynamicsHandler: i
                        };
                    t.addEventListener("parameterDynamics", i), this._methods.push(r)
                }
            }, r.prototype.remove = function (t) {
                var e = this._indexOfInstance(t);
                if (e >= 0) {
                    var i = this._methods.splice(e, 1)[0];
                    i.instance.removeEventListener("parameterDynamics", i.parameterDynamicsHandler)
                }
            }, r.prototype.has = function (t) {
                return this._indexOfInstance(t) >= 0
            }, r.prototype._indexOfInstance = function (t) {
                for (var e = 0; e < this._methods.length; e++)
                    if (this._methods[e].instance === t) return e;
                return -1
            }, r.prototype.list = function () {
                for (var t = [], e = 0; e < this._methods.length; e++) t.push(this._methods[e].instance);
                return t
            }, r.prototype._updateDynamics = function (t, e, i, r) {
                var n = t[i];
                if (!n) throw new Error("Unknown control parameter " + i);
                var o = this._clock();
                n.dynamics.update(r, (o - n.time) / 1e3), n.time = o, this.emit("change")
            }, r.prototype._resetComposedOffsets = function () {
                for (var t = 0; t < this._parameters.length; t++) this._composedOffsets[this._parameters[t]] = 0
            }, r.prototype.offsets = function () {
                var t, e = !1,
                    i = this._clock();
                this._resetComposedOffsets();
                for (var r = 0; r < this._methods.length; r++)
                    for (var n = this._methods[r].dynamics, o = 0; o < this._parameters.length; o++) {
                        t = this._parameters[o];
                        var s = n[t],
                            a = s.dynamics;
                        null != a.offset && (this._composedOffsets[t] += a.offset, a.offset = null);
                        var l = (i - s.time) / 1e3,
                            h = a.offsetFromVelocity(l);
                        h && (this._composedOffsets[t] += h);
                        var u = a.velocityAfter(l);
                        a.velocity = u, u && (e = !0), s.time = i
                    }
                return this._composeReturn.changing = e, this._composeReturn
            }, r.prototype.destroy = function () {
                for (var t = this.list(), e = 0; e < t.length; e++) this.remove(t[e]);
                this._methods = null
            }, e.exports = r
        }, {
            "../util/clock": 92,
            "./Dynamics": 41,
            "minimal-event-emitter": 13
        }],
        38: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r) {
                r = n(r || {}, o), this._element = i, this._controls = t, this._id = e, this._attached = !1, this._setActiveCursor = this._setCursor.bind(this, r.active), this._setInactiveCursor = this._setCursor.bind(this, r.inactive), this._setDisabledCursor = this._setCursor.bind(this, r.disabled), this._setOriginalCursor = this._setCursor.bind(this, this._element.style.cursor),
                    this._updateAttachmentHandler = this._updateAttachment.bind(this), t.addEventListener("methodEnabled", this._updateAttachmentHandler), t.addEventListener("methodDisabled", this._updateAttachmentHandler), t.addEventListener("enabled", this._updateAttachmentHandler), t.addEventListener("disabled", this._updateAttachmentHandler), this._updateAttachment()
            }
            var n = t("../util/defaults"),
                o = {
                    active: "move",
                    inactive: "default",
                    disabled: "default"
                };
            r.prototype.destroy = function () {
                this._detachFromControlMethod(this._controls.method(this._id)), this._setOriginalCursor(), this._controls.removeEventListener("methodEnabled", this._updateAttachmentHandler), this._controls.removeEventListener("methodDisabled", this._updateAttachmentHandler), this._controls.removeEventListener("enabled", this._updateAttachmentHandler), this._controls.removeEventListener("disabled", this._updateAttachmentHandler), this._element = null, this._controls = null, this._id = null, this._attached = null, this._setActiveCursor = null, this._setInactiveCursor = null, this._setDisabledCursor = null, this._setOriginalCursor = null, this._updateAttachmentHandler = null
            }, r.prototype._updateAttachment = function () {
                var t = this._controls,
                    e = this._id;
                t.enabled() && t.method(e).enabled ? this._attachToControlMethod(t.method(e)) : this._detachFromControlMethod(t.method(e))
            }, r.prototype._attachToControlMethod = function (t) {
                this._attached || (t.instance.addEventListener("active", this._setActiveCursor), t.instance.addEventListener("inactive", this._setInactiveCursor), t.active ? this._setActiveCursor() : this._setInactiveCursor(), this._attached = !0)
            }, r.prototype._detachFromControlMethod = function (t) {
                this._attached && (t.instance.removeEventListener("active", this._setActiveCursor), t.instance.removeEventListener("inactive", this._setInactiveCursor), this._setDisabledCursor(), this._attached = !1)
            }, r.prototype._setCursor = function (t) {
                this._element.style.cursor = t
            }, e.exports = r
        }, {
            "../util/defaults": 97
        }],
        39: [function (t, e, i) {
            "use strict";

            function r(t) {
                t = t || {}, this._methods = {}, this._methodGroups = {}, this._composer = new n, this._enabled = !t || !t.enabled || !!t.enabled, this._activeCount = 0, this.updatedViews_ = [], this._attachedRenderLoop = null
            }
            var n = t("./Composer"),
                o = t("minimal-event-emitter"),
                s = "undefined" != typeof MARZIPANODEBUG && MARZIPANODEBUG.controls;
            o(r), r.prototype.methods = function () {
                var t = {};
                for (var e in this._methods) t[e] = this._methods[e];
                return t
            }, r.prototype.method = function (t) {
                return this._methods[t]
            }, r.prototype.registerMethod = function (t, e, i) {
                if (this._methods[t]) throw new Error("Control method already registered with id " + t);
                this._methods[t] = {
                    instance: e,
                    enabled: !1,
                    active: !1,
                    activeHandler: this._handleActive.bind(this, t),
                    inactiveHandler: this._handleInactive.bind(this, t)
                }, i && this.enableMethod(t, e)
            }, r.prototype.unregisterMethod = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("No control method registered with id " + t);
                e.enabled && this.disableMethod(t), delete this._methods[t]
            }, r.prototype.enableMethod = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("No control method registered with id " + t);
                e.enabled || (e.enabled = !0, e.active && this._incrementActiveCount(), this._listen(t), this._updateComposer(), this.emit("methodEnabled", t))
            }, r.prototype.disableMethod = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("No control method registered with id " + t);
                e.enabled && (e.enabled = !1, e.active && this._decrementActiveCount(), this._unlisten(t), this._updateComposer(), this.emit("methodDisabled", t))
            }, r.prototype.addMethodGroup = function (t, e) {
                this._methodGroups[t] = e
            }, r.prototype.removeMethodGroup = function (t) {
                delete this._methodGroups[t]
            }, r.prototype.methodGroups = function () {
                var t = {};
                for (var e in this._methodGroups) t[e] = this._methodGroups[e];
                return t
            }, r.prototype.enableMethodGroup = function (t) {
                var e = this;
                e._methodGroups[t].forEach(function (t) {
                    e.enableMethod(t)
                })
            }, r.prototype.disableMethodGroup = function (t) {
                var e = this;
                e._methodGroups[t].forEach(function (t) {
                    e.disableMethod(t)
                })
            }, r.prototype.enabled = function () {
                return this._enabled
            }, r.prototype.enable = function () {
                this._enabled = !0, this._activeCount > 0 && this.emit("active"), this.emit("enabled"), this._updateComposer()
            }, r.prototype.disable = function () {
                this._enabled = !1, this._activeCount > 0 && this.emit("inactive"), this.emit("disabled"), this._updateComposer()
            }, r.prototype.attach = function (t) {
                this._attachedRenderLoop && this.detach(), this._attachedRenderLoop = t, this._beforeRenderHandler = this._updateViewsWithControls.bind(this), this._changeHandler = t.renderOnNextFrame.bind(t), this._attachedRenderLoop.addEventListener("beforeRender", this._beforeRenderHandler), this._composer.addEventListener("change", this._changeHandler)
            }, r.prototype.detach = function () {
                this._attachedRenderLoop && (this._attachedRenderLoop.removeEventListener("beforeRender", this._beforeRenderHandler), this._composer.removeEventListener("change", this._changeHandler), this._beforeRenderHandler = null, this._changeHandler = null, this._attachedRenderLoop = null)
            }, r.prototype.attached = function () {
                return null != this._attachedRenderLoop
            }, r.prototype._listen = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("Bad method id");
                e.instance.addEventListener("active", e.activeHandler), e.instance.addEventListener("inactive", e.inactiveHandler)
            }, r.prototype._unlisten = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("Bad method id");
                e.instance.removeEventListener("active", e.activeHandler), e.instance.removeEventListener("inactive", e.inactiveHandler)
            }, r.prototype._handleActive = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("Bad method id");
                if (!e.enabled) throw new Error("Should not receive event from disabled control method");
                e.active || (e.active = !0, this._incrementActiveCount())
            }, r.prototype._handleInactive = function (t) {
                var e = this._methods[t];
                if (!e) throw new Error("Bad method id");
                if (!e.enabled) throw new Error("Should not receive event from disabled control method");
                e.active && (e.active = !1, this._decrementActiveCount())
            }, r.prototype._incrementActiveCount = function () {
                this._activeCount++, s && this._checkActiveCount(), this._enabled && 1 === this._activeCount && this.emit("active")
            }, r.prototype._decrementActiveCount = function () {
                this._activeCount--, s && this._checkActiveCount(), this._enabled && 0 === this._activeCount && this.emit("inactive")
            }, r.prototype._checkActiveCount = function () {
                var t = 0;
                for (var e in this._methods) {
                    var i = this._methods[e];
                    i.enabled && i.active && t++
                }
                if (t != this._activeCount) throw new Error("Bad control state")
            }, r.prototype._updateComposer = function () {
                var t = this._composer;
                for (var e in this._methods) {
                    var i = this._methods[e],
                        r = this._enabled && i.enabled;
                    r && !t.has(i.instance) && t.add(i.instance), !r && t.has(i.instance) && t.remove(i.instance)
                }
            }, r.prototype._updateViewsWithControls = function () {
                var t = this._composer.offsets();
                t.changing && this._attachedRenderLoop.renderOnNextFrame(), this.updatedViews_.length = 0;
                for (var e = this._attachedRenderLoop.stage().listLayers(), i = 0; i < e.length; i++) {
                    var r = e[i].view();
                    this.updatedViews_.indexOf(r) < 0 && (e[i].view().updateWithControlParameters(t.offsets), this.updatedViews_.push(r))
                }
            }, r.prototype.destroy = function () {
                this.detach(), this._composer.destroy(), this._methods = null
            }, e.exports = r
        }, {
            "./Composer": 37,
            "minimal-event-emitter": 13
        }],
        40: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                this._element = t, this._opts = s(i || {}, h), this._startEvent = null, this._lastEvent = null, this._active = !1, this._dynamics = {
                    x: new n,
                    y: new n
                }, this._hammer = o.get(t, e), this._hammer.on("hammer.input", this._handleHammerEvent.bind(this)), this._hammer.on("panstart", this._handleStart.bind(this)), this._hammer.on("panmove", this._handleMove.bind(this)), this._hammer.on("panend", this._handleEnd.bind(this)), this._hammer.on("pancancel", this._handleEnd.bind(this))
            }
            var n = t("./Dynamics"),
                o = t("./HammerGestures"),
                s = t("../util/defaults"),
                a = t("minimal-event-emitter"),
                l = t("./util").maxFriction,
                h = {
                    friction: 6,
                    maxFrictionTime: .3
                },
                u = "undefined" != typeof MARZIPANODEBUG && MARZIPANODEBUG.controls;
            a(r), r.prototype.destroy = function () {
                this._hammer.release(), this._element = null, this._opts = null, this._startEvent = null, this._lastEvent = null, this._active = null, this._dynamics = null, this._hammer = null
            }, r.prototype._handleHammerEvent = function (t) {
                if (t.isFirst) {
                    if (u && this._active) throw new Error("DragControlMethod active detected when already active");
                    this._active = !0, this.emit("active")
                }
                if (t.isFinal) {
                    if (u && !this._active) throw new Error("DragControlMethod inactive detected when already inactive");
                    this._active = !1, this.emit("inactive")
                }
            }, r.prototype._handleStart = function (t) {
                t.preventDefault(), this._startEvent = t
            }, r.prototype._handleMove = function (t) {
                t.preventDefault(), this._startEvent && (this._updateDynamicsMove(t), this.emit("parameterDynamics", "axisScaledX", this._dynamics.x), this.emit("parameterDynamics", "axisScaledY", this._dynamics.y))
            }, r.prototype._handleEnd = function (t) {
                t.preventDefault(), this._startEvent && (this._updateDynamicsRelease(t), this.emit("parameterDynamics", "axisScaledX", this._dynamics.x), this.emit("parameterDynamics", "axisScaledY", this._dynamics.y)), this._startEvent = !1, this._lastEvent = !1
            }, r.prototype._updateDynamicsMove = function (t) {
                var e = t.deltaX,
                    i = t.deltaY,
                    r = this._lastEvent || this._startEvent;
                r && (e -= r.deltaX, i -= r.deltaY);
                var n = this._element.getBoundingClientRect(),
                    o = n.right - n.left,
                    s = n.bottom - n.top;
                e /= o, i /= s, this._dynamics.x.reset(), this._dynamics.y.reset(), this._dynamics.x.offset = -e, this._dynamics.y.offset = -i, this._lastEvent = t
            };
            var c = [null, null];
            r.prototype._updateDynamicsRelease = function (t) {
                var e = this._element.getBoundingClientRect(),
                    i = e.right - e.left,
                    r = e.bottom - e.top,
                    n = 1e3 * t.velocityX / i,
                    o = 1e3 * t.velocityY / r;
                this._dynamics.x.reset(), this._dynamics.y.reset(), this._dynamics.x.velocity = n, this._dynamics.y.velocity = o, l(this._opts.friction, this._dynamics.x.velocity, this._dynamics.y.velocity, this._opts.maxFrictionTime, c), this._dynamics.x.friction = c[0], this._dynamics.y.friction = c[1]
            }, e.exports = r
        }, {
            "../util/defaults": 97,
            "./Dynamics": 41,
            "./HammerGestures": 43,
            "./util": 51,
            "minimal-event-emitter": 13
        }],
        41: [function (t, e, i) {
            "use strict";

            function r() {
                this.velocity = null, this.friction = null, this.offset = null
            }

            function n(t, e) {
                return t < 0 ? Math.min(0, t + e) : t > 0 ? Math.max(0, t - e) : 0
            }
            r.equals = function (t, e) {
                return t.velocity === e.velocity && t.friction === e.friction && t.offset === e.offset
            }, r.prototype.equals = function (t) {
                return r.equals(this, t)
            }, r.prototype.update = function (t, e) {
                t.offset && (this.offset = this.offset || 0, this.offset += t.offset);
                var i = this.offsetFromVelocity(e);
                i && (this.offset = this.offset || 0, this.offset += i), this.velocity = t.velocity, this.friction = t.friction
            }, r.prototype.reset = function () {
                this.velocity = null, this.friction = null, this.offset = null
            }, r.prototype.velocityAfter = function (t) {
                return this.velocity ? this.friction ? n(this.velocity, this.friction * t) : this.velocity : null
            }, r.prototype.offsetFromVelocity = function (t) {
                t = Math.min(t, this.nullVelocityTime());
                var e = this.velocityAfter(t);
                return (this.velocity + e) / 2 * t
            }, r.prototype.nullVelocityTime = function () {
                return null == this.velocity ? 0 : this.velocity && !this.friction ? Infinity : Math.abs(this.velocity / this.friction)
            }, e.exports = r
        }, {}],
        42: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r) {
                if (!t) throw new Error("ElementPressControlMethod: element must be defined");
                if (!e) throw new Error("ElementPressControlMethod: parameter must be defined");
                if (!i) throw new Error("ElementPressControlMethod: velocity must be defined");
                if (!r) throw new Error("ElementPressControlMethod: friction must be defined");
                this._element = t, this._pressHandler = this._handlePress.bind(this), this._releaseHandler = this._handleRelease.bind(this), t.addEventListener("mousedown", this._pressHandler), t.addEventListener("mouseup", this._releaseHandler), t.addEventListener("mouseleave", this._releaseHandler), t.addEventListener("touchstart", this._pressHandler), t.addEventListener("touchmove", this._releaseHandler), t.addEventListener("touchend", this._releaseHandler), this._parameter = e, this._velocity = i, this._friction = r, this._dynamics = new n, this._pressing = !1
            }
            var n = t("./Dynamics");
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {
                this._element.removeEventListener("mousedown", this._pressHandler), this._element.removeEventListener("mouseup", this._releaseHandler), this._element.removeEventListener("mouseleave", this._releaseHandler), this._element.removeEventListener("touchstart", this._pressHandler), this._element.removeEventListener("touchmove", this._releaseHandler), this._element.removeEventListener("touchend", this._releaseHandler)
            }, r.prototype._handlePress = function () {
                this._pressing = !0, this._dynamics.velocity = this._velocity, this._dynamics.friction = 0, this.emit("parameterDynamics", this._parameter, this._dynamics), this.emit("active")
            }, r.prototype._handleRelease = function () {
                this._pressing && (this._dynamics.friction = this._friction, this.emit("parameterDynamics", this._parameter, this._dynamics), this.emit("inactive")), this._pressing = !1
            }, e.exports = r
        }, {
            "./Dynamics": 41,
            "minimal-event-emitter": 13
        }],
        43: [function (t, e, i) {
            "use strict";

            function r() {
                this._managers = new l(n, o)
            }

            function n(t, e) {
                return t === e
            }

            function o(t) {
                for (var e = t.id || t.toString(); e.length < 5;) e += "0";
                return h(e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3), e.charCodeAt(4))
            }

            function s(t, e, i, r) {
                this._manager = e, this._element = i, this._type = r, this._hammerGestures = t, this._eventHandlers = []
            }
            var a = t("hammerjs"),
                l = t("../collections/Map"),
                h = t("../util/hash"),
                u = t("bowser");
            r.prototype.get = function (t, e) {
                this._managers.has(t) || this._managers.set(t, {});
                var i = this._managers.get(t);
                i[e] || (i[e] = this._createManager(t, e));
                var r = i[e];
                return r.refs += 1, new s(this, r.manager, t, e)
            }, r.prototype._createManager = function (t, e) {
                var i = new a.Manager(t);
                return "mouse" === e ? i.add(new a.Pan({
                    direction: a.DIRECTION_ALL,
                    threshold: 0
                })) : "touch" !== e && "pen" !== e && "kinect" !== e || (i.add(new a.Pan({
                    direction: a.DIRECTION_ALL,
                    threshold: 20,
                    pointers: 1
                })), u.msie && parseFloat(u.version) < 10 || i.add(new a.Pinch)), {
                    manager: i,
                    refs: 0
                }
            }, r.prototype._releaseHandle = function (t, e) {
                var i = this._managers.get(t)[e];
                i.refs -= 1, i.refs <= 0 && (i.manager.destroy(), this._managers.get(t)[e] = null)
            }, s.prototype.on = function (t, e) {
                var i = this._type,
                    r = function (t) {
                        i === t.pointerType && e(t)
                    };
                this._eventHandlers.push({
                    events: t,
                    handler: r
                }), this._manager.on(t, r)
            }, s.prototype.release = function () {
                for (var t = 0; t < this._eventHandlers.length; t++) {
                    var e = this._eventHandlers[t];
                    this._manager.off(e.events, e.handler)
                }
                this._hammerGestures._releaseHandle(this._element, this._type), this._manager = null, this._element = null, this._type = null, this._hammerGestures = null
            }, s.prototype.manager = function () {
                return this._manager
            }, e.exports = new r
        }, {
            "../collections/Map": 32,
            "../util/hash": 103,
            bowser: 1,
            hammerjs: 12
        }],
        44: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, o) {
                if (!t) throw new Error("KeyControlMethod: keyCode must be defined");
                if (!e) throw new Error("KeyControlMethod: parameter must be defined");
                if (!i) throw new Error("KeyControlMethod: velocity must be defined");
                if (!r) throw new Error("KeyControlMethod: friction must be defined");
                o = o || document, this._keyCode = t, this._parameter = e, this._velocity = i, this._friction = r, this._element = o, this._keydownHandler = this._handlePress.bind(this), this._keyupHandler = this._handleRelease.bind(this), this._blurHandler = this._handleBlur.bind(this), this._element.addEventListener("keydown", this._keydownHandler), this._element.addEventListener("keyup", this._keyupHandler), window.addEventListener("blur", this._blurHandler), this._dynamics = new n, this._pressing = !1
            }
            var n = t("./Dynamics");
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {
                this._element.removeEventListener("keydown", this._keydownHandler), this._element.removeEventListener("keyup", this._keyupHandler), window.removeEventListener("blur", this._blurHandler)
            }, r.prototype._handlePress = function (t) {
                t.keyCode === this._keyCode && (this._pressing = !0, this._dynamics.velocity = this._velocity, this._dynamics.friction = 0, this.emit("parameterDynamics", this._parameter, this._dynamics), this.emit("active"))
            }, r.prototype._handleRelease = function (t) {
                t.keyCode === this._keyCode && (this._pressing && (this._dynamics.friction = this._friction, this.emit("parameterDynamics", this._parameter, this._dynamics), this.emit("inactive")), this._pressing = !1)
            }, r.prototype._handleBlur = function () {
                this._dynamics.velocity = 0, this.emit("parameterDynamics", this._parameter, this._dynamics), this.emit("inactive"), this._pressing = !1
            }, e.exports = r
        }, {
            "./Dynamics": 41,
            "minimal-event-emitter": 13
        }],
        45: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                this._hammer = o.get(t, e), this._lastEvent = null, this._active = !1, this._dynamics = new n, this._hammer.on("pinchstart", this._handleStart.bind(this)), this._hammer.on("pinch", this._handleEvent.bind(this)), this._hammer.on("pinchend", this._handleEnd.bind(this)), this._hammer.on("pinchcancel", this._handleEnd.bind(this))
            }
            var n = t("./Dynamics"),
                o = t("./HammerGestures");
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {
                this._hammer.release(), this._hammer = null, this._lastEvent = null, this._active = null, this._dynamics = null
            }, r.prototype._handleStart = function () {
                this._active || (this._active = !0, this.emit("active"))
            }, r.prototype._handleEnd = function () {
                this._lastEvent = null, this._active && (this._active = !1, this.emit("inactive"))
            }, r.prototype._handleEvent = function (t) {
                var e = t.scale;
                this._lastEvent && (e /= this._lastEvent.scale), this._dynamics.offset = -1 * (e - 1), this.emit("parameterDynamics", "zoom", this._dynamics), this._lastEvent = t
            }, e.exports = r
        }, {
            "./Dynamics": 41,
            "./HammerGestures": 43,
            "minimal-event-emitter": 13
        }],
        46: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                this._element = t, this._opts = s(i || {}, h), this._active = !1, this._hammer = o.get(t, e), this._dynamics = {
                    x: new n,
                    y: new n
                }, this._hammer.on("panstart", this._handleStart.bind(this)), this._hammer.on("panmove", this._handleMove.bind(this)), this._hammer.on("panend", this._handleRelease.bind(this)), this._hammer.on("pancancel", this._handleRelease.bind(this))
            }
            var n = t("./Dynamics"),
                o = t("./HammerGestures"),
                s = t("../util/defaults"),
                a = t("minimal-event-emitter"),
                l = t("./util").maxFriction,
                h = {
                    speed: 8,
                    friction: 6,
                    maxFrictionTime: .3
                };
            a(r), r.prototype.destroy = function () {
                this._hammer.release(), this._hammer = null, this._element = null, this._opts = null, this._active = null, this._dynamics = null
            }, r.prototype._handleStart = function (t) {
                t.preventDefault(), this._active || (this._active = !0, this.emit("active"))
            }, r.prototype._handleMove = function (t) {
                t.preventDefault(), this._updateDynamics(t, !1)
            }, r.prototype._handleRelease = function (t) {
                t.preventDefault(), this._updateDynamics(t, !0), this._active && (this._active = !1, this.emit("inactive"))
            };
            var u = [null, null];
            r.prototype._updateDynamics = function (t, e) {
                var i = this._element.getBoundingClientRect(),
                    r = i.right - i.left,
                    n = i.bottom - i.top,
                    o = Math.max(r, n),
                    s = t.deltaX / o * this._opts.speed,
                    a = t.deltaY / o * this._opts.speed;
                this._dynamics.x.reset(), this._dynamics.y.reset(), this._dynamics.x.velocity = s, this._dynamics.y.velocity = a, e && (l(this._opts.friction, this._dynamics.x.velocity, this._dynamics.y.velocity, this._opts.maxFrictionTime, u), this._dynamics.x.friction = u[0], this._dynamics.y.friction = u[1]), this.emit("parameterDynamics", "x", this._dynamics.x), this.emit("parameterDynamics", "y", this._dynamics.y)
            }, e.exports = r
        }, {
            "../util/defaults": 97,
            "./Dynamics": 41,
            "./HammerGestures": 43,
            "./util": 51,
            "minimal-event-emitter": 13
        }],
        47: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this._opts = a(e || {}, l), this._dynamics = new o, this._eventList = [];
                var i = this._opts.frictionTime ? this.withSmoothing : this.withoutSmoothing;
                this._wheelListener = new s(t, i.bind(this))
            }

            function n(t) {
                var e = 1 == t.deltaMode ? 20 : 1;
                return t.deltaY * e
            }
            var o = t("./Dynamics"),
                s = t("./WheelListener"),
                a = t("../util/defaults"),
                l = {
                    frictionTime: .2,
                    zoomDelta: .001
                };
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {
                this._wheelListener.remove(), this._opts = null, this._dynamics = null, this._eventList = null
            }, r.prototype.withoutSmoothing = function (t) {
                this._dynamics.offset = n(t) * this._opts.zoomDelta, this.emit("parameterDynamics", "zoom", this._dynamics), t.preventDefault(), this.emit("active"), this.emit("inactive")
            }, r.prototype.withSmoothing = function (t) {
                var e = t.timeStamp;
                for (this._eventList.push(t); this._eventList[0].timeStamp < e - 1e3 * this._opts.frictionTime;) this._eventList.shift(0);
                for (var i = 0, r = 0; r < this._eventList.length; r++) i += n(this._eventList[r]) * this._opts.zoomDelta / this._opts.frictionTime;
                this._dynamics.velocity = i, this._dynamics.friction = Math.abs(i) / this._opts.frictionTime, this.emit("parameterDynamics", "zoom", this._dynamics), t.preventDefault(), this.emit("active"), this.emit("inactive")
            }, e.exports = r
        }, {
            "../util/defaults": 97,
            "./Dynamics": 41,
            "./WheelListener": 49,
            "minimal-event-emitter": 13
        }],
        48: [function (t, e, i) {
            "use strict";

            function r(t) {
                if (!t) throw new Error("VelocityControlMethod: parameter must be defined");
                this._parameter = t, this._dynamics = new n
            }
            var n = t("./Dynamics");
            t("../util/defaults");
            t("minimal-event-emitter")(r), r.prototype.destroy = function () {}, r.prototype.setVelocity = function (t) {
                this._dynamics.velocity = t, this.emit("parameterDynamics", this._parameter, this._dynamics)
            }, r.prototype.setFriction = function (t) {
                this._dynamics.friction = t, this.emit("parameterDynamics", this._parameter, this._dynamics)
            }, e.exports = r
        }, {
            "../util/defaults": 97,
            "./Dynamics": 41,
            "minimal-event-emitter": 13
        }],
        49: [function (t, e, i) {
            "use strict";

            function r() {
                return "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== undefined ? "mousewheel" : null
            }

            function n(t, e, i) {
                var n = r();
                if ("wheel" === n) this._fun = e, this._elem = t, this._elem.addEventListener("wheel", this._fun, i);
                else {
                    if ("mousewheel" !== n) throw new Error("Browser does not support mouse wheel events");
                    this._fun = o(e), this._elem = t, this._elem.addEventListener("mousewheel", this._fun, i)
                }
            }

            function o(t) {
                return function (e) {
                    e || (e = window.event);
                    var i = {
                        originalEvent: e,
                        target: e.target || e.srcElement,
                        type: "wheel",
                        deltaMode: 1,
                        deltaX: 0,
                        deltaZ: 0,
                        timeStamp: e.timeStamp || Date.now(),
                        preventDefault: e.preventDefault.bind(e)
                    };
                    return i.deltaY = -.025 * e.wheelDelta, e.wheelDeltaX && (i.deltaX = -.025 * e.wheelDeltaX), t(i)
                }
            }
            n.prototype.remove = function () {
                var t = r();
                "wheel" === t ? this._elem.removeEventListener("wheel", this._fun) : "mousewheel" === t && this._elem.removeEventListener("mousewheel", this._fun)
            }, e.exports = n
        }, {}],
        50: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                i = n(i || {}, u);
                var r = {
                    mouseViewDrag: new o(e, "mouse"),
                    mouseViewQtvr: new s(e, "mouse"),
                    touchView: new o(e, "touch"),
                    pinch: new l(e, "touch"),
                    leftArrowKey: new h(37, "x", -.7, 3),
                    rightArrowKey: new h(39, "x", .7, 3),
                    upArrowKey: new h(38, "y", -.7, 3),
                    downArrowKey: new h(40, "y", .7, 3),
                    plusKey: new h(107, "zoom", -.7, 3),
                    minusKey: new h(109, "zoom", .7, 3),
                    wKey: new h(87, "y", -.7, 3),
                    aKey: new h(65, "x", -.7, 3),
                    sKey: new h(83, "y", .7, 3),
                    dKey: new h(68, "x", .7, 3),
                    qKey: new h(81, "roll", .7, 3),
                    eKey: new h(69, "roll", -.7, 3)
                };
                !1 !== i.scrollZoom && (r.scrollZoom = new a(e));
                var c = {
                        arrowKeys: ["leftArrowKey", "rightArrowKey", "upArrowKey", "downArrowKey"],
                        plusMinusKeys: ["plusKey", "minusKey"],
                        wasdKeys: ["wKey", "aKey", "sKey", "dKey"],
                        qeKeys: ["qKey", "eKey"]
                    },
                    p = ["scrollZoom", "touchView", "pinch"];
                switch (i.mouseViewMode) {
                    case "drag":
                        p.push("mouseViewDrag");
                        break;
                    case "qtvr":
                        p.push("mouseViewQtvr");
                        break;
                    default:
                        throw new Error("Unknown mouse view mode: " + i.mouseViewMode)
                }
                for (var d in r) {
                    var f = r[d];
                    t.registerMethod(d, f), p.indexOf(d) >= 0 && t.enableMethod(d)
                }
                for (var m in c) {
                    var v = c[m];
                    t.addMethodGroup(m, v)
                }
                return r
            }
            var n = t("../util/defaults"),
                o = t("./Drag"),
                s = t("./Qtvr"),
                a = t("./ScrollZoom"),
                l = t("./PinchZoom"),
                h = t("./Key"),
                u = {
                    mouseViewMode: "drag"
                };
            e.exports = r
        }, {
            "../util/defaults": 97,
            "./Drag": 40,
            "./Key": 44,
            "./PinchZoom": 45,
            "./Qtvr": 46,
            "./ScrollZoom": 47
        }],
        51: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, o) {
                var s = Math.sqrt(Math.pow(e, 2) + Math.pow(i, 2));
                t = Math.max(t, s / r), n(e, i, t, o), o[0] = Math.abs(o[0]), o[1] = Math.abs(o[1])
            }

            function n(t, e, i, r) {
                var n = Math.atan(e / t);
                r[0] = i * Math.cos(n), r[1] = i * Math.sin(n)
            }
            e.exports = {
                maxFriction: r,
                changeVectorNorm: n
            }
        }, {}],
        52: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, n) {
                this.face = t, this.x = e, this.y = i, this.z = r, this._geometry = n, this._level = n.levelList[r]
            }

            function n(t) {
                if (this.constructor.super_.call(this, t), this._size = t.size, this._tileSize = t.tileSize, this._size % this._tileSize != 0) throw new Error("Level size is not multiple of tile size: " + this._size + " " + this._tileSize)
            }

            function o(t) {
                if ("array" !== v(t)) throw new Error("Level list must be an array");
                this.levelList = c(t, n), this.selectableLevelList = p(this.levelList);
                for (var e = 1; e < this.levelList.length; e++) this.levelList[e]._validateWithParentLevel(this.levelList[e - 1]);
                this._graphFinder = new l(r.equals, r.hash), this._neighborsCache = new h(r.equals, r.hash, 64), this._vec = _.create(), this._viewSize = {}, this._viewParams = {}, this._tileVertices = [_.create(), _.create(), _.create(), _.create()]
            }
            for (var s = t("../util/inherits"), a = t("../util/hash"), l = t("../GraphFinder"), h = t("../collections/LruMap"), u = t("./Level"), c = t("./common").makeLevelList, p = t("./common").makeSelectableLevelList, d = t("../util/rotateVector"), f = t("../util/clamp"), m = t("../util/cmp"), v = t("../util/type"), _ = t("gl-matrix/src/gl-matrix/vec3"), y = "fudlrb", g = {
                    f: {
                        x: 0,
                        y: 0
                    },
                    b: {
                        x: 0,
                        y: Math.PI
                    },
                    l: {
                        x: 0,
                        y: Math.PI / 2
                    },
                    r: {
                        x: 0,
                        y: -Math.PI / 2
                    },
                    u: {
                        x: Math.PI / 2,
                        y: 0
                    },
                    d: {
                        x: -Math.PI / 2,
                        y: 0
                    }
                }, x = {}, M = 0; M < y.length; M++) {
                var w = y[M],
                    b = g[w],
                    S = _.fromValues(0, 0, -1);
                d(S, S, b.y, b.x, 0), x[w] = S
            }
            var E = {
                    f: ["l", "r", "u", "d"],
                    b: ["r", "l", "u", "d"],
                    l: ["b", "f", "u", "d"],
                    r: ["f", "b", "u", "d"],
                    u: ["l", "r", "b", "f"],
                    d: ["l", "r", "f", "b"]
                },
                I = [[0, 1], [1, 0], [0, -1], [-1, 0]];
            r.prototype.rotX = function () {
                return g[this.face].x
            }, r.prototype.rotY = function () {
                return g[this.face].y
            }, r.prototype.centerX = function () {
                return (this.x + .5) / this._level.numHorizontalTiles() - .5
            }, r.prototype.centerY = function () {
                return .5 - (this.y + .5) / this._level.numVerticalTiles()
            }, r.prototype.scaleX = function () {
                return 1 / this._level.numHorizontalTiles()
            }, r.prototype.scaleY = function () {
                return 1 / this._level.numVerticalTiles()
            }, r.prototype.width = function () {
                return this._level.tileWidth()
            }, r.prototype.height = function () {
                return this._level.tileHeight()
            }, r.prototype.levelWidth = function () {
                return this._level.width()
            }, r.prototype.levelHeight = function () {
                return this._level.height()
            }, r.prototype.atTopLevel = function () {
                return 0 === this.z
            }, r.prototype.atBottomLevel = function () {
                return this.z === this._geometry.levelList.length - 1
            }, r.prototype.atTopEdge = function () {
                return 0 === this.y
            }, r.prototype.atBottomEdge = function () {
                return this.y === this._level.numVerticalTiles() - 1
            }, r.prototype.atLeftEdge = function () {
                return 0 === this.x
            }, r.prototype.atRightEdge = function () {
                return this.x === this._level.numHorizontalTiles() - 1
            }, r.prototype.padTop = function () {
                return this.atTopEdge() && /[fu]/.test(this.face)
            }, r.prototype.padBottom = function () {
                return !this.atBottomEdge() || /[fd]/.test(this.face)
            }, r.prototype.padLeft = function () {
                return this.atLeftEdge() && /[flud]/.test(this.face)
            }, r.prototype.padRight = function () {
                return !this.atRightEdge() || /[frud]/.test(this.face)
            }, r.prototype.vertices = function (t) {
                function e(t, e, r) {
                    _.set(t, e, r, -.5), d(t, t, i.y, i.x, 0)
                }
                var i = g[this.face],
                    r = this.centerX() - this.scaleX() / 2,
                    n = this.centerX() + this.scaleX() / 2,
                    o = this.centerY() - this.scaleY() / 2,
                    s = this.centerY() + this.scaleY() / 2;
                return e(t[0], r, s), e(t[1], n, s), e(t[2], n, o), e(t[3], r, o), t
            }, r.prototype.parent = function () {
                if (this.atTopLevel()) return null;
                var t = this.face,
                    e = this.z,
                    i = this.x,
                    n = this.y,
                    o = this._geometry,
                    s = o.levelList[e],
                    a = o.levelList[e - 1];
                return new r(t, Math.floor(i / s.numHorizontalTiles() * a.numHorizontalTiles()), Math.floor(n / s.numVerticalTiles() * a.numVerticalTiles()), e - 1, o)
            }, r.prototype.children = function (t) {
                if (this.atBottomLevel()) return null;
                var e = this.face,
                    i = this.z,
                    n = this.x,
                    o = this.y,
                    s = this._geometry,
                    a = s.levelList[i],
                    l = s.levelList[i + 1],
                    h = l.numHorizontalTiles() / a.numHorizontalTiles(),
                    u = l.numVerticalTiles() / a.numVerticalTiles();
                t = t || [];
                for (var c = 0; c < h; c++)
                    for (var p = 0; p < u; p++) {
                        var d = h * n + c,
                            f = u * o + p,
                            m = i + 1;
                        t.push(new r(e, d, f, m, s))
                    }
                return t
            }, r.prototype.neighbors = function () {
                var t = this._geometry,
                    e = t._neighborsCache,
                    i = e.get(this);
                if (i) return i;
                for (var n = t._vec, o = this.face, s = this.x, a = this.y, l = this.z, h = this._level, u = h.numHorizontalTiles(), c = h.numVerticalTiles(), p = [], m = 0; m < I.length; m++) {
                    var v = I[m][0],
                        y = I[m][1],
                        x = s + v,
                        M = a + y,
                        w = l,
                        b = o;
                    if (x < 0 || x >= u || M < 0 || M >= c) {
                        var S = this.centerX(),
                            D = this.centerY();
                        x < 0 ? (_.set(n, -.5, D, -.5), b = E[o][0]) : x >= u ? (_.set(n, .5, D, -.5), b = E[o][1]) : M < 0 ? (_.set(n, S, .5, -.5), b = E[o][2]) : M >= c && (_.set(n, S, -.5, -.5), b = E[o][3]);
                        var T;
                        T = g[o], d(n, n, T.y, T.x, 0), T = g[b], d(n, n, -T.y, -T.x, 0), x = f(Math.floor((.5 + n[0]) * u), 0, u - 1), M = f(Math.floor((.5 - n[1]) * c), 0, c - 1)
                    }
                    p.push(new r(b, x, M, w, t))
                }
                return e.set(this, p), p
            }, r.prototype.hash = function () {
                return r.hash(this)
            }, r.prototype.equals = function (t) {
                return r.equals(this, t)
            }, r.prototype.cmp = function (t) {
                return r.cmp(this, t)
            }, r.prototype.str = function () {
                return r.str(this)
            }, r.hash = function (t) {
                return null != t ? a(t.face.charCodeAt(0), t.z, t.x, t.y) : 0
            }, r.equals = function (t, e) {
                return null != t && null != e && t.face === e.face && t.z === e.z && t.x === e.x && t.y === e.y
            }, r.cmp = function (t, e) {
                var i = y.indexOf(t.face),
                    r = y.indexOf(e.face);
                return m(t.z, e.z) || m(i, r) || m(t.y, e.y) || m(t.x, e.x)
            }, r.str = function (t) {
                return "CubeTile(" + t.face + ", " + t.x + ", " + t.y + ", " + t.z + ")"
            }, s(n, u), n.prototype.width = function () {
                return this._size
            }, n.prototype.height = function () {
                return this._size
            }, n.prototype.tileWidth = function () {
                return this._tileSize
            }, n.prototype.tileHeight = function () {
                return this._tileSize
            }, n.prototype._validateWithParentLevel = function (t) {
                var e = this.width(),
                    i = this.height(),
                    r = this.tileWidth(),
                    n = this.tileHeight(),
                    o = this.numHorizontalTiles(),
                    s = this.numVerticalTiles(),
                    a = t.width(),
                    l = t.height(),
                    h = t.tileWidth(),
                    u = t.tileHeight(),
                    c = t.numHorizontalTiles(),
                    p = t.numVerticalTiles();
                if (e % a != 0) throw new Error("Level width must be multiple of parent level: " + e + " vs. " + a);
                if (i % l != 0) throw new Error("Level height must be multiple of parent level: " + i + " vs. " + l);
                if (o % c != 0) throw new Error("Number of horizontal tiles must be multiple of parent level: " + o + " (" + e + "/" + r + ") vs. " + c + " (" + a + "/" + h + ")");
                if (s % p != 0) throw new Error("Number of vertical tiles must be multiple of parent level: " + s + " (" + i + "/" + n + ") vs. " + p + " (" + l + "/" + u + ")")
            }, o.prototype.maxTileSize = function () {
                for (var t = 0, e = 0; e < this.levelList.length; e++) {
                    var i = this.levelList[e];
                    t = Math.max(t, i.tileWidth, i.tileHeight)
                }
                return t
            }, o.prototype.levelTiles = function (t, e) {
                var i = this.levelList.indexOf(t),
                    n = t.numHorizontalTiles() - 1,
                    o = t.numVerticalTiles() - 1;
                e = e || [];
                for (var s = 0; s < y.length; s++)
                    for (var a = y[s], l = 0; l <= n; l++)
                        for (var h = 0; h <= o; h++) e.push(new r(a, l, h, i, this));
                return e
            }, o.prototype._closestTile = function (t, e) {
                var i = this._vec,
                    n = Infinity,
                    o = null;
                _.set(i, 0, 0, -1), d(i, i, -t.yaw, -t.pitch, -t.roll);
                for (var s in x) {
                    var a = x[s],
                        l = 1 - _.dot(a, i);
                    l < n && (n = l, o = s)
                }
                for (var h = Math.max(Math.abs(i[0]), Math.abs(i[1]), Math.abs(i[2])) / .5, u = 0; u < 3; u++) i[u] = i[u] / h;
                var c = g[o];
                d(i, i, -c.y, -c.x, -c.z);
                var p = this.levelList.indexOf(e),
                    m = e.numHorizontalTiles(),
                    v = e.numVerticalTiles(),
                    y = i[0],
                    M = i[1];
                return new r(o, f(Math.floor((.5 + y) * m), 0, m - 1), f(Math.floor((.5 - M) * v), 0, v - 1), p, this)
            }, o.prototype.visibleTiles = function (t, e, i) {
                function r(t) {
                    return t.neighbors()
                }

                function n(e) {
                    return e.vertices(a), t.intersects(a)
                }
                var o = this._viewSize,
                    s = this._viewParams,
                    a = this._tileVertices,
                    l = this._graphFinder;
                if (i = i || [], t.size(o), 0 === o.width || 0 === o.height) return i;
                var h = this._closestTile(t.parameters(s), e);
                if (!n(h)) throw new Error("Starting tile is not visible");
                var u;
                for (l.start(h, r, n); null != (u = l.next());) i.push(u);
                return i
            }, o.TileClass = o.prototype.TileClass = r, o.type = o.prototype.type = "cube", r.type = r.prototype.type = "cube", e.exports = o
        }, {
            "../GraphFinder": 14,
            "../collections/LruMap": 30,
            "../util/clamp": 91,
            "../util/cmp": 93,
            "../util/hash": 103,
            "../util/inherits": 104,
            "../util/rotateVector": 113,
            "../util/type": 115,
            "./Level": 55,
            "./common": 56,
            "gl-matrix/src/gl-matrix/vec3": 10
        }],
        53: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this.z = t, this._geometry = e, this._level = e.levelList[t]
            }

            function n(t) {
                this.constructor.super_.call(this, t), this._width = t.width
            }

            function o(t) {
                if ("array" !== c(t)) throw new Error("Level list must be an array");
                this.levelList = h.makeLevelList(t, n), this.selectableLevelList = h.makeSelectableLevelList(this.levelList)
            }
            var s = t("../util/inherits"),
                a = t("../util/hash"),
                l = t("../util/cmp"),
                h = t("./common"),
                u = t("./Level"),
                c = t("../util/type");
            r.prototype.rotX = function () {
                    return 0
                }, r.prototype.rotY = function () {
                    return 0
                }, r.prototype.centerX = function () {
                    return .5
                }, r.prototype.centerY = function () {
                    return .5
                }, r.prototype.scaleX = function () {
                    return 1
                }, r.prototype.scaleY = function () {
                    return 1
                }, r.prototype.width = function () {
                    return this._level.tileWidth()
                }, r.prototype.height = function () {
                    return this._level.tileHeight()
                },
                r.prototype.levelWidth = function () {
                    return this._level.width()
                }, r.prototype.levelHeight = function () {
                    return this._level.height()
                }, r.prototype.atTopLevel = function () {
                    return 0 === this.z
                }, r.prototype.atBottomLevel = function () {
                    return this.z === this._geometry.levelList.length - 1
                }, r.prototype.atTopEdge = function () {
                    return !0
                }, r.prototype.atBottomEdge = function () {
                    return !0
                }, r.prototype.atLeftEdge = function () {
                    return !0
                }, r.prototype.atRightEdge = function () {
                    return !0
                }, r.prototype.padTop = function () {
                    return !1
                }, r.prototype.padBottom = function () {
                    return !1
                }, r.prototype.padLeft = function () {
                    return !1
                }, r.prototype.padRight = function () {
                    return !1
                }, r.prototype.parent = function () {
                    return this.atTopLevel() ? null : new r(this.z - 1, this._geometry)
                }, r.prototype.children = function (t) {
                    return this.atBottomLevel() ? null : (t = t || [], t.push(new r(this.z + 1, this._geometry)), t)
                }, r.prototype.neighbors = function () {
                    return []
                }, r.prototype.hash = function () {
                    return r.hash(this)
                }, r.prototype.equals = function (t) {
                    return r.equals(this, t)
                }, r.prototype.cmp = function (t) {
                    return r.cmp(this, t)
                }, r.prototype.str = function () {
                    return r.str(this)
                }, r.hash = function (t) {
                    return a(t.z)
                }, r.equals = function (t, e) {
                    return t.z === e.z
                }, r.cmp = function (t, e) {
                    return l(t.z, e.z)
                }, r.str = function (t) {
                    return "EquirectTile(" + t.z + ")"
                }, s(n, u), n.prototype.width = function () {
                    return this._width
                }, n.prototype.height = function () {
                    return this._width / 2
                }, n.prototype.tileWidth = function () {
                    return this._width
                }, n.prototype.tileHeight = function () {
                    return this._width / 2
                }, o.prototype.maxTileSize = function () {
                    for (var t = 0, e = 0; e < this.levelList.length; e++) {
                        var i = this.levelList[e];
                        t = Math.max(t, i.tileWidth, i.tileHeight)
                    }
                    return t
                }, o.prototype.levelTiles = function (t, e) {
                    var i = this.levelList.indexOf(t);
                    return e = e || [], e.push(new r(i, this)), e
                }, o.prototype.visibleTiles = function (t, e, i) {
                    var n = new r(this.levelList.indexOf(e), this);
                    i = i || [], i.length = 0, i.push(n)
                }, o.TileClass = o.prototype.TileClass = r, o.type = o.prototype.type = "equirect", r.type = r.prototype.type = "equirect", e.exports = o
        }, {
            "../util/cmp": 93,
            "../util/hash": 103,
            "../util/inherits": 104,
            "../util/type": 115,
            "./Level": 55,
            "./common": 56
        }],
        54: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r) {
                this.x = t, this.y = e, this.z = i, this._geometry = r, this._level = r.levelList[i]
            }

            function n(t) {
                this.constructor.super_.call(this, t), this._width = t.width, this._height = t.height, this._tileWidth = t.tileWidth, this._tileHeight = t.tileHeight
            }

            function o(t) {
                if ("array" !== v(t)) throw new Error("Level list must be an array");
                this.levelList = c(t, n), this.selectableLevelList = p(this.levelList);
                for (var e = 1; e < this.levelList.length; e++) this.levelList[e]._validateWithParentLevel(this.levelList[e - 1]);
                this._graphFinder = new l(r.equals, r.hash), this._neighborsCache = new h(r.equals, r.hash, 64), this._viewSize = {}, this._viewParams = {}, this._tileVertices = [_.create(), _.create(), _.create(), _.create()]
            }
            var s = t("../util/inherits"),
                a = t("../util/hash"),
                l = t("../GraphFinder"),
                h = t("../collections/LruMap"),
                u = t("./Level"),
                c = t("./common").makeLevelList,
                p = t("./common").makeSelectableLevelList,
                d = t("../util/clamp"),
                f = t("../util/mod"),
                m = t("../util/cmp"),
                v = t("../util/type"),
                _ = t("gl-matrix/src/gl-matrix/vec2"),
                y = [[0, 1], [1, 0], [0, -1], [-1, 0]];
            r.prototype.rotX = function () {
                return 0
            }, r.prototype.rotY = function () {
                return 0
            }, r.prototype.centerX = function () {
                var t = this._level.width(),
                    e = this._level.tileWidth();
                return (this.x * e + .5 * this.width()) / t - .5
            }, r.prototype.centerY = function () {
                var t = this._level.height(),
                    e = this._level.tileHeight();
                return .5 - (this.y * e + .5 * this.height()) / t
            }, r.prototype.scaleX = function () {
                var t = this._level.width();
                return this.width() / t
            }, r.prototype.scaleY = function () {
                var t = this._level.height();
                return this.height() / t
            }, r.prototype.width = function () {
                var t = this._level.width(),
                    e = this._level.tileWidth();
                if (this.atRightEdge()) {
                    return f(t, e) || e
                }
                return e
            }, r.prototype.height = function () {
                var t = this._level.height(),
                    e = this._level.tileHeight();
                if (this.atBottomEdge()) {
                    return f(t, e) || e
                }
                return e
            }, r.prototype.levelWidth = function () {
                return this._level.width()
            }, r.prototype.levelHeight = function () {
                return this._level.height()
            }, r.prototype.atTopLevel = function () {
                return 0 === this.z
            }, r.prototype.atBottomLevel = function () {
                return this.z === this._geometry.levelList.length - 1
            }, r.prototype.atTopEdge = function () {
                return 0 === this.y
            }, r.prototype.atBottomEdge = function () {
                return this.y === this._level.numVerticalTiles() - 1
            }, r.prototype.atLeftEdge = function () {
                return 0 === this.x
            }, r.prototype.atRightEdge = function () {
                return this.x === this._level.numHorizontalTiles() - 1
            }, r.prototype.padTop = function () {
                return !1
            }, r.prototype.padBottom = function () {
                return !this.atBottomEdge()
            }, r.prototype.padLeft = function () {
                return !1
            }, r.prototype.padRight = function () {
                return !this.atRightEdge()
            }, r.prototype.vertices = function (t) {
                var e = this.centerX() - this.scaleX() / 2,
                    i = this.centerX() + this.scaleX() / 2,
                    r = this.centerY() - this.scaleY() / 2,
                    n = this.centerY() + this.scaleY() / 2;
                return _.set(t[0], e, n), _.set(t[1], i, n), _.set(t[2], i, r), _.set(t[3], e, r), t
            }, r.prototype.parent = function () {
                if (this.atTopLevel()) return null;
                var t = this._geometry,
                    e = this.z - 1;
                return new r(Math.floor(this.x / 2), Math.floor(this.y / 2), e, t)
            }, r.prototype.children = function (t) {
                if (this.atBottomLevel()) return null;
                var e = this._geometry,
                    i = this.z + 1;
                return t = t || [], t.push(new r(2 * this.x, 2 * this.y, i, e)), t.push(new r(2 * this.x, 2 * this.y + 1, i, e)), t.push(new r(2 * this.x + 1, 2 * this.y, i, e)), t.push(new r(2 * this.x + 1, 2 * this.y + 1, i, e)), t
            }, r.prototype.neighbors = function () {
                var t = this._geometry,
                    e = t._neighborsCache,
                    i = e.get(this);
                if (i) return i;
                for (var n = this.x, o = this.y, s = this.z, a = this._level, l = a.numHorizontalTiles() - 1, h = a.numVerticalTiles() - 1, u = [], c = 0; c < y.length; c++) {
                    var p = y[c][0],
                        d = y[c][1],
                        f = n + p,
                        m = o + d,
                        v = s;
                    0 <= f && f <= l && 0 <= m && m <= h && u.push(new r(f, m, v, t))
                }
                return e.set(this, u), u
            }, r.prototype.hash = function () {
                return r.hash(this)
            }, r.prototype.equals = function (t) {
                return r.equals(this, t)
            }, r.prototype.cmp = function (t) {
                return r.cmp(this, t)
            }, r.prototype.str = function () {
                return r.str(this)
            }, r.hash = function (t) {
                return null != t ? a(t.z, t.x, t.y) : 0
            }, r.equals = function (t, e) {
                return null != t && null != e && t.z === e.z && t.x === e.x && t.y === e.y
            }, r.cmp = function (t, e) {
                return m(t.z, e.z) || m(t.y, e.y) || m(t.x, e.x)
            }, r.str = function (t) {
                return "FlatTile(" + t.x + ", " + t.y + ", " + t.z + ")"
            }, s(n, u), n.prototype.width = function () {
                return this._width
            }, n.prototype.height = function () {
                return this._height
            }, n.prototype.tileWidth = function () {
                return this._tileWidth
            }, n.prototype.tileHeight = function () {
                return this._tileHeight
            }, n.prototype._validateWithParentLevel = function (t) {
                var e = this.width(),
                    i = this.height(),
                    r = this.tileWidth(),
                    n = this.tileHeight(),
                    o = t.width(),
                    s = t.height(),
                    a = t.tileWidth(),
                    l = t.tileHeight();
                return e % o != 0 ? new Error("Level width must be multiple of parent level: " + e + " vs. " + o) : i % s != 0 ? new Error("Level height must be multiple of parent level: " + i + " vs. " + s) : r % a != 0 ? new Error("Level tile width must be multiple of parent level: " + r + " vs. " + a) : n % l != 0 ? new Error("Level tile height must be multiple of parent level: " + n + " vs. " + l) : void 0
            }, o.prototype.maxTileSize = function () {
                for (var t = 0, e = 0; e < this.levelList.length; e++) {
                    var i = this.levelList[e];
                    t = Math.max(t, i.tileWidth, i.tileHeight)
                }
                return t
            }, o.prototype.levelTiles = function (t, e) {
                var i = this.levelList.indexOf(t),
                    n = t.numHorizontalTiles() - 1,
                    o = t.numVerticalTiles() - 1;
                e || (e = []);
                for (var s = 0; s <= n; s++)
                    for (var a = 0; a <= o; a++) e.push(new r(s, a, i, this));
                return e
            }, o.prototype._closestTile = function (t, e) {
                var i = t.x,
                    n = t.y,
                    o = this.levelList.indexOf(e),
                    s = e.width(),
                    a = e.height(),
                    l = e.tileWidth(),
                    h = e.tileHeight(),
                    u = e.numHorizontalTiles(),
                    c = e.numVerticalTiles();
                return new r(d(Math.floor(i * s / l), 0, u - 1), d(Math.floor(n * a / h), 0, c - 1), o, this)
            }, o.prototype.visibleTiles = function (t, e, i) {
                function r(t) {
                    return t.neighbors()
                }

                function n(e) {
                    return e.vertices(a), t.intersects(a)
                }
                var o = this._viewSize,
                    s = this._viewParams,
                    a = this._tileVertices,
                    l = this._graphFinder;
                if (i = i || [], t.size(o), 0 === o.width || 0 === o.height) return i;
                var h = this._closestTile(t.parameters(s), e);
                if (!n(h)) throw new Error("Starting tile is not visible");
                var u;
                for (l.start(h, r, n); null != (u = l.next());) i.push(u);
                return i
            }, o.TileClass = o.prototype.TileClass = r, o.type = o.prototype.type = "flat", r.type = r.prototype.type = "flat", e.exports = o
        }, {
            "../GraphFinder": 14,
            "../collections/LruMap": 30,
            "../util/clamp": 91,
            "../util/cmp": 93,
            "../util/hash": 103,
            "../util/inherits": 104,
            "../util/mod": 106,
            "../util/type": 115,
            "./Level": 55,
            "./common": 56,
            "gl-matrix/src/gl-matrix/vec2": 9
        }],
        55: [function (t, e, i) {
            "use strict";

            function r(t) {
                this._fallbackOnly = !!t.fallbackOnly
            }
            r.prototype.numHorizontalTiles = function () {
                return Math.ceil(this.width() / this.tileWidth())
            }, r.prototype.numVerticalTiles = function () {
                return Math.ceil(this.height() / this.tileHeight())
            }, r.prototype.fallbackOnly = function () {
                return this._fallbackOnly
            }, e.exports = r
        }, {}],
        56: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                for (var i = [], r = 0; r < t.length; r++) i.push(new e(t[r]));
                return i.sort(function (t, e) {
                    return o(t.width(), e.width())
                }), i
            }

            function n(t) {
                for (var e = [], i = 0; i < t.length; i++) t[i]._fallbackOnly || e.push(t[i]);
                if (!e.length) throw new Error("No selectable levels in list");
                return e
            }
            var o = t("../util/cmp");
            e.exports = {
                makeLevelList: r,
                makeSelectableLevelList: n
            }
        }, {
            "../util/cmp": 93
        }],
        57: [function (t, e, i) {
            e.exports = {
                WebGlStage: t("./stages/WebGl"),
                CssStage: t("./stages/Css"),
                FlashStage: t("./stages/Flash"),
                WebGlCubeRenderer: t("./renderers/WebGlCube"),
                WebGlFlatRenderer: t("./renderers/WebGlFlat"),
                WebGlEquirectRenderer: t("./renderers/WebGlEquirect"),
                CssCubeRenderer: t("./renderers/CssCube"),
                CssFlatRenderer: t("./renderers/CssFlat"),
                FlashCubeRenderer: t("./renderers/FlashCube"),
                FlashFlatRenderer: t("./renderers/FlashFlat"),
                registerDefaultRenderers: t("./renderers/registerDefaultRenderers"),
                CubeGeometry: t("./geometries/Cube"),
                FlatGeometry: t("./geometries/Flat"),
                EquirectGeometry: t("./geometries/Equirect"),
                RectilinearView: t("./views/Rectilinear"),
                FlatView: t("./views/Flat"),
                ImageUrlSource: t("./sources/ImageUrl"),
                SingleAssetSource: t("./sources/SingleAsset"),
                DynamicCanvasAsset: t("./assets/DynamicCanvas"),
                StaticCanvasAsset: t("./assets/StaticCanvas"),
                TextureStore: t("./TextureStore"),
                Layer: t("./Layer"),
                RenderLoop: t("./RenderLoop"),
                KeyControlMethod: t("./controls/Key"),
                DragControlMethod: t("./controls/Drag"),
                QtvrControlMethod: t("./controls/Qtvr"),
                ScrollZoomControlMethod: t("./controls/ScrollZoom"),
                PinchZoomControlMethod: t("./controls/PinchZoom"),
                VelocityControlMethod: t("./controls/Velocity"),
                ElementPressControlMethod: t("./controls/ElementPress"),
                Controls: t("./controls/Controls"),
                Dynamics: t("./controls/Dynamics"),
                Viewer: t("./Viewer"),
                Scene: t("./Scene"),
                Hotspot: t("./Hotspot"),
                HotspotContainer: t("./HotspotContainer"),
                colorEffects: t("./colorEffects"),
                registerDefaultControls: t("./controls/registerDefaultControls"),
                autorotate: t("./autorotate"),
                util: {
                    async: t("./util/async"),
                    cancelize: t("./util/cancelize"),
                    chain: t("./util/chain"),
                    clamp: t("./util/clamp"),
                    clock: t("./util/clock"),
                    cmp: t("./util/cmp"),
                    compose: t("./util/compose"),
                    convertFov: t("./util/convertFov"),
                    decimal: t("./util/decimal"),
                    defaults: t("./util/defaults"),
                    defer: t("./util/defer"),
                    degToRad: t("./util/degToRad"),
                    delay: t("./util/delay"),
                    dom: t("./util/dom"),
                    extend: t("./util/extend"),
                    hash: t("./util/hash"),
                    inherits: t("./util/inherits"),
                    mod: t("./util/mod"),
                    noop: t("./util/noop"),
                    once: t("./util/once"),
                    pixelRatio: t("./util/pixelRatio"),
                    radToDeg: t("./util/radToDeg"),
                    real: t("./util/real"),
                    retry: t("./util/retry"),
                    tween: t("./util/tween"),
                    type: t("./util/type")
                },
                dependencies: {
                    bowser: t("bowser"),
                    glMatrix: t("gl-matrix"),
                    eventEmitter: t("minimal-event-emitter"),
                    hammerjs: t("hammerjs")
                }
            }
        }, {
            "./Hotspot": 15,
            "./HotspotContainer": 16,
            "./Layer": 17,
            "./RenderLoop": 19,
            "./Scene": 20,
            "./TextureStore": 21,
            "./Viewer": 23,
            "./assets/DynamicCanvas": 24,
            "./assets/StaticCanvas": 26,
            "./autorotate": 28,
            "./colorEffects": 36,
            "./controls/Controls": 39,
            "./controls/Drag": 40,
            "./controls/Dynamics": 41,
            "./controls/ElementPress": 42,
            "./controls/Key": 44,
            "./controls/PinchZoom": 45,
            "./controls/Qtvr": 46,
            "./controls/ScrollZoom": 47,
            "./controls/Velocity": 48,
            "./controls/registerDefaultControls": 50,
            "./geometries/Cube": 52,
            "./geometries/Equirect": 53,
            "./geometries/Flat": 54,
            "./renderers/CssCube": 60,
            "./renderers/CssFlat": 61,
            "./renderers/FlashCube": 63,
            "./renderers/FlashFlat": 64,
            "./renderers/WebGlCube": 67,
            "./renderers/WebGlEquirect": 68,
            "./renderers/WebGlFlat": 69,
            "./renderers/registerDefaultRenderers": 70,
            "./sources/ImageUrl": 75,
            "./sources/SingleAsset": 76,
            "./stages/Css": 77,
            "./stages/Flash": 78,
            "./stages/WebGl": 81,
            "./util/async": 88,
            "./util/cancelize": 89,
            "./util/chain": 90,
            "./util/clamp": 91,
            "./util/clock": 92,
            "./util/cmp": 93,
            "./util/compose": 94,
            "./util/convertFov": 95,
            "./util/decimal": 96,
            "./util/defaults": 97,
            "./util/defer": 98,
            "./util/degToRad": 99,
            "./util/delay": 100,
            "./util/dom": 101,
            "./util/extend": 102,
            "./util/hash": 103,
            "./util/inherits": 104,
            "./util/mod": 106,
            "./util/noop": 107,
            "./util/once": 108,
            "./util/pixelRatio": 109,
            "./util/radToDeg": 110,
            "./util/real": 111,
            "./util/retry": 112,
            "./util/tween": 114,
            "./util/type": 115,
            "./views/Flat": 116,
            "./views/Rectilinear": 117,
            bowser: 1,
            "gl-matrix": 2,
            hammerjs: 12,
            "minimal-event-emitter": 13
        }],
        58: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                if (n()) {
                    var r = "translateX(" + a(e) + "px) translateY(" + a(i) + "px) translateZ(0)";
                    o(t, r)
                } else s(t, e, i)
            }
            var n = t("./support/Css"),
                o = t("./util/dom").setTransform,
                s = t("./util/dom").setPixelPosition,
                a = t("./util/decimal");
            e.exports = r
        }, {
            "./support/Css": 84,
            "./util/decimal": 96,
            "./util/dom": 101
        }],
        59: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                return t.cmp(e)
            }

            function n(t, e, i) {
                this._root = t, this._browserQuirks = e;
                var r = document.createElement("div");
                t.appendChild(r), r.style.position = "absolute", s(r), a(r), this._browserQuirks.useNullTransform && l(r), this.domElement = r, this._oldTileList = [], this._newTileList = [], this._textureMap = new o(i.equals, i.hash)
            }
            var o = t("../collections/Map"),
                s = t("../util/dom").setOverflowHidden,
                a = t("../util/dom").setNoPointerEvents,
                l = t("../util/dom").setNullTransform,
                h = t("../util/dom").setTransform,
                u = "undefined" != typeof MARZIPANODEBUG && MARZIPANODEBUG.css;
            n.prototype.destroy = function () {
                this._root.removeChild(this.domElement), this._textureMap = null, this.domElement = null
            }, n.prototype.startLayer = function (t, e) {
                var i = this.domElement;
                i.style.left = e.left + "px", i.style.top = e.top + "px", i.style.width = e.width + "px", i.style.height = e.height + "px";
                var r = 1,
                    n = t.effects();
                n && null != n.opacity && (r = n.opacity), i.style.opacity = r, this._newTileList.length = 0, this._textureMap.clear()
            }, n.prototype.renderTile = function (t, e) {
                this._newTileList.push(t), this._textureMap.set(t, e)
            }, n.prototype.endLayer = function (t) {
                var e, i, n, o, s, a, l, c, p = this.domElement,
                    d = this._oldTileList,
                    f = this._newTileList,
                    m = this._textureMap,
                    v = t.view();
                if (p.children.length !== d.length) throw new Error("DOM not in sync with tile list");
                for (f.sort(r), e = 0, n = d[e], l = p.firstChild, i = 0; i < f.length; i++) {
                    for (o = f[i]; e < d.length && !(n.cmp(o) >= 0);) c = l.nextSibling, p.removeChild(l), l = c, n = d[++e];
                    if (s = m.get(o), !(a = s ? s._canvas : null)) throw new Error("Rendering tile with missing texture");
                    if (n && 0 === n.cmp(o)) {
                        if (a != l) throw new Error("DOM not in sync with tile list");
                        l = l.nextSibling, n = d[++e]
                    } else p.insertBefore(a, l);
                    h(a, this.calculateTransform(o, s, v)), u && a.setAttribute("data-tile", o.str())
                }
                for (; l;) c = l.nextSibling, p.removeChild(l), l = c;
                if (p.children.length !== f.length) throw new Error("DOM not in sync with tile list");
                var _ = this._oldTileList;
                this._oldTileList = this._newTileList, this._newTileList = _
            }, e.exports = n
        }, {
            "../collections/Map": 32,
            "../util/dom": 101
        }],
        60: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this.constructor.super_.call(this, t, e, n)
            }
            var n = t("../geometries/Cube").TileClass,
                o = t("./CssBase"),
                s = t("../util/decimal");
            t("../util/inherits")(r, o), r.prototype.calculateTransform = function (t, e, i) {
                var r = this._browserQuirks.padSize,
                    n = this._browserQuirks.reverseLevelDepth,
                    o = this._browserQuirks.perspectiveNudge,
                    a = "",
                    l = n ? 256 - t.z : t.levelWidth(),
                    h = i.size(),
                    u = h.width,
                    c = h.height;
                a += "translate3d(" + s(u / 2) + "px, " + s(c / 2) + "px, 0px) ";
                var p = .5 * c / Math.tan(i.fov() / 2),
                    d = p + o;
                a += "perspective(" + s(p) + "px) translateZ(" + s(d) + "px) ";
                var f = -i.roll(),
                    m = -i.pitch(),
                    v = i.yaw();
                a += "rotateZ(" + s(f) + "rad) rotateX(" + s(m) + "rad) rotateY(" + s(v) + "rad) ";
                var _ = -t.rotX(),
                    y = t.rotY();
                a += "rotateX(" + s(_) + "rad) rotateY(" + s(y) + "rad) ";
                var g = t.centerX() - t.scaleX() / 2,
                    x = -(t.centerY() + t.scaleY() / 2),
                    M = g * l,
                    w = x * l,
                    b = -l / 2;
                if (a += "translate3d(" + s(M) + "px, " + s(w) + "px, " + s(b) + "px) ", n) {
                    var S = l * t.scaleX() / t.width(),
                        E = l * t.scaleY() / t.height();
                    a += "scale(" + s(S) + ", " + s(E) + ") "
                }
                var I = t.padLeft() ? r : 0,
                    D = t.padTop() ? r : 0;
                return 0 === I && 0 === D || (a += "translate3d(" + s(-I) + "px, " + s(-D) + "px, 0) "), a
            }, e.exports = r
        }, {
            "../geometries/Cube": 52,
            "../util/decimal": 96,
            "../util/inherits": 104,
            "./CssBase": 59
        }],
        61: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this.constructor.super_.call(this, t, e, n)
            }
            var n = t("../geometries/Flat").TileClass,
                o = t("./CssBase"),
                s = t("../util/decimal");
            t("../util/inherits")(r, o), r.prototype.calculateTransform = function (t, e, i) {
                var r = this._browserQuirks.padSize,
                    n = "",
                    o = i.width(),
                    a = i.height();
                n += "translateX(" + s(o / 2) + "px) translateY(" + s(a / 2) + "px) ";
                var l = o / i._zoomX(),
                    h = a / i._zoomY(),
                    u = t.centerX() - t.scaleX() / 2 + .5,
                    c = .5 - t.centerY() - t.scaleY() / 2,
                    p = u * l,
                    d = c * h;
                n += "translateX(" + s(p) + "px) translateY(" + s(d) + "px) ";
                var f = -i.x() * l,
                    m = -i.y() * h;
                n += "translateX(" + s(f) + "px) translateY(" + s(m) + "px) ";
                var v = t.padLeft() ? r : 0,
                    _ = t.padTop() ? r : 0;
                0 === v && 0 === _ || (n += "translateX(" + s(-v) + "px) translateY(" + s(-_) + "px) ");
                var y = l / t.levelWidth(),
                    g = h / t.levelHeight();
                return n += "scale(" + s(y) + ", " + s(g) + ") "
            }, e.exports = r
        }, {
            "../geometries/Flat": 54,
            "../util/decimal": 96,
            "../util/inherits": 104,
            "./CssBase": 59
        }],
        62: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                return t.cmp(e)
            }

            function n(t, e, i, r) {
                this._flashElement = t, this._layerId = e, this._quirks = i, this._tileList = [], this._textureMap = new o(r.equals, r.hash), this._layerCreated = !1
            }
            var o = t("../collections/Map");
            n.prototype.destroy = function () {
                this._flashElement.destroyLayer(this._layerId), this._flashElement = null, this._layerId = null, this._layerCreated = null, this._tileList = null, this._padSize = null
            }, n.prototype.startLayer = function (t, e) {
                this._flashElement.isReady && this._flashElement.isReady() && (this._layerCreated || (this._flashElement.createLayer(this._layerId), this._layerCreated = !0), this._tileList.length = 0, this._textureMap.clear())
            }, n.prototype.renderTile = function (t, e) {
                this._tileList.push(t), this._textureMap.set(t, e)
            }, n.prototype.endLayer = function (t, e) {
                if (this._flashElement.isReady && this._flashElement.isReady()) {
                    this._tileList.sort(r), this._renderOnFlash(t, e)
                }
            }, e.exports = n
        }, {
            "../collections/Map": 32
        }],
        63: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                this.constructor.super_.call(this, t, e, i, o), this._flashTileList = []
            }
            var n = t("./FlashBase"),
                o = t("../geometries/Cube").TileClass,
                s = t("../util/inherits"),
                a = t("../util/radToDeg");
            s(r, n), r.prototype._renderOnFlash = function (t, e) {
                var i = this._flashElement,
                    r = this._layerId,
                    n = this._quirks.padSize,
                    o = this._tileList,
                    s = this._textureMap,
                    l = this._flashTileList;
                l.length = 0;
                for (var h = 0; h < o.length; h++) {
                    var u = o[h],
                        c = s.get(u);
                    if (!c) throw new Error("Rendering tile with missing texture");
                    var p = u.padTop() ? n : 0,
                        d = u.padBottom() ? n : 0,
                        f = u.padLeft() ? n : 0,
                        m = u.padRight() ? n : 0;
                    l.push({
                        textureId: c._textureId,
                        face: u.face,
                        width: u.width(),
                        height: u.height(),
                        centerX: u.centerX(),
                        centerY: u.centerY(),
                        rotX: a(u.rotX()),
                        rotY: a(u.rotY()),
                        levelSize: u.levelWidth(),
                        padTop: p,
                        padBottom: d,
                        padLeft: f,
                        padRight: m
                    })
                }
                var v = 1,
                    _ = t.effects();
                _ && null != _.opacity && (v = _.opacity);
                var y = t.view(),
                    g = y.yaw(),
                    x = y.pitch(),
                    M = y.roll(),
                    w = y.fov();
                i.drawCubeTiles(r, e.width, e.height, e.left, e.top, v, g, x, M, w, l)
            }, e.exports = r
        }, {
            "../geometries/Cube": 52,
            "../util/inherits": 104,
            "../util/radToDeg": 110,
            "./FlashBase": 62
        }],
        64: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                this.constructor.super_.call(this, t, e, i, o), this._flashTileList = []
            }
            var n = t("./FlashBase"),
                o = t("../geometries/Flat").TileClass;
            t("../util/inherits")(r, n), r.prototype._renderOnFlash = function (t, e) {
                var i = this._flashElement,
                    r = this._layerId,
                    n = this._quirks.padSize,
                    o = this._tileList,
                    s = this._textureMap,
                    a = this._flashTileList;
                a.length = 0;
                for (var l = 0; l < o.length; l++) {
                    var h = o[l],
                        u = s.get(h);
                    if (!u) throw new Error("Rendering tile with missing texture");
                    var c = h.padTop() ? n : 0,
                        p = h.padBottom() ? n : 0,
                        d = h.padLeft() ? n : 0,
                        f = h.padRight() ? n : 0;
                    a.push({
                        textureId: u._textureId,
                        width: h.width(),
                        height: h.height(),
                        centerX: h.centerX(),
                        centerY: h.centerY(),
                        scaleX: h.scaleX(),
                        scaleY: h.scaleY(),
                        levelWidth: h.levelWidth(),
                        levelHeight: h.levelHeight(),
                        padTop: c,
                        padBottom: p,
                        padLeft: d,
                        padRight: f
                    })
                }
                var m = 1,
                    v = t.effects();
                v && null != v.opacity && (m = v.opacity);
                var _ = t.view(),
                    y = _.x(),
                    g = _.y(),
                    x = _._zoomX(),
                    M = _._zoomY();
                i.drawFlatTiles(r, e.width, e.height, e.left, e.top, m, y, g, x, M, a)
            }, e.exports = r
        }, {
            "../geometries/Flat": 54,
            "../util/inherits": 104,
            "./FlashBase": 62
        }],
        65: [function (t, e, i) {
            "use strict";

            function r(t) {
                this.gl = t, this.projMatrix = w.create(), this.viewportMatrix = w.create(), this.translateVector = b.create(), this.scaleVector = b.create(), this.constantBuffers = o(t, _, y, g), this.shaderProgram = a(t, m, v, x, M)
            }
            var n = t("./WebGlCommon"),
                o = n.createConstantBuffers,
                s = n.destroyConstantBuffers,
                a = n.createShaderProgram,
                l = n.destroyShaderProgram,
                h = n.enableAttributes,
                u = n.disableAttributes,
                c = n.setViewport,
                p = n.setupPixelEffectUniforms,
                d = n.setDepth,
                f = n.setTexture,
                m = t("../shaders/vertexNormal"),
                v = t("../shaders/fragmentNormal"),
                _ = [0, 1, 2, 0, 2, 3],
                y = [-.5, -.5, 0, .5, -.5, 0, .5, .5, 0, -.5, .5, 0],
                g = [0, 0, 1, 0, 1, 1, 0, 1],
                x = ["aVertexPosition", "aTextureCoord"],
                M = ["uDepth", "uOpacity", "uSampler", "uProjMatrix", "uViewportMatrix", "uColorOffset", "uColorMatrix"],
                w = t("gl-matrix/src/gl-matrix/mat4"),
                b = t("gl-matrix/src/gl-matrix/vec3");
            r.prototype.destroy = function () {
                s(this.gl, this.constantBuffers), this.constantBuffers = null, l(this.gl, this.shaderProgram), this.shaderProgram = null, this.projMatrix = null, this.viewportMatrix = null, this.translateVector = null, this.scaleVector = null, this.gl = null
            }, r.prototype.startLayer = function (t, e) {
                var i = this.gl,
                    r = this.shaderProgram,
                    n = this.constantBuffers,
                    o = this.viewportMatrix;
                i.useProgram(r), h(i, r);
                for (var s = i.getProgramParameter(r, i.ACTIVE_ATTRIBUTES), a = 0; a < s; a++) i.enableVertexAttribArray(a);
                c(i, t, e, o), i.uniformMatrix4fv(r.uViewportMatrix, !1, o), i.bindBuffer(i.ARRAY_BUFFER, n.vertexPositions), i.vertexAttribPointer(r.aVertexPosition, 3, i.FLOAT, i.FALSE, 0, 0), i.bindBuffer(i.ARRAY_BUFFER, n.textureCoords), i.vertexAttribPointer(r.aTextureCoord, 2, i.FLOAT, i.FALSE, 0, 0), p(i, t.effects(), {
                    opacity: r.uOpacity,
                    colorOffset: r.uColorOffset,
                    colorMatrix: r.uColorMatrix
                })
            }, r.prototype.endLayer = function () {
                var t = this.gl,
                    e = this.shaderProgram;
                u(t, e)
            }, r.prototype.renderTile = function (t, e, i, r) {
                var n = this.gl,
                    o = this.shaderProgram,
                    s = this.constantBuffers,
                    a = this.projMatrix,
                    l = this.translateVector,
                    h = this.scaleVector;
                l[0] = t.centerX(), l[1] = t.centerY(), l[2] = -.5, h[0] = t.scaleX(), h[1] = t.scaleY(), h[2] = 1, w.copy(a, i.view().projection()), w.rotateX(a, a, t.rotX()), w.rotateY(a, a, t.rotY()), w.translate(a, a, l), w.scale(a, a, h), n.uniformMatrix4fv(o.uProjMatrix, !1, a), d(n, o, r, t.z), f(n, o, e), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, s.vertexIndices), n.drawElements(n.TRIANGLES, _.length, n.UNSIGNED_SHORT, 0)
            }, e.exports = r
        }, {
            "../shaders/fragmentNormal": 72,
            "../shaders/vertexNormal": 74,
            "./WebGlCommon": 66,
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec3": 10
        }],
        66: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                var r = t.createShader(e);
                if (t.shaderSource(r, i), t.compileShader(r), !t.getShaderParameter(r, t.COMPILE_STATUS)) throw t.getShaderInfoLog(r);
                return r
            }

            function n(t, e, i, n, o) {
                var s = r(t, t.VERTEX_SHADER, e),
                    a = r(t, t.FRAGMENT_SHADER, i),
                    l = t.createProgram();
                if (t.attachShader(l, s), t.attachShader(l, a), t.linkProgram(l), !t.getProgramParameter(l, t.LINK_STATUS)) throw t.getProgramInfoLog(l);
                for (var h = 0; h < n.length; h++) {
                    var u = n[h];
                    if (l[u] = t.getAttribLocation(l, u), -1 === l[u]) throw new Error("Shader program has no " + u + " attribute")
                }
                for (var c = 0; c < o.length; c++) {
                    var p = o[c];
                    if (l[p] = t.getUniformLocation(l, p), -1 === l[p]) throw new Error("Shader program has no " + p + " uniform")
                }
                return l
            }

            function o(t, e) {
                for (var i = t.getAttachedShaders(e), r = 0; r < i.length; r++) {
                    var n = i[r];
                    t.detachShader(e, n), t.deleteShader(n)
                }
                t.deleteProgram(e)
            }

            function s(t, e, i, r) {
                var n = t.createBuffer();
                return t.bindBuffer(e, n), t.bufferData(e, r, i), n
            }

            function a(t, e, i, r) {
                return {
                    vertexIndices: s(t, t.ELEMENT_ARRAY_BUFFER, t.STATIC_DRAW, new Uint16Array(e)),
                    vertexPositions: s(t, t.ARRAY_BUFFER, t.STATIC_DRAW, new Float32Array(i)),
                    textureCoords: s(t, t.ARRAY_BUFFER, t.STATIC_DRAW, new Float32Array(r))
                }
            }

            function l(t, e) {
                t.deleteBuffer(e.vertexIndices), t.deleteBuffer(e.vertexPositions), t.deleteBuffer(e.textureCoords)
            }

            function h(t, e) {
                for (var i = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES), r = 0; r < i; r++) t.enableVertexAttribArray(r)
            }

            function u(t, e) {
                for (var i = t.getProgramParameter(e, t.ACTIVE_ATTRIBUTES), r = 0; r < i; r++) t.disableVertexAttribArray(r)
            }

            function c(t, e, i) {
                t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, i._texture), t.uniform1i(e.uSampler, 0)
            }

            function p(t, e, i, r) {
                var n = ((i + 1) * _ - r) / (_ * v);
                t.uniform1f(e.uDepth, n)
            }

            function d(t, e, i) {
                var r = b;
                e && null != e.opacity && (r = e.opacity), t.uniform1f(i.opacity, r);
                var n = S;
                e && e.colorOffset && (n = e.colorOffset), t.uniform4fv(i.colorOffset, n);
                var o = E;
                e && e.colorMatrix && (o = e.colorMatrix), t.uniformMatrix4fv(i.colorMatrix, !1, o)
            }

            function f(t, e, i, r) {
                var n = y();
                m(i, I, r), t.viewport(n * I.offsetX, n * I.offsetY, n * I.width, n * I.height)
            }

            function m(t, e, i) {
                var r = t.left,
                    n = t.totalWidth,
                    o = g(r, 0, n),
                    s = t.width - (o - r),
                    a = n - o,
                    l = g(s, 0, a);
                e.offsetX = o, e.width = l;
                var h = t.totalHeight - t.bottom,
                    u = t.totalHeight,
                    c = g(h, 0, u),
                    p = t.height - (c - h),
                    d = u - c,
                    f = g(p, 0, d);
                e.offsetY = c, e.height = f, T[0] = t.width / l, T[1] = t.height / f, T[2] = 1;
                var m = o - r,
                    v = r + t.width,
                    _ = o + l,
                    y = v - _,
                    x = c - h,
                    M = h + t.height,
                    b = c + f,
                    S = M - b;
                D[0] = (y - m) / l, D[1] = (S - x) / f, D[2] = 0;
                var E = i;
                w.identity(E), w.translate(E, E, D), w.scale(E, E, T)
            }
            var v = 256,
                _ = 256,
                y = t("../util/pixelRatio"),
                g = t("../util/clamp"),
                x = t("gl-matrix/src/gl-matrix/vec4"),
                M = t("gl-matrix/src/gl-matrix/vec3"),
                w = t("gl-matrix/src/gl-matrix/mat4"),
                b = 1,
                S = x.create(),
                E = w.create();
            w.identity(E);
            var I = {},
                D = M.create(),
                T = M.create();
            e.exports = {
                createShaderProgram: n,
                destroyShaderProgram: o,
                createConstantBuffers: a,
                destroyConstantBuffers: l,
                enableAttributes: h,
                disableAttributes: u,
                setTexture: c,
                setDepth: p,
                setViewport: f,
                setupPixelEffectUniforms: d
            }
        }, {
            "../util/clamp": 91,
            "../util/pixelRatio": 109,
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec3": 10,
            "gl-matrix/src/gl-matrix/vec4": 11
        }],
        67: [function (t, e, i) {
            "use strict";

            function r() {
                this.constructor.super_.apply(this, arguments)
            }
            var n = t("./WebGlBase");
            t("../util/inherits")(r, n), e.exports = r
        }, {
            "../util/inherits": 104,
            "./WebGlBase": 65
        }],
        68: [function (t, e, i) {
            "use strict";

            function r(t) {
                this.gl = t, this.invProjMatrix = w.create(), this.viewportMatrix = w.create(), this.constantBuffers = o(t, _, y, g), this.shaderProgram = a(t, m, v, x, M)
            }
            var n = t("./WebGlCommon"),
                o = n.createConstantBuffers,
                s = n.destroyConstantBuffers,
                a = n.createShaderProgram,
                l = n.destroyShaderProgram,
                h = n.enableAttributes,
                u = n.disableAttributes,
                c = n.setViewport,
                p = n.setupPixelEffectUniforms,
                d = n.setDepth,
                f = n.setTexture,
                m = t("../shaders/vertexEquirect"),
                v = t("../shaders/fragmentEquirect"),
                _ = [0, 1, 2, 0, 2, 3],
                y = [-1, -1, 0, 1, -1, 0, 1, 1, 0, -1, 1, 0],
                g = [0, 0, 1, 0, 1, 1, 0, 1],
                x = ["aVertexPosition"],
                M = ["uDepth", "uOpacity", "uSampler", "uInvProjMatrix", "uViewportMatrix", "uColorOffset", "uColorMatrix", "uTextureX", "uTextureY", "uTextureWidth", "uTextureHeight"],
                w = t("gl-matrix/src/gl-matrix/mat4");
            r.prototype.destroy = function () {
                s(this.gl, this.constantBuffers), this.constantBuffers = null, l(this.gl, this.shaderProgram), this.shaderProgram = null, this.invProjMatrix = null, this.viewportMatrix = null, this.gl = null
            }, r.prototype.startLayer = function (t, e) {
                var i = this.gl,
                    r = this.shaderProgram,
                    n = this.constantBuffers,
                    o = this.invProjMatrix,
                    s = this.viewportMatrix;
                i.useProgram(r), h(i, r), c(i, t, e, s), i.uniformMatrix4fv(r.uViewportMatrix, !1, s), i.bindBuffer(i.ARRAY_BUFFER, n.vertexPositions), i.vertexAttribPointer(r.aVertexPosition, 3, i.FLOAT, i.FALSE, 0, 0), i.bindBuffer(i.ARRAY_BUFFER, n.textureCoords), w.copy(o, t.view().projection()), w.invert(o, o), i.uniformMatrix4fv(r.uInvProjMatrix, !1, o);
                var a = t.effects().textureCrop || {},
                    l = null != a.x ? a.x : 0,
                    u = null != a.y ? a.y : 0,
                    d = null != a.width ? a.width : 1,
                    f = null != a.height ? a.height : 1;
                i.uniform1f(r.uTextureX, l), i.uniform1f(r.uTextureY, u), i.uniform1f(r.uTextureWidth, d), i.uniform1f(r.uTextureHeight, f), p(i, t.effects(), {
                    opacity: r.uOpacity,
                    colorOffset: r.uColorOffset,
                    colorMatrix: r.uColorMatrix
                })
            }, r.prototype.endLayer = function () {
                var t = this.gl,
                    e = this.shaderProgram;
                u(t, e)
            }, r.prototype.renderTile = function (t, e, i, r) {
                var n = this.gl,
                    o = this.shaderProgram,
                    s = this.constantBuffers;
                d(n, o, r, t.z), f(n, o, e), n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, s.vertexIndices), n.drawElements(n.TRIANGLES, _.length, n.UNSIGNED_SHORT, 0)
            }, e.exports = r
        }, {
            "../shaders/fragmentEquirect": 71,
            "../shaders/vertexEquirect": 73,
            "./WebGlCommon": 66,
            "gl-matrix/src/gl-matrix/mat4": 7
        }],
        69: [function (t, e, i) {
            "use strict";

            function r() {
                this.constructor.super_.apply(this, arguments)
            }
            var n = t("./WebGlBase");
            t("../util/inherits")(r, n), e.exports = r
        }, {
            "../util/inherits": 104,
            "./WebGlBase": 65
        }],
        70: [function (t, e, i) {
            "use strict";

            function r(t) {
                switch (t.type) {
                    case "webgl":
                        t.registerRenderer("flat", "flat", o), t.registerRenderer("cube", "rectilinear", n), t.registerRenderer("equirect", "rectilinear", s);
                        break;
                    case "css":
                        t.registerRenderer("flat", "flat", l), t.registerRenderer("cube", "rectilinear", a);
                        break;
                    case "flash":
                        t.registerRenderer("flat", "flat", u), t.registerRenderer("cube", "rectilinear", h);
                        break;
                    default:
                        throw new Error("Unknown stage type: " + t.type)
                }
            }
            var n = t("./WebGlCube"),
                o = t("./WebGlFlat"),
                s = t("./WebGlEquirect"),
                a = t("./CssCube"),
                l = t("./CssFlat"),
                h = t("./FlashCube"),
                u = t("./FlashFlat");
            e.exports = r
        }, {
            "./CssCube": 60,
            "./CssFlat": 61,
            "./FlashCube": 63,
            "./FlashFlat": 64,
            "./WebGlCube": 67,
            "./WebGlEquirect": 68,
            "./WebGlFlat": 69
        }],
        71: [function (t, e, i) {
            "use strict";
            e.exports = ["#ifdef GL_FRAGMENT_PRECISION_HIGH", "precision highp float;", "#else", "precision mediump float", "#endif", "uniform sampler2D uSampler;", "uniform float uOpacity;", "uniform float uTextureX;", "uniform float uTextureY;", "uniform float uTextureWidth;", "uniform float uTextureHeight;", "uniform vec4 uColorOffset;", "uniform mat4 uColorMatrix;", "varying vec4 vRay;", "const float PI = 3.14159265358979323846264;", "void main(void) {", "  float r = inversesqrt(vRay.x * vRay.x + vRay.y * vRay.y + vRay.z * vRay.z);", "  float phi  = acos(vRay.y * r);", "  float theta = atan(vRay.x, -1.0*vRay.z);", "  float s = 0.5 + 0.5 * theta / PI;", "  float t = 1.0 - phi / PI;", "  s = s * uTextureWidth + uTextureX;", "  t = t * uTextureHeight + uTextureY;", "  vec4 color = texture2D(uSampler, vec2(s, t)) * uColorMatrix + uColorOffset;", "  gl_FragColor = vec4(color.rgba * uOpacity);", "}"].join("\n")
        }, {}],
        72: [function (t, e, i) {
            "use strict";
            e.exports = ["#ifdef GL_FRAGMENT_PRECISION_HIGH", "precision highp float;", "#else", "precision mediump float;", "#endif", "uniform sampler2D uSampler;", "uniform float uOpacity;", "uniform vec4 uColorOffset;", "uniform mat4 uColorMatrix;", "varying vec2 vTextureCoord;", "void main(void) {", "  vec4 color = texture2D(uSampler, vTextureCoord) * uColorMatrix + uColorOffset;", "  gl_FragColor = vec4(color.rgba * uOpacity);", "}"].join("\n")
        }, {}],
        73: [function (t, e, i) {
            "use strict";
            e.exports = ["attribute vec3 aVertexPosition;", "uniform float uDepth;", "uniform mat4 uViewportMatrix;", "uniform mat4 uInvProjMatrix;", "varying vec4 vRay;", "void main(void) {", "  vRay = uInvProjMatrix * vec4(aVertexPosition.xy, 1.0, 1.0);", "  gl_Position = uViewportMatrix * vec4(aVertexPosition.xy, uDepth, 1.0);", "}"].join("\n")
        }, {}],
        74: [function (t, e, i) {
            "use strict";
            e.exports = ["attribute vec3 aVertexPosition;", "attribute vec2 aTextureCoord;", "uniform float uDepth;", "uniform mat4 uViewportMatrix;", "uniform mat4 uProjMatrix;", "varying vec2 vTextureCoord;", "void main(void) {", "  gl_Position = uViewportMatrix * uProjMatrix * vec4(aVertexPosition.xy, 0.0, 1.0);", "  gl_Position.z = uDepth * gl_Position.w;", "  vTextureCoord = aTextureCoord;", "}"].join("\n")
        }, {}],
        75: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                e = e || {}, this._loadPool = new a({
                    concurrency: e.concurrency || p
                }), this._retryDelay = e.retryDelay || d, this._retryMap = {}, this._sourceFromTile = t
            }

            function n(t) {
                var e = "\\{(" + t + ")\\}";
                return new RegExp(e, "g")
            }
            var o = t("minimal-event-emitter"),
                s = t("../NetworkError"),
                a = t("../collections/WorkPool"),
                l = t("../util/chain"),
                h = t("../util/delay"),
                u = t("../util/clock"),
                c = {
                    x: "x",
                    y: "y",
                    z: "z",
                    f: "face"
                },
                p = 4,
                d = 1e4;
            r.prototype.loadAsset = function (t, e, i) {
                var r, n = this,
                    o = this._retryDelay,
                    a = this._retryMap,
                    c = this._sourceFromTile(e),
                    p = c.url,
                    d = c.rect,
                    f = t.loadImage.bind(t, p, d),
                    m = function (t) {
                        return n._loadPool.push(f, function (i, r) {
                            i ? (i instanceof s && (a[p] = u(), n.emit("networkError", r, i)), t(i, e)) : (delete a[p], t(null, e, r))
                        })
                    },
                    v = a[p];
                if (null != v) {
                    var _ = u(),
                        y = _ - v;
                    y < o ? r = o - y : (r = 0, delete a[p])
                }
                var g = h.bind(null, r);
                return l(g, m)(i)
            }, r.fromString = function (t, e) {
                function i(e) {
                    var i = t;
                    for (var r in c) {
                        var o = c[r],
                            s = n(r),
                            a = e.hasOwnProperty(o) ? e[o] : "";
                        i = i.replace(s, a)
                    }
                    return {
                        url: i
                    }
                }

                function o(t) {
                    return 0 === t.z ? s(t) : i(t)
                }

                function s(t) {
                    var i = a.indexOf(t.face) / 6;
                    return {
                        url: e.cubeMapPreviewUrl,
                        rect: {
                            x: 0,
                            y: i,
                            width: 1,
                            height: 1 / 6
                        }
                    }
                }
                e = e || {};
                var a = e && e.cubeMapPreviewFaceOrder || "bdflru";
                return new r(e.cubeMapPreviewUrl ? o : i)
            }, r.stringHasFace = function (t) {
                return r.stringHasProperty(t, "f")
            }, r.stringHasX = function (t) {
                return r.stringHasProperty(t, "x")
            }, r.stringHasY = function (t) {
                return r.stringHasProperty(t, "y")
            }, r.stringHasLevel = function (t) {
                return r.stringHasProperty(t, "z")
            }, r.stringHasProperty = function (t, e) {
                return !!t.match(n(e))
            }, o(r), e.exports = r
        }, {
            "../NetworkError": 18,
            "../collections/WorkPool": 34,
            "../util/chain": 90,
            "../util/clock": 92,
            "../util/delay": 100,
            "minimal-event-emitter": 13
        }],
        76: [function (t, e, i) {
            "use strict";

            function r(t) {
                this._asset = t
            }
            r.prototype.asset = function () {
                return this._asset
            }, r.prototype.loadAsset = function (t, e, i) {
                function r() {
                    clearTimeout(o), i.apply(null, arguments)
                }
                var n = this,
                    o = setTimeout(function () {
                        i(null, e, n._asset)
                    }, 0);
                return r
            }, e.exports = r
        }, {}],
        77: [function (t, e, i) {
            "use strict";

            function r(t) {
                this.constructor.super_.call(this, t), this._domElement = document.createElement("div"), u(this._domElement), c(this._domElement)
            }

            function n(t, e, i) {
                var r = document.createElement("canvas");
                u(r), p(r), this._canvas = r, this._timestamp = null, this.refresh(e, i)
            }
            var o = t("./Stage"),
                s = t("../support/Css"),
                a = t("bowser"),
                l = t("../util/inherits"),
                h = t("./loadImageHtml"),
                u = t("../util/dom").setAbsolute,
                c = t("../util/dom").setFullSize,
                p = t("../util/dom").setNullTransformOrigin,
                d = {
                    padSize: a.ios ? 0 : 3,
                    reverseLevelDepth: a.ios,
                    useNullTransform: a.ios,
                    perspectiveNudge: a.webkit || a.gecko ? .001 : 0
                };
            l(r, o), r.prototype.destroy = function () {
                this.constructor.super_.prototype.destroy.call(this), this._domElement = null
            }, r.supported = function () {
                return s()
            }, r.prototype._setSize = function () {}, r.prototype.loadImage = h, r.prototype._validateLayer = function (t) {}, r.prototype.createRenderer = function (t) {
                return new t(this._domElement, d)
            }, r.prototype.destroyRenderer = function (t) {
                t.destroy()
            }, r.prototype.startFrame = function () {}, r.prototype.endFrame = function () {}, r.prototype.takeSnapshot = function () {
                throw new Error("CssStage: takeSnapshot not implemented")
            }, r.type = r.prototype.type = "css", n.prototype.refresh = function (t, e) {
                var i = e.timestamp();
                if (i !== this._timestamp) {
                    this._timestamp = i;
                    var r = this._canvas,
                        n = r.getContext("2d"),
                        o = e.element(),
                        s = t.width(),
                        a = t.height(),
                        l = d.padSize,
                        h = t.padTop() ? l : 0,
                        u = t.padBottom() ? l : 0,
                        c = t.padLeft() ? l : 0,
                        p = t.padRight() ? l : 0;
                    r.width = c + s + p, r.height = h + a + u, n.drawImage(o, c, h, s, a);
                    var f;
                    for (f = 0; f < h; f++) n.drawImage(r, c, h, s, 1, c, f, s, 1);
                    for (f = 0; f < c; f++) n.drawImage(r, c, h, 1, a, f, h, 1, a);
                    for (f = 0; f < u; f++) n.drawImage(r, c, h + a - 1, s, 1, c, h + a + f, s, 1);
                    for (f = 0; f < p; f++) n.drawImage(r, c + s - 1, h, 1, a, c + s + f, h, 1, a)
                }
            }, n.prototype.destroy = function () {
                this._canvas = null, this._timestamp = null
            }, r.TextureClass = r.prototype.TextureClass = n, e.exports = r
        }, {
            "../support/Css": 84,
            "../util/dom": 101,
            "../util/inherits": 104,
            "./Stage": 80,
            "./loadImageHtml": 83,
            bowser: 1
        }],
        78: [function (t, e, i) {
            "use strict";

            function r() {
                return window[y].__next++
            }

            function n(t) {
                if (this.constructor.super_.call(this, t), this._wmode = t && t.wmode || v, this._swfPath = t && t.swfPath || _, !_) throw new Error("Missing SWF path");
                this._flashStageId = r(), this._callbacksObj = window[y][this._flashStageId] = {}, this._stageCallbacksObjVarName = y + "[" + this._flashStageId + "]", this._callbackListeners = {};
                for (var e = 0; e < g.length; e++) this._callbacksObj[g[e]] = this._callListeners(g[e]);
                this._loadImageQueue = new h, this._loadImageQueue.pause(), this._flashReady = !1, this._nextLayerId = 0;
                var i = o(this._swfPath, this._flashStageId, this._stageCallbacksObjVarName);
                this._domElement = i.root, this._blockingElement = i.blocking, this._flashElement = i.flash, this._checkReadyTimer = setInterval(this._checkReady.bind(this), 50)
            }

            function o(t, e, i) {
                var r = document.createElement("div");
                p(r), d(r);
                var n = "marzipano-flash-stage-" + e,
                    o = '<object id="' + n + '" name="' + n + '" type="application/x-shockwave-flash" data="' + t + '">',
                    s = "";
                s += '<param name="movie" value="' + t + '" />', s += '<param name="allowscriptaccess" value="always" />', s += '<param name="flashvars" value="callbacksObjName=' + i + '" />', s += '<param name="wmode" value="transparent" />', o += s, o += "</object>";
                var a = document.createElement("div");
                a.innerHTML = o;
                var l = a.firstChild;
                p(l), d(l), r.appendChild(l);
                var h = document.createElement("div");
                return p(h), d(h), f(h), r.appendChild(h), {
                    root: r,
                    flash: l,
                    blocking: h
                }
            }

            function s(t, e, i) {
                var r = i.element(),
                    n = e.width(),
                    o = e.height(),
                    s = x.padSize,
                    a = e.padTop() ? s : 0,
                    l = e.padBottom() ? s : 0,
                    h = e.padLeft() ? s : 0,
                    u = e.padRight() ? s : 0,
                    c = t._flashElement.createTexture(r, n, o, a, l, h, u);
                this._stage = t, this._textureId = c
            }
            var a = t("./Stage"),
                l = t("../support/Flash"),
                h = t("../collections/WorkQueue"),
                u = t("../util/inherits"),
                c = t("../util/defer"),
                p = t("../util/dom").setAbsolute,
                d = t("../util/dom").setFullSize,
                f = t("../util/dom").setBlocking,
                m = t("./loadImageFlash"),
                v = "transparent",
                _ = function () {
                    var t = document.currentScript;
                    if (!t) {
                        var e = document.getElementsByTagName("script");
                        t = e.length ? e[e.length - 1] : null
                    }
                    if (!t) return null;
                    var i = t.src,
                        r = i.lastIndexOf("/");
                    return (i = r >= 0 ? i.slice(0, r + 1) : "") + "marzipano.swf"
                }(),
                y = "MarzipanoFlashCallbackMap";
            y in window || (window[y] = {
                __next: 0
            });
            var g = ["imageLoaded"],
                x = {
                    padSize: 3
                };
            u(n, a), n.prototype.destroy = function () {
                this.constructor.super_.prototype.destroy.call(this), this._domElement = null, this._blockingElement = null, this._flashElement = null, window[y][this._flashStageId] = null, this._callbacksObj = null, this._loadImageQueue = null, clearInterval(this._checkReadyTimer)
            }, n.supported = function () {
                return l()
            }, n.prototype._setSize = function () {}, n.prototype.loadImage = function (t, e, i) {
                var r = m.bind(null, this, t, e);
                return this._loadImageQueue.push(r, i)
            }, n.prototype._validateLayer = function (t) {}, n.prototype._onCallback = function (t, e) {
                this._callbackListeners[t] = this._callbackListeners[t] || [], this._callbackListeners[t].push(e)
            }, n.prototype._offCallback = function (t, e) {
                var i = this._callbackListeners[t] || [],
                    r = i.indexOf(e);
                r >= 0 && i.splice(r, 1)
            }, n.prototype._callListeners = function (t) {
                var e = this;
                return function () {
                    for (var i = e._callbackListeners[t] || [], r = 0; r < i.length; r++) {
                        c(i[r], arguments)
                    }
                }
            }, n.prototype._checkReady = function () {
                return !!(this._flashElement && this._flashElement.isReady && this._flashElement.isReady()) && (this._flashReady = !0, clearTimeout(this._checkReadyTimer), this._loadImageQueue.resume(), this.emitRenderInvalid(), !0)
            }, n.prototype.createRenderer = function (t) {
                return new t(this._flashElement, ++this._nextLayerId, x)
            }, n.prototype.destroyRenderer = function (t) {
                t.destroy()
            }, n.prototype.startFrame = function () {}, n.prototype.endFrame = function () {}, n.prototype.takeSnapshot = function (t) {
                "object" == typeof t && null != t || (t = {});
                var e = t.quality;
                if (void 0 === e && (e = 75), "number" != typeof e || e < 0 || e > 100) throw new Error("FlashStage: Snapshot quality needs to be a number between 0 and 100");
                return this._flashElement.takeSnapshot(e)
            }, n.type = n.prototype.type = "flash", s.prototype.refresh = function (t, e) {}, s.prototype.destroy = function () {
                var t = this._textureId;
                this._stage._flashElement.destroyTexture(t), this._stage = null, this._textureId = null
            }, n.TextureClass = n.prototype.TextureClass = s, e.exports = n
        }, {
            "../collections/WorkQueue": 35,
            "../support/Flash": 85,
            "../util/defer": 98,
            "../util/dom": 101,
            "../util/inherits": 104,
            "./Stage": 80,
            "./loadImageFlash": 82
        }],
        79: [function (t, e, i) {
            "use strict";

            function r() {
                this._renderers = {}
            }
            r.prototype.set = function (t, e, i) {
                this._renderers[t] || (this._renderers[t] = {}), this._renderers[t][e] = i
            }, r.prototype.get = function (t, e) {
                return this._renderers[t] && this._renderers[t][e] || null
            }, e.exports = r
        }, {}],
        80: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                return -t.cmp(e)
            }

            function n(t) {
                this._domElement = null, this._layers = [], this._renderers = [], this._visibleTiles = [], this._fallbackTiles = {
                    children: [],
                    parents: []
                }, this._tmpTiles = [], this._width = null, this._height = null, this._rect = {}, this._createTextureWorkQueue = new s({
                    delay: c
                }), this.emitRenderInvalid = this.emitRenderInvalid.bind(this), this._rendererRegistry = new u
            }
            var o = t("minimal-event-emitter"),
                s = t("../collections/WorkQueue"),
                a = t("../calcRect"),
                l = t("../util/async"),
                h = t("../util/cancelize"),
                u = t("./RendererRegistry"),
                c = 20;
            o(n), n.prototype.destroy = function () {
                this.removeAllLayers(), this._layers = null, this._renderers = null, this._visibleTiles = null, this._fallbackTiles = null, this._tmpTiles = null, this._width = null, this._height = null, this._createTextureWorkQueue = null, this.emitRenderInvalid = null, this._rendererRegistry = null
            }, n.prototype.registerRenderer = function (t, e, i) {
                return this._rendererRegistry.set(t, e, i)
            }, n.prototype.domElement = function () {
                return this._domElement
            }, n.prototype.width = function () {
                return this._width
            }, n.prototype.height = function () {
                return this._height
            }, n.prototype.size = function (t) {
                return t = t || {}, t.width = this._width, t.height = this._height, t
            }, n.prototype.setSize = function (t) {
                this._width = t.width, this._height = t.height, this._setSize(), this.emit("resize"), this.emitRenderInvalid()
            }, n.prototype.emitRenderInvalid = function () {
                this.emit("renderInvalid")
            }, n.prototype.listLayers = function () {
                return [].concat(this._layers)
            }, n.prototype.hasLayer = function (t) {
                return this._layers.indexOf(t) >= 0
            }, n.prototype.addLayer = function (t, e) {
                if (this._layers.indexOf(t) >= 0) throw new Error("Layer already in stage");
                if (null == e && (e = this._layers.length), e < 0 || e > this._layers.length) throw new Error("Invalid layer position");
                this._validateLayer(t), this._layers.splice(e, 0, t), this._renderers.splice(e, 0, null), t.addEventListener("viewChange", this.emitRenderInvalid), t.addEventListener("effectsChange", this.emitRenderInvalid), t.addEventListener("fixedLevelChange", this.emitRenderInvalid), t.addEventListener("textureStoreChange", this.emitRenderInvalid), this.emitRenderInvalid()
            }, n.prototype.moveLayer = function (t, e) {
                var i = this._layers.indexOf(t);
                if (i < 0) throw new Error("No such layer in stage");
                if (e < 0 || e >= this._layers.length) throw new Error("Invalid layer position");
                t = this._layers.splice(i, 1)[0];
                var r = this._renderers.splice(i, 1)[0];
                this._layers.splice(e, 0, t), this._renderers.splice(e, 0, r), this.emitRenderInvalid()
            }, n.prototype.removeLayer = function (t) {
                var e = this._layers.indexOf(t);
                if (e < 0) throw new Error("No such layer in stage");
                var i = this._layers.splice(e, 1)[0],
                    r = this._renderers.splice(e, 1)[0];
                r && this.destroyRenderer(r), i.removeEventListener("viewChange", this.emitRenderInvalid), i.removeEventListener("effectsChange", this.emitRenderInvalid), i.removeEventListener("fixedLevelChange", this.emitRenderInvalid), i.removeEventListener("textureStoreChange", this.emitRenderInvalid), this.emitRenderInvalid()
            }, n.prototype.removeAllLayers = function () {
                for (; this._layers.length > 0;) this.removeLayer(this._layers[0])
            }, n.prototype.render = function () {
                var t, e = this._visibleTiles,
                    i = this._fallbackTiles,
                    n = this._width,
                    o = this._height,
                    s = this._rect;
                if (!(n <= 0 || o <= 0)) {
                    for (this.startFrame(), t = 0; t < this._layers.length; t++) this._layers[t].textureStore().startFrame();
                    for (t = 0; t < this._layers.length; t++) {
                        var l = this._layers[t],
                            h = l.effects(),
                            u = l.view(),
                            c = this._updateRenderer(t),
                            p = this._layers.length - t,
                            d = l.textureStore();
                        if (a(n, o, h && h.rect, s), !(s.width <= 0 || s.height <= 0)) {
                            u.setSize(s), e.length = 0, l.visibleTiles(e), c.startLayer(l, s);
                            var f = i.parents,
                                m = i.children;
                            m.length = 0, f.length = 0, this._renderTiles(e, d, c, l, p, !0), this._renderTiles(m, d, c, l, p, !1), f.sort(r), this._renderTiles(f, d, c, l, p, !1), c.endLayer(l, s)
                        }
                    }
                    for (t = 0; t < this._layers.length; t++) this._layers[t].textureStore().endFrame();
                    this.endFrame()
                }
            }, n.prototype._updateRenderer = function (t) {
                var e = this._layers[t],
                    i = this.type,
                    r = e.geometry().type,
                    n = e.view().type,
                    o = this._rendererRegistry.get(r, n);
                if (!o) throw new Error("No " + i + " renderer avaiable for " + r + " geometry and " + n + " view");
                var s = this._renderers[t];
                return s ? s instanceof o || (this._renderers[t] = this.createRenderer(o), this.destroyRenderer(s)) : this._renderers[t] = this.createRenderer(o), this._renderers[t]
            }, n.prototype._renderTiles = function (t, e, i, r, n, o) {
                for (var s = 0; s < t.length; s++) {
                    var a = t[s];
                    e.markTile(a);
                    var l = e.texture(a);
                    l ? i.renderTile(a, l, r, n, s) : o && this._fallback(a, e)
                }
            }, n.prototype._fallback = function (t, e) {
                return this._childrenFallback(t, e) || this._parentFallback(t, e)
            }, n.prototype._parentFallback = function (t, e) {
                for (var i = this._fallbackTiles.parents; null != (t = t.parent());)
                    if (t && e.texture(t)) {
                        for (var r = 0; r < i.length; r++)
                            if (t.equals(i[r])) return !0;
                        return i.push(t), !0
                    }
                return !1
            }, n.prototype._childrenFallback = function (t, e) {
                var i = this._fallbackTiles.children,
                    r = this._tmpTiles;
                if (r.length = 0, !t.children(r)) return !1;
                if (1 === r.length && !e.texture(r[0])) return this._childrenFallback(r[0], e, i);
                for (var n = !1, o = 0; o < r.length; o++) e.texture(r[o]) ? i.push(r[o]) : n = !0;
                return !n
            }, n.prototype.createTexture = function (t, e, i) {
                function r() {
                    return new n.TextureClass(n, t, e)
                }
                var n = this,
                    o = h(l(r));
                return this._createTextureWorkQueue.push(o, function (r, n) {
                    i(r, t, e, n)
                })
            }, e.exports = n
        }, {
            "../calcRect": 29,
            "../collections/WorkQueue": 35,
            "../util/async": 88,
            "../util/cancelize": 89,
            "./RendererRegistry": 79,
            "minimal-event-emitter": 13
        }],
        81: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                var i = {
                    alpha: !0,
                    premultipliedAlpha: !0,
                    antialias: !(!e || !e.antialias),
                    preserveDrawingBuffer: !(!e || !e.preserveDrawingBuffer)
                };
                _ && "undefined" != typeof WebGLDebugUtils && (console.log("Using WebGL lost context simulator"), t = WebGLDebugUtils.makeLostContextSimulatingCanvas(t));
                var r = t.getContext && (t.getContext("webgl", i) || t.getContext("experimental-webgl", i));
                if (!r) throw new Error("Could not get WebGL context");
                return _ && "undefined" != typeof WebGLDebugUtils && (r = WebGLDebugUtils.makeDebugContext(r), console.log("Using WebGL debug context")), r
            }

            function n(t) {
                function e(t, e) {
                    return t === e
                }

                function i(t) {
                    return d(t.toString())
                }
                t = t || {};
                var n = this;
                this.constructor.super_.call(this, t), this._generateMipmaps = null != t.generateMipmaps && t.generateMipmaps, this._domElement = document.createElement("canvas"), m(this._domElement), v(this._domElement), this._gl = r(this._domElement, t), this._handleContextLoss = function () {
                    n.emit("webglcontextlost"), n._gl = null
                }, this._domElement.addEventListener("webglcontextlost", this._handleContextLoss), this._rendererInstances = new h(e, i)
            }

            function o(t, e, i) {
                this._stage = t, this._gl = t._gl, this._texture = null, this._timestamp = null, this._width = this._height = null, this.refresh(e, i)
            }
            var s = t("./Stage"),
                a = t("../support/WebGl"),
                l = t("bowser"),
                h = t("../collections/Map"),
                u = t("./loadImageHtml"),
                c = t("../util/inherits"),
                p = (t("../util/defer"), t("../util/pixelRatio")),
                d = t("../util/hash"),
                f = t("../util/ispot"),
                m = t("../util/dom").setAbsolute,
                v = (t("../util/dom").setPixelSize, t("../util/dom").setFullSize),
                _ = "undefined" != typeof MARZIPANODEBUG && MARZIPANODEBUG.webGl,
                y = {
                    videoUseTexImage2D: l.chrome
                };
            c(n, s), n.prototype.destroy = function () {
                this.constructor.super_.prototype.destroy.call(this), this.removeEventListener("webglcontextlost", this._handleContextLoss), this._domElement = null, this._rendererInstances = null, this._gl = null
            }, n.supported = function () {
                return a()
            }, n.prototype.webGlContext = function () {
                return this._gl
            }, n.prototype._setSize = function () {
                var t = p();
                this._domElement.width = t * this._width, this._domElement.height = t * this._height
            }, n.prototype.loadImage = u, n.prototype.maxTextureSize = function () {
                return this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE)
            }, n.prototype._validateLayer = function (t) {
                var e = t.geometry().maxTileSize(),
                    i = this.maxTextureSize();
                if (e > i) throw new Error("Layer has level with tile size larger than maximum texture size (" + e + " vs. " + i + ")")
            }, n.prototype.createRenderer = function (t) {
                if (this._rendererInstances.has(t)) return this._rendererInstances.get(t);
                var e = new t(this._gl);
                return this._rendererInstances.set(t, e), e
            }, n.prototype.destroyRenderer = function (t) {
                this._renderers.indexOf(t) < 0 && (t.destroy(), this._rendererInstances.del(t.constructor))
            }, n.prototype.startFrame = function () {
                var t = this._gl;
                if (!t) throw new Error("Bad WebGL context - maybe context was lost?");
                var e = this._width,
                    i = this._height,
                    r = p();
                t.viewport(0, 0, r * e, r * i), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT), t.enable(t.DEPTH_TEST), t.enable(t.BLEND), t.blendFunc(t.ONE, t.ONE_MINUS_SRC_ALPHA)
            }, n.prototype.endFrame = function () {}, n.prototype.takeSnapshot = function (t) {
                "object" == typeof t && null != t || (t = {});
                var e = t.quality;
                if (void 0 === e && (e = 75), "number" != typeof e || e < 0 || e > 100) throw new Error("WebGLStage: Snapshot quality needs to be a number between 0 and 100");
                return this.render(), this._domElement.toDataURL("image/jpeg", e / 100)
            }, n.type = n.prototype.type = "webgl", o.prototype.refresh = function (t, e) {
                var i, r = this._gl,
                    n = this._stage,
                    o = e.timestamp();
                if (o !== this._timestamp) {
                    var s = e.element(),
                        a = e.width(),
                        l = e.height();
                    if (a !== this._width || l !== this._height) {
                        var h = n.maxTextureSize();
                        if (a > h) throw new Error("Texture width larger than max size (" + a + " vs. " + h + ")");
                        if (l > h) throw new Error("Texture height larger than max size (" + l + " vs. " + h + ")");
                        this._texture && r.deleteTexture(i), i = this._texture = r.createTexture(), r.bindTexture(r.TEXTURE_2D, i), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !0), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, s)
                    } else i = this._texture, r.bindTexture(r.TEXTURE_2D, i), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !0), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), s instanceof HTMLVideoElement && y.videoUseTexImage2D ? r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, s) : r.texSubImage2D(r.TEXTURE_2D, 0, 0, 0, r.RGBA, r.UNSIGNED_BYTE, s);
                    n._generateMipmaps && f(a) && f(l) ? (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR_MIPMAP_LINEAR), r.generateMipmap(r.TEXTURE_2D)) : (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR)), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.bindTexture(r.TEXTURE_2D, null), this._timestamp = o, this._width = a, this._height = l
                }
            }, o.prototype.destroy = function () {
                var t = this._texture,
                    e = this._gl;
                t && e.deleteTexture(t), this._stage = null, this._gl = null, this._texture = null, this._timestamp = null, this._width = this._height = null
            }, n.TextureClass = n.prototype.TextureClass = o, e.exports = n
        }, {
            "../collections/Map": 32,
            "../support/WebGl": 86,
            "../util/defer": 98,
            "../util/dom": 101,
            "../util/hash": 103,
            "../util/inherits": 104,
            "../util/ispot": 105,
            "../util/pixelRatio": 109,
            "./Stage": 80,
            "./loadImageHtml": 83,
            bowser: 1
        }],
        82: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r) {
                function a(i, o) {
                    o === f && (t._offCallback("imageLoaded", a), i ? r(new n("Network error: " + e)) : r(null, new s(h, f)))
                }

                function l() {
                    h.cancelImage(f), t._offCallback("imageLoaded", a), r.apply(null, arguments)
                }
                var h = t._flashElement,
                    u = i && i.x || 0,
                    c = i && i.y || 0,
                    p = i && i.width || 1,
                    d = i && i.height || 1,
                    f = h.loadImage(e, p, d, u, c);
                return r = o(r), t._onCallback("imageLoaded", a), l
            }
            var n = t("../NetworkError"),
                o = t("../util/once"),
                s = t("../assets/FlashImage");
            e.exports = r
        }, {
            "../NetworkError": 18,
            "../assets/FlashImage": 25,
            "../util/once": 108
        }],
        83: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                function r() {
                    l.onload = l.onerror = null, l.src = "", i.apply(null, arguments)
                }
                var l = new Image;
                l.crossOrigin = "anonymous";
                var h = e && e.x || 0,
                    u = e && e.y || 0,
                    c = e && e.width || 1,
                    p = e && e.height || 1;
                return i = o(i), l.onload = function () {
                    if (0 === h && 0 === u && 1 === c && 1 === p) i(null, new s(l));
                    else {
                        h *= l.naturalWidth, u *= l.naturalHeight, c *= l.naturalWidth, p *= l.naturalHeight;
                        var t = document.createElement("canvas");
                        t.width = c, t.height = p;
                        t.getContext("2d").drawImage(l, h, u, c, p, 0, 0, c, p), i(null, new a(t))
                    }
                }, l.onerror = function () {
                    i(new n("Network error: " + t))
                }, l.src = t, r
            }
            var n = t("../NetworkError"),
                o = t("../util/once"),
                s = t("../assets/StaticImage"),
                a = t("../assets/StaticCanvas");
            e.exports = r
        }, {
            "../NetworkError": 18,
            "../assets/StaticCanvas": 26,
            "../assets/StaticImage": 27,
            "../util/once": 108
        }],
        84: [function (t, e, i) {
            "use strict";

            function r() {
                var t = s("perspective"),
                    e = document.createElement("div"),
                    i = "undefined" != typeof e.style[t];
                if (i && "WebkitPerspective" === t) {
                    var r = "__marzipano_test_css3d_support__",
                        n = document.createElement("style");
                    n.textContent = "@media(-webkit-transform-3d){#" + r + "{height: 3px;})", document.getElementsByTagName("head")[0].appendChild(n), e.id = r, document.body.appendChild(e), i = e.offsetHeight > 0, n.parentNode.removeChild(n), e.parentNode.removeChild(e)
                }
                return i
            }

            function n() {
                return o !== undefined ? o : o = r()
            }
            var o, s = t("../util/dom").prefixProperty;
            e.exports = n
        }, {
            "../util/dom": 101
        }],
        85: [function (t, e, i) {
            "use strict";

            function r() {
                var t = null,
                    e = navigator.plugins,
                    i = navigator.mimeTypes,
                    r = null;
                if (e && e["Shockwave Flash"] && i && i["application/x-shockwave-flash"] && i["application/x-shockwave-flash"].enabledPlugin) r = e["Shockwave Flash"].description, r = r.replace(/^.*\s+(\S+\s+\S+$)/, "$1"), t = [0, 0, 0], t[0] = parseInt(r.replace(/^(.*)\..*$/, "$1"), 10), t[1] = parseInt(r.replace(/^.*\.(.*)\s.*$/, "$1"), 10), t[2] = /[a-zA-Z]/.test(r) ? parseInt(r.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
                else if (window.ActiveXObject) try {
                    var n = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
                    n && (r = n.GetVariable("$version")) && (r = r.split(" ")[1].split(","), t = [parseInt(r[0], 10), parseInt(r[1], 10), parseInt(r[2], 10)])
                } catch (o) {}
                return t
            }

            function n() {
                var t = r();
                return t && (t[0] >= 11 || 10 === t[0] && t[1] >= 1)
            }

            function o() {
                return s !== undefined ? s : s = n()
            }
            var s;
            e.exports = o
        }, {}],
        86: [function (t, e, i) {
            "use strict";

            function r() {
                var t = document.createElement("canvas");
                return !(!t.getContext || !t.getContext("webgl") && !t.getContext("experimental-webgl"))
            }

            function n() {
                return o !== undefined ? o : o = r()
            }
            var o;
            e.exports = n
        }, {}],
        87: [function (t, e, i) {
            "use strict";

            function r() {
                var t = document.createElement("a").style;
                t.cssText = "pointer-events:auto";
                var e = "auto" === t.pointerEvents,
                    i = s.msie && parseFloat(s.version) < 11;
                return e && !i
            }

            function n() {
                return o !== undefined ? o : o = r()
            }
            var o, s = t("bowser");
            e.exports = n
        }, {
            bowser: 1
        }],
        88: [function (t, e, i) {
            "use strict";

            function r(t) {
                return function (e) {
                    var i, r;
                    try {
                        r = t()
                    } catch (n) {
                        i = n
                    } finally {
                        e(i || null, i ? null : r)
                    }
                }
            }
            e.exports = r
        }, {}],
        89: [function (t, e, i) {
            "use strict";

            function r(t) {
                return function () {
                    function e() {
                        r.apply(null, arguments)
                    }
                    if (!arguments.length) throw new Error("cancelized: expected at least one argument");
                    var i = Array.prototype.slice.call(arguments, 0),
                        r = i[i.length - 1] = n(i[i.length - 1]);
                    return t.apply(null, i), e
                }
            }
            var n = t("./once");
            e.exports = r
        }, {
            "./once": 108
        }],
        90: [function (t, e, i) {
            "use strict";

            function r() {
                var t = Array.prototype.slice.call(arguments, 0);
                return function () {
                    function e() {
                        if (arguments[0]) return o = s = null, void l.apply(null, arguments);
                        if (!r.length) return o = s = null, void l.apply(null, arguments);
                        o = r.shift();
                        var t = o,
                            i = Array.prototype.slice.call(arguments, 1);
                        i.push(e);
                        var n = o.apply(null, i);
                        if (t === o) {
                            if ("function" != typeof n) throw new Error("chain: chaining on non-cancellable function");
                            s = n
                        }
                    }

                    function i() {
                        s && s.apply(null, arguments)
                    }
                    var r = t.slice(0),
                        o = null,
                        s = null,
                        a = arguments.length ? Array.prototype.slice.call(arguments, 0, arguments.length - 1) : [],
                        l = arguments.length ? arguments[arguments.length - 1] : n;
                    return a.unshift(null), e.apply(null, a), i
                }
            }
            var n = t("./noop");
            e.exports = r
        }, {
            "./noop": 107
        }],
        91: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                return Math.min(Math.max(t, e), i)
            }
            e.exports = r
        }, {}],
        92: [function (t, e, i) {
            "use strict";
            var r = function () {
                return window.performance && window.performance.now ? function () {
                    return window.performance.now()
                } : null
            }() || function () {
                return function () {
                    return Date.now()
                }
            }();
            e.exports = r
        }, {}],
        93: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                return t < e ? -1 : t > e ? 1 : 0
            }
            e.exports = r
        }, {}],
        94: [function (t, e, i) {
            "use strict";

            function r() {
                var t = arguments;
                return function (e) {
                    for (var i = e, r = 0; r < t.length; r++) {
                        i = t[r].call(null, i)
                    }
                    return i
                }
            }
            e.exports = r
        }, {}],
        95: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                return 2 * Math.atan(i * Math.tan(t / 2) / e)
            }

            function n(t, e, i) {
                return r(t, e, i)
            }

            function o(t, e, i) {
                return r(t, e, Math.sqrt(e * e + i * i))
            }

            function s(t, e, i) {
                return r(t, i, e)
            }

            function a(t, e, i) {
                return r(t, i, Math.sqrt(e * e + i * i))
            }

            function l(t, e, i) {
                return r(t, Math.sqrt(e * e + i * i), e)
            }

            function h(t, e, i) {
                return r(t, Math.sqrt(e * e + i * i), i)
            }
            e.exports = {
                convert: r,
                htov: n,
                htod: o,
                vtoh: s,
                vtod: a,
                dtoh: l,
                dtov: h
            }
        }, {}],
        96: [function (t, e, i) {
            "use strict";

            function r(t) {
                return t.toPrecision(15)
            }
            e.exports = r
        }, {}],
        97: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                for (var i in e) i in t || (t[i] = e[i]);
                return t
            }
            e.exports = r
        }, {}],
        98: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                function i() {
                    e && e.length > 0 ? t.apply(null, e) : t()
                }
                setTimeout(i, 0)
            }
            e.exports = r
        }, {}],
        99: [function (t, e, i) {
            "use strict";

            function r(t) {
                return t * Math.PI / 180
            }
            e.exports = r
        }, {}],
        100: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                function i() {
                    null != n && (n = null, e(null))
                }

                function r() {
                    null != n && (clearTimeout(n), n = null, e.apply(null, arguments))
                }
                var n = null;
                return n = setTimeout(i, t), r
            }
            e.exports = r
        }, {}],
        101: [function (t, e, i) {
            "use strict";

            function r(t) {
                for (var e = document.documentElement.style, i = ["Moz", "Webkit", "Khtml", "O", "ms"], r = 0; r < i.length; r++) {
                    var n = i[r],
                        o = t[0].toUpperCase() + t.slice(1),
                        s = n + o;
                    if (s in e) return s
                }
                return t
            }

            function n(t) {
                var e = r(t);
                return function (t) {
                    return t.style[e]
                }
            }

            function o(t) {
                var e = r(t);
                return function (t, i) {
                    return t.style[e] = i
                }
            }

            function s(t) {
                _(t, "translateZ(0)")
            }

            function a(t) {
                y(t, "0 0 0")
            }

            function l(t) {
                t.style.position = "absolute"
            }

            function h(t, e, i) {
                t.style.left = e + "px", t.style.top = i + "px"
            }

            function u(t, e, i) {
                t.style.width = e + "px", t.style.height = i + "px"
            }

            function c(t) {
                t.style.width = t.style.height = 0
            }

            function p(t) {
                t.style.width = t.style.height = "100%"
            }

            function d(t) {
                t.style.overflow = "hidden"
            }

            function f(t) {
                t.style.overflow = "visible"
            }

            function m(t) {
                t.style.pointerEvents = "none"
            }

            function v(t) {
                t.style.backgroundColor = "#000", t.style.opacity = "0", t.style.filter = "alpha(opacity=0)"
            }
            var _ = o("transform"),
                y = o("transformOrigin");
            e.exports = {
                prefixProperty: r,
                getWithVendorPrefix: n,
                setWithVendorPrefix: o,
                setTransform: _,
                setTransformOrigin: y,
                setNullTransform: s,
                setNullTransformOrigin: a,
                setAbsolute: l,
                setPixelPosition: h,
                setPixelSize: u,
                setNullSize: c,
                setFullSize: p,
                setOverflowHidden: d,
                setOverflowVisible: f,
                setNoPointerEvents: m,
                setBlocking: v
            }
        }, {}],
        102: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                for (var i in e) t[i] = e[i];
                return t
            }
            e.exports = r
        }, {}],
        103: [function (t, e, i) {
            "use strict";

            function r() {
                for (var t = 0, e = 0; e < arguments.length; e++) {
                    var i = arguments[e];
                    t += i, t += i << 10, t ^= i >> 6
                }
                return t += t << 3, t ^= t >> 11, t += t << 15, t >= 0 ? t : -t
            }
            e.exports = r
        }, {}],
        104: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                t.super_ = e;
                var i = function () {};
                i.prototype = e.prototype, t.prototype = new i, t.prototype.constructor = t
            }
            e.exports = r
        }, {}],
        105: [function (t, e, i) {
            "use strict";

            function r(t) {
                return 0 == (t & t - 1)
            }
            e.exports = r
        }, {}],
        106: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                return (+t % (e = +e) + e) % e
            }
            e.exports = r
        }, {}],
        107: [function (t, e, i) {
            "use strict";

            function r() {}
            e.exports = r
        }, {}],
        108: [function (t, e, i) {
            "use strict";

            function r(t) {
                var e, i = !1;
                return function () {
                    return i || (i = !0, e = t.apply(null, arguments)), e
                }
            }
            e.exports = r
        }, {}],
        109: [function (t, e, i) {
            "use strict";

            function r() {
                if ("undefined" != typeof window) {
                    if (window.devicePixelRatio) return window.devicePixelRatio;
                    var t = window.screen;
                    if (t && t.deviceXDPI && t.logicalXDPI) return t.deviceXDPI / t.logicalXDPI;
                    if (t && t.systemXDPI && t.logicalXDPI) return t.systemXDPI / t.logicalXDPI
                }
                return n
            }
            var n = 1;
            e.exports = r
        }, {}],
        110: [function (t, e, i) {
            "use strict";

            function r(t) {
                return 180 * t / Math.PI
            }
            e.exports = r
        }, {}],
        111: [function (t, e, i) {
            "use strict";

            function r(t) {
                return "number" == typeof t && isFinite(t)
            }
            e.exports = r
        }, {}],
        112: [function (t, e, i) {
            "use strict";

            function r(t) {
                return function () {
                    function e() {
                        !arguments[0] || s ? r.apply(null, arguments) : o = t.apply(null, i)
                    }
                    var i = arguments.length ? Array.prototype.slice.call(arguments, 0, arguments.length - 1) : [],
                        r = arguments.length ? arguments[arguments.length - 1] : n,
                        o = null,
                        s = !1;
                    return i.push(e), e(!0),
                        function () {
                            s = !0, o.apply(null, arguments)
                        }
                }
            }
            var n = t("./noop");
            e.exports = r
        }, {
            "./noop": 107
        }],
        113: [function (t, e, i) {
            "use strict";

            function r(t, e, i, r, l) {
                return o.copy(a, s), i && o.rotateY(a, a, i), r && o.rotateX(a, a, r), l && o.rotateZ(a, a, l), n.transformMat4(t, e, a), t
            }
            var n = t("gl-matrix/src/gl-matrix/vec3"),
                o = t("gl-matrix/src/gl-matrix/mat4"),
                s = o.identity(o.create()),
                a = o.create();
            e.exports = r
        }, {
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec3": 10
        }],
        114: [function (t, e, i) {
            "use strict";

            function r(t, e, i) {
                function r() {
                    if (!o) {
                        var a = (n() - s) / t;
                        a < 1 ? (e(a), requestAnimationFrame(r)) : (e(1), i())
                    }
                }
                var o = !1,
                    s = n();
                return e(0), requestAnimationFrame(r),
                    function () {
                        o = !0, i.apply(null, arguments)
                    }
            }
            var n = t("./clock");
            e.exports = r
        }, {
            "./clock": 92
        }],
        115: [function (t, e, i) {
            "use strict";

            function r(t) {
                var e = typeof t;
                if ("object" === e) {
                    if (null === t) return "null";
                    if ("[object Array]" === Object.prototype.toString.call(t)) return "array";
                    if ("[object RegExp]" === Object.prototype.toString.call(t)) return "regexp"
                }
                return e
            }
            e.exports = r
        }, {}],
        116: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                if (!t || null == t.mediaAspectRatio) throw new Error("mediaAspectRatio must be defined");
                this._x = t && null != t.x ? t.x : p, this._y = t && null != t.y ? t.y : d, this._zoom = t && null != t.zoom ? t.zoom : f, this._mediaAspectRatio = t.mediaAspectRatio, this._width = t && null != t.width ? t.width : u, this._height = t && null != t.height ? t.height : c, this._limiter = e || null, this._viewFrustum = [0, 0, 0, 0], this._projectionMatrix = l.create(), this._projectionChanged = !0, this._params = {}, this._vertex = h.create(), this._invProj = l.create(), this._update()
            }
            var n = t("minimal-event-emitter"),
                o = t("../util/pixelRatio"),
                s = t("../util/real"),
                a = t("../util/clamp"),
                l = t("gl-matrix/src/gl-matrix/mat4"),
                h = t("gl-matrix/src/gl-matrix/vec4"),
                u = 0,
                c = 0,
                p = .5,
                d = .5,
                f = 1,
                m = [1, 0, 1, 0],
                v = [-1, -1, 1, 1];
            n(r), r.prototype.destroy = function () {
                this._x = null, this._y = null, this._zoom = null, this._mediaAspectRatio = null, this._width = null, this._height = null, this._limiter = null, this._viewFrustum = null, this._projectionMatrix = null, this._projectionChanged = null, this._params = null, this._vertex = null, this._invProj = null
            }, r.prototype.x = function () {
                return this._x
            }, r.prototype.y = function () {
                return this._y
            }, r.prototype.zoom = function () {
                return this._zoom
            }, r.prototype.mediaAspectRatio = function () {
                return this._mediaAspectRatio
            }, r.prototype.width = function () {
                return this._width
            }, r.prototype.height = function () {
                return this._height
            }, r.prototype.size = function (t) {
                return t = t || {}, t.width = this._width, t.height = this._height, t
            }, r.prototype.parameters = function (t) {
                return t = t || {}, t.x = this._x, t.y = this._y, t.zoom = this._zoom, t.mediaAspectRatio = this._mediaAspectRatio, t
            }, r.prototype.limiter = function () {
                return this._limiter
            }, r.prototype.setX = function (t) {
                this._resetParams(), this._params.x = t, this._update(this._params)
            }, r.prototype.setY = function (t) {
                this._resetParams(), this._params.y = t, this._update(this._params)
            }, r.prototype.setZoom = function (t) {
                this._resetParams(), this._params.zoom = t, this._update(this._params)
            }, r.prototype.offsetX = function (t) {
                this.setX(this._x + t)
            }, r.prototype.offsetY = function (t) {
                this.setY(this._y + t)
            }, r.prototype.offsetZoom = function (t) {
                this.setZoom(this._zoom + t)
            }, r.prototype.setMediaAspectRatio = function (t) {
                this._resetParams(), this._params.mediaAspectRatio = t, this._update(this._params)
            }, r.prototype.setSize = function (t) {
                this._resetParams(), this._params.width = t.width, this._params.height = t.height, this._update(this._params)
            }, r.prototype.setParameters = function (t) {
                this._resetParams();
                var e = this._params;
                e.x = t.x, e.y = t.y, e.zoom = t.zoom, e.mediaAspectRatio = t.mediaAspectRatio, this._update(e)
            }, r.prototype.setLimiter = function (t) {
                this._limiter = t || null, this._update()
            }, r.prototype._resetParams = function () {
                var t = this._params;
                t.x = null, t.y = null, t.zoom = null, t.mediaAspectRatio = null, t.width = null, t.height = null
            }, r.prototype._update = function (t) {
                null == t && (this._resetParams(), t = this._params);
                var e = this._x,
                    i = this._y,
                    r = this._zoom,
                    n = this._mediaAspectRatio,
                    o = this._width,
                    l = this._height;
                if (t.x = null != t.x ? t.x : e, t.y = null != t.y ? t.y : i, t.zoom = null != t.zoom ? t.zoom : r, t.mediaAspectRatio = null != t.mediaAspectRatio ? t.mediaAspectRatio : n, t.width = null != t.width ? t.width : o, t.height = null != t.height ? t.height : l, this._limiter && !(t = this._limiter(t))) throw new Error("Bad view limiter");
                var h = t.x,
                    u = t.y,
                    c = t.zoom,
                    p = t.mediaAspectRatio,
                    d = t.width,
                    f = t.height;
                if (!(s(h) && s(u) && s(c) && s(p) && s(d) && s(f))) throw new Error("Bad view - suspect a broken limiter");
                c = a(c, 1e-9, Infinity), this._x = h, this._y = u, this._zoom = c, this._mediaAspectRatio = p, this._width = d, this._height = f, h === e && u === i && c === r && p === n && d === o && f === l || (this._projectionChanged = !0, this.emit("change")), d === o && f === l || this.emit("resize")
            }, r.prototype._zoomX = function () {
                return this._zoom
            }, r.prototype._zoomY = function () {
                var t = this._mediaAspectRatio,
                    e = this._width / this._height,
                    i = this._zoom,
                    r = i * t / e;
                return isNaN(r) && (r = i), r
            }, r.prototype.updateWithControlParameters = function (t) {
                var e = this.zoom(),
                    i = this._zoomX(),
                    r = this._zoomY();
                this.offsetX(t.axisScaledX * i + t.x * e), this.offsetY(t.axisScaledY * r + t.y * e), this.offsetZoom(t.zoom * e)
            }, r.prototype.projection = function () {
                var t = this._projectionMatrix;
                if (this._projectionChanged) {
                    var e = this._x,
                        i = this._y,
                        r = this._zoomX(),
                        n = this._zoomY(),
                        o = this._viewFrustum,
                        s = o[0] = .5 - i + .5 * n,
                        a = o[1] = e - .5 + .5 * r,
                        h = o[2] = .5 - i - .5 * n,
                        u = o[3] = e - .5 - .5 * r;
                    l.ortho(t, u, a, h, s, -1, 1), this._projectionChanged = !1
                }
                return t
            }, r.prototype.intersects = function (t) {
                var e = this._viewFrustum;
                this.projection();
                for (var i = 0; i < e.length; i++) {
                    for (var r = e[i], n = m[i], o = v[i], s = !1, a = 0; a < t.length; a++) {
                        var l = t[a];
                        if (o < 0 && l[n] < r || o > 0 && l[n] > r) {
                            s = !0;
                            break
                        }
                    }
                    if (!s) return !1
                }
                return !0
            }, r.prototype.selectLevel = function (t) {
                for (var e = o() * this.width(), i = this._zoom, r = 0; r < t.length; r++) {
                    var n = t[r];
                    if (i * n.width() >= e) return n
                }
                return t[t.length - 1]
            }, r.prototype.coordinatesToScreen = function (t, e) {
                var i = this._vertex;
                e || (e = {});
                var r = this._width,
                    n = this._height;
                if (r <= 0 || n <= 0) return e.x = null, e.y = null, null;
                var o = t && null != t.x ? t.x : p,
                    s = t && null != t.y ? t.y : d;
                h.set(i, o - .5, .5 - s, -1, 1), h.transformMat4(i, i, this.projection());
                for (var a = 0; a < 3; a++) i[a] /= i[3];
                return e.x = r * (i[0] + 1) / 2, e.y = n * (1 - i[1]) / 2, e
            }, r.prototype.screenToCoordinates = function (t, e) {
                var i = this._vertex,
                    r = this._invProj;
                e || (e = {});
                var n = this._width,
                    o = this._height;
                l.invert(r, this.projection());
                var s = 2 * t.x / n - 1,
                    a = 1 - 2 * t.y / o;
                return h.set(i, s, a, 1, 1), h.transformMat4(i, i, r), e.x = .5 + i[0], e.y = .5 - i[1], e
            }, r.limit = {
                x: function (t, e) {
                    return function (i) {
                        return i.x = a(i.x, t, e), i
                    }
                },
                y: function (t, e) {
                    return function (i) {
                        return i.y = a(i.y, t, e), i
                    }
                },
                zoom: function (t, e) {
                    return function (i) {
                        return i.zoom = a(i.zoom, t, e), i
                    }
                },
                resolution: function (t) {
                    return function (e) {
                        if (e.width <= 0 || e.height <= 0) return e;
                        var i = e.width,
                            r = o() * i / t;
                        return e.zoom = a(e.zoom, r, Infinity), e
                    }
                },
                visibleX: function (t, e) {
                    return function (i) {
                        var r = e - t;
                        i.zoom > r && (i.zoom = r);
                        var n = t + .5 * i.zoom,
                            o = e - .5 * i.zoom;
                        return i.x = a(i.x, n, o), i
                    }
                },
                visibleY: function (t, e) {
                    return function (i) {
                        if (i.width <= 0 || i.height <= 0) return i;
                        var r = i.width / i.height,
                            n = r / i.mediaAspectRatio,
                            o = (e - t) * n;
                        i.zoom > o && (i.zoom = o);
                        var s = t + .5 * i.zoom / n,
                            l = e - .5 * i.zoom / n;
                        return i.y = a(i.y, s, l), i
                    }
                },
                letterbox: function () {
                    return function (t) {
                        if (t.width <= 0 || t.height <= 0) return t;
                        var e = t.width / t.height,
                            i = e / t.mediaAspectRatio;
                        t.mediaAspectRatio >= e && (t.zoom = Math.min(t.zoom, 1)), t.mediaAspectRatio <= e && (t.zoom = Math.min(t.zoom, i));
                        var r, n;
                        t.zoom > 1 ? r = n = .5 : (r = 0 + .5 * t.zoom / 1, n = 1 - .5 * t.zoom / 1);
                        var o, s;
                        return t.zoom > i ? o = s = .5 : (o = 0 + .5 * t.zoom / i, s = 1 - .5 * t.zoom / i), t.x = a(t.x, r, n), t.y = a(t.y, o, s), t
                    }
                }
            }, r.type = r.prototype.type = "flat", e.exports = r
        }, {
            "../util/clamp": 91,
            "../util/pixelRatio": 109,
            "../util/real": 111,
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec4": 11,
            "minimal-event-emitter": 13
        }],
        117: [function (t, e, i) {
            "use strict";

            function r(t, e) {
                this._yaw = t && null != t.yaw ? t.yaw : _, this._pitch = t && null != t.pitch ? t.pitch : y, this._roll = t && null != t.roll ? t.roll : g, this._fov = t && null != t.fov ? t.fov : x, this._width = t && null != t.width ? t.width : m, this._height = t && null != t.height ? t.height : v, this._projectionCenterX = t && null != t.projectionCenterX ? t.projectionCenterX : M, this._projectionCenterY = t && null != t.projectionCenterY ? t.projectionCenterY : w, this._limiter = e || null, this._projectionMatrix = d.create(), this._projectionChanged = !0, this._viewFrustum = [f.create(), f.create(), f.create(), f.create(), f.create()], this._params = {}, this._fovs = {}, this._vertex = f.create(), this._invProj = d.create(), this._update()
            }
            var n = t("minimal-event-emitter"),
                o = t("../util/pixelRatio"),
                s = t("../util/convertFov"),
                a = t("../util/rotateVector"),
                l = t("../util/mod"),
                h = t("../util/real"),
                u = t("../util/clamp"),
                c = t("../util/decimal"),
                p = t("../util/compose"),
                d = t("gl-matrix/src/gl-matrix/mat4"),
                f = t("gl-matrix/src/gl-matrix/vec4"),
                m = 0,
                v = 0,
                _ = 0,
                y = 0,
                g = 0,
                x = Math.PI / 4,
                M = 0,
                w = 0;
            n(r), r.prototype.destroy = function () {
                this._yaw = null, this._pitch = null, this._roll = null, this._fov = null, this._width = null, this._height = null, this._limiter = null, this._projectionChanged = null, this._projectionMatrix = null, this._viewFrustum = null, this._params = null, this._vertex = null, this._invProj = null
            }, r.prototype.yaw = function () {
                return this._yaw
            }, r.prototype.pitch = function () {
                return this._pitch
            }, r.prototype.roll = function () {
                return this._roll
            }, r.prototype.projectionCenterX = function () {
                return this._projectionCenterX
            }, r.prototype.projectionCenterY = function () {
                return this._projectionCenterY
            }, r.prototype.fov = function () {
                return this._fov
            }, r.prototype.width = function () {
                return this._width
            }, r.prototype.height = function () {
                return this._height
            }, r.prototype.size = function (t) {
                return t || (t = {}), t.width = this._width, t.height = this._height, t
            }, r.prototype.parameters = function (t) {
                return t || (t = {}), t.yaw = this._yaw, t.pitch = this._pitch, t.roll = this._roll, t.fov = this._fov, t
            }, r.prototype.limiter = function () {
                return this._limiter
            }, r.prototype.setYaw = function (t) {
                this._resetParams(), this._params.yaw = t, this._update(this._params)
            }, r.prototype.setPitch = function (t) {
                this._resetParams(), this._params.pitch = t, this._update(this._params)
            }, r.prototype.setRoll = function (t) {
                this._resetParams(), this._params.roll = t, this._update(this._params)
            }, r.prototype.setFov = function (t) {
                this._resetParams(), this._params.fov = t, this._update(this._params)
            }, r.prototype.setProjectionCenterX = function (t) {
                this._resetParams(), this._params.projectionCenterX = t, this._update(this._params)
            }, r.prototype.setProjectionCenterY = function (t) {
                this._resetParams(), this._params.projectionCenterY = t, this._update(this._params)
            }, r.prototype.offsetYaw = function (t) {
                this.setYaw(this._yaw + t)
            }, r.prototype.offsetPitch = function (t) {
                this.setPitch(this._pitch + t)
            }, r.prototype.offsetRoll = function (t) {
                this.setRoll(this._roll + t)
            }, r.prototype.offsetFov = function (t) {
                this.setFov(this._fov + t)
            }, r.prototype.setSize = function (t) {
                this._resetParams(), this._params.width = t.width, this._params.height = t.height, this._update(this._params)
            }, r.prototype.setParameters = function (t) {
                this._resetParams();
                var e = this._params;
                e.yaw = t.yaw, e.pitch = t.pitch, e.roll = t.roll, e.fov = t.fov, e.projectionCenterX = t.projectionCenterX, e.projectionCenterY = t.projectionCenterY, this._update(e)
            }, r.prototype.setLimiter = function (t) {
                this._limiter = t || null, this._update()
            }, r.prototype._resetParams = function () {
                var t = this._params;
                t.yaw = null, t.pitch = null, t.roll = null, t.fov = null, t.width = null, t.height = null
            }, r.prototype._update = function (t) {
                null == t && (this._resetParams(), t = this._params);
                var e = this._yaw,
                    i = this._pitch,
                    r = this._roll,
                    n = this._fov,
                    o = this._projectionCenterX,
                    s = this._projectionCenterY,
                    a = this._width,
                    l = this._height;
                if (t.yaw = null != t.yaw ? t.yaw : e, t.pitch = null != t.pitch ? t.pitch : i, t.roll = null != t.roll ? t.roll : r, t.fov = null != t.fov ? t.fov : n, t.width = null != t.width ? t.width : a, t.height = null != t.height ? t.height : l, t.projectionCenterX = null != t.projectionCenterX ? t.projectionCenterX : o, t.projectionCenterY = null != t.projectionCenterY ? t.projectionCenterY : s, this._limiter && !(t = this._limiter(t))) throw new Error("Bad view limiter");
                t = this._normalize(t);
                var u = t.yaw,
                    c = t.pitch,
                    p = t.roll,
                    d = t.fov,
                    f = t.width,
                    m = t.height,
                    v = t.projectionCenterX,
                    _ = t.projectionCenterY;
                if (!(h(u) && h(c) && h(p) && h(d) && h(f) && h(m) && h(v) && h(_))) throw new Error("Bad view - suspect a broken limiter");
                this._yaw = u, this._pitch = c, this._roll = p, this._fov = d, this._width = f, this._height = m, this._projectionCenterX = v, this._projectionCenterY = _, u === e && c === i && p === r && d === n && f === a && m === l && v === o && _ === s || (this._projectionChanged = !0, this.emit("change")), f === a && m === l || this.emit("resize")
            }, r.prototype._normalize = function (t) {
                this._normalizeCoordinates(t);
                var e = s.htov(Math.PI, t.width, t.height),
                    i = isNaN(e) ? Math.PI : Math.min(Math.PI, e);
                return t.fov = u(t.fov, 1e-6, i - 1e-6), t
            }, r.prototype._normalizeCoordinates = function (t) {
                return "yaw" in t && (t.yaw = l(t.yaw - Math.PI, -2 * Math.PI) + Math.PI), "pitch" in t && (t.pitch = l(t.pitch - Math.PI, -2 * Math.PI) + Math.PI), "roll" in t && (t.roll = l(t.roll - Math.PI, -2 * Math.PI) + Math.PI), t
            }, r.prototype.normalizeToClosest = function (t, e) {
                var i = this._yaw,
                    r = this._pitch,
                    n = t.yaw,
                    o = t.pitch,
                    s = n - 2 * Math.PI,
                    a = n + 2 * Math.PI;
                Math.abs(s - i) < Math.abs(n - i) ? n = s : Math.abs(a - i) < Math.abs(n - i) && (n = a);
                var l = o - 2 * Math.PI,
                    h = o + 2 * Math.PI;
                return Math.abs(l - r) < Math.abs(o - r) ? o = l : Math.abs(l - r) < Math.abs(o - r) && (o = h), e = e || {}, e.yaw = n, e.pitch = o, e
            }, r.prototype.updateWithControlParameters = function (t) {
                var e = this._fov,
                    i = s.vtoh(e, this._width, this._height);
                isNaN(i) && (i = e), this.offsetYaw(t.axisScaledX * i + 2 * t.x * i + t.yaw), this.offsetPitch(t.axisScaledY * e + 2 * t.y * i + t.pitch), this.offsetRoll(-t.roll), this.offsetFov(t.zoom * e)
            }, r.prototype.projection = function () {
                var t = this._projectionMatrix,
                    e = this._viewFrustum;
                if (this._projectionChanged) {
                    var i = this._width,
                        r = this._height,
                        n = this._fov,
                        o = s.vtoh(n, i, r),
                        a = i / r,
                        l = this._projectionCenterX,
                        h = this._projectionCenterY;
                    if (0 !== l || 0 !== h) {
                        var u = Math.atan(2 * l * Math.tan(o / 2)),
                            c = Math.atan(2 * h * Math.tan(n / 2)),
                            p = this._fovs;
                        p.leftDegrees = 180 * (o / 2 + u) / Math.PI, p.rightDegrees = 180 * (o / 2 - u) / Math.PI, p.upDegrees = 180 * (n / 2 + c) / Math.PI, p.downDegrees = 180 * (n / 2 - c) / Math.PI, d.perspectiveFromFieldOfView(t, p, -1, 1)
                    } else d.perspective(t, n, a, -1, 1);
                    d.rotateZ(t, t, this._roll), d.rotateX(t, t, this._pitch), d.rotateY(t, t, this._yaw), f.set(e[0], t[3] + t[0], t[7] + t[4], t[11] + t[8], 0), f.set(e[1], t[3] - t[0], t[7] - t[4], t[11] - t[8], 0), f.set(e[2], t[3] + t[1], t[7] + t[5], t[11] + t[9], 0), f.set(e[3], t[3] - t[1], t[7] - t[5], t[11] - t[9], 0), f.set(e[4], t[3] + t[2], t[7] + t[6], t[11] + t[10], 0), this._projectionChanged = !1
                }
                return t
            }, r.prototype.intersects = function (t) {
                var e = this._viewFrustum,
                    i = this._vertex;
                this.projection();
                for (var r = 0; r < e.length; r++) {
                    for (var n = e[r], o = !1, s = 0; s < t.length; s++) {
                        var a = t[s];
                        f.set(i, a[0], a[1], a[2], 0), f.dot(n, i) >= 0 && (o = !0)
                    }
                    if (!o) return !1
                }
                return !0
            }, r.prototype.selectLevel = function (t) {
                for (var e = o() * this._height, i = Math.tan(.5 * this._fov), r = 0; r < t.length; r++) {
                    var n = t[r];
                    if (i * n.height() >= e) return n
                }
                return t[t.length - 1]
            }, r.prototype.coordinatesToScreen = function (t, e) {
                var i = this._vertex;
                e || (e = {});
                var r = this._width,
                    n = this._height;
                if (r <= 0 || n <= 0) return e.x = null, e.y = null, null;
                var o = t && null != t.yaw ? t.yaw : _,
                    s = t && null != t.pitch ? t.pitch : y,
                    l = t && null != t.roll ? t.roll : g;
                return f.set(i, 0, 0, -1, 1), a(i, i, -o, -s, -l), f.transformMat4(i, i, this.projection()), i[3] >= 0 ? (e.x = r * (i[0] / i[3] + 1) / 2, e.y = n * (1 - i[1] / i[3]) / 2, e) : (e.x = null, e.y = null, null)
            }, r.prototype.screenToCoordinates = function (t, e) {
                var i = this._vertex,
                    r = this._invProj;
                e || (e = {});
                var n = this._width,
                    o = this._height;
                d.invert(r, this.projection());
                var s = 2 * t.x / n - 1,
                    a = 1 - 2 * t.y / o;
                f.set(i, s, a, 1, 1), f.transformMat4(i, i, r);
                var l = Math.sqrt(i[0] * i[0] + i[1] * i[1] + i[2] * i[2]);
                return e.yaw = Math.atan2(i[0], -i[2]), e.pitch = Math.acos(i[1] / l) - Math.PI / 2, this._normalizeCoordinates(e), e
            }, r.prototype.coordinatesToPerspectiveTransform = function (t, e, i) {
                i = i || "";
                var r = this._height,
                    n = this._width,
                    o = this._fov,
                    s = .5 * r / Math.tan(o / 2),
                    a = "";
                return a += "translateX(" + c(n / 2) + "px) translateY(" + c(r / 2) + "px) ", a += "translateX(-50%) translateY(-50%) ", a += "perspective(" + c(s) + "px) ", a += "translateZ(" + c(s) + "px) ", a += "rotateZ(" + c(-this._roll) + "rad) ", a += "rotateX(" + c(-this._pitch) + "rad) ", a += "rotateY(" + c(this._yaw) + "rad) ", a += "rotateY(" + c(-t.yaw) + "rad) ", a += "rotateX(" + c(t.pitch) + "rad) ", a += "translateZ(" + c(-e) + "px) ", a += i + " "
            }, r.limit = {
                yaw: function (t, e) {
                    return function (i) {
                        return i.yaw = u(i.yaw, t, e), i
                    }
                },
                pitch: function (t, e) {
                    return function (i) {
                        return i.pitch = u(i.pitch, t, e), i
                    }
                },
                roll: function (t, e) {
                    return function (i) {
                        return i.roll = u(i.roll, t, e), i
                    }
                },
                hfov: function (t, e) {
                    return function (i) {
                        var r = i.width,
                            n = i.height;
                        if (r > 0 && n > 0) {
                            var o = s.htov(t, r, n),
                                a = s.htov(e, r, n);
                            i.fov = u(i.fov, o, a)
                        }
                        return i
                    }
                },
                vfov: function (t, e) {
                    return function (i) {
                        return i.fov = u(i.fov, t, e), i
                    }
                },
                resolution: function (t) {
                    return function (e) {
                        var i = e.height;
                        if (i) {
                            var r = o() * i,
                                n = 2 * Math.atan(r / t);
                            e.fov = u(e.fov, n, Infinity)
                        }
                        return e
                    }
                },
                traditional: function (t, e, i) {
                    return i = null != i ? i : e, p(r.limit.resolution(t), r.limit.vfov(0, e), r.limit.hfov(0, i), r.limit.pitch(-Math.PI / 2, Math.PI / 2))
                }
            }, r.type = r.prototype.type = "rectilinear", e.exports = r
        }, {
            "../util/clamp": 91,
            "../util/compose": 94,
            "../util/convertFov": 95,
            "../util/decimal": 96,
            "../util/mod": 106,
            "../util/pixelRatio": 109,
            "../util/real": 111,
            "../util/rotateVector": 113,
            "gl-matrix/src/gl-matrix/mat4": 7,
            "gl-matrix/src/gl-matrix/vec4": 11,
            "minimal-event-emitter": 13
        }]
    }, {}, [57])(57)
});